export const projects=[
  {
    ProjectUID: "c495c538-3974-eb11-8af0-005056921d78",
    ProjectName: "حصر وتقييم الأصول الثابتة",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-20-001",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectDescription:
      "دراسة وتحديد طريقة حصر وقياس أصول البنك بحيث يتم اثباتها وفق معايير المحاسبة الدولية للقطاع العام ودليل السياسات والإجراءات المحاسبية والممارسات الرائدة والقيام بعملية الحصر والتقييم اللازمة لإعداد المركز المالي والقوائم المالية الافتتاحية على أساس الاستحقاق وفق معايير المحاسبة الدولية للقطاع العام",
    ProjectStartDate: "2020-07-09T00:00:00",
    ProjectFinishDate: "2021-06-01T00:00:00",
    BIProjectStartDate: "2020-09-07T08:00:00",
    BIProjectFinishDate: "2021-01-06T17:00:00",
    PlannedCompletePercent: "100",
    ActualCompletePercent: 100,
    BudgetItemNo: "2301822",
    BudgetItemName: "الخدمات الاستشارية",
    EstimatedBudget: "2500000.000000",
    ApprovedBudget: "1200000.000000",
    ContractValue: "1341776.300000",
    RevisedContractValue: "1475953.930000",
    PaidAmount: "1475953.93",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة برايس وترهاوس كوبرز للاستشارات المحدودة",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع المالية",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تحقيق الاستدامة المالية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "ماجد محمد الدخيل Maged M. Aldakheel",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الانتهاء من المشروع وصرف المستحقات علماً بان حالة الصرف تعكس طلب التغيير المالي بزيادة قدرها 10%",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ebba6e15-3b74-eb11-8af0-005056921d78",
    ProjectName: "مشروع تنفيذ حملات تسويقية للبنك ومنتجاته",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-012",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "خالد راشد الثويني Khaled R Althowaini",
    ProjectDescription:
      "يهدف هذا المشروع لتطوير الاستراتيجية الاتصالية والتسويقية لبنك التنمية الاجتماعية وبناء منتجات تسويقية وإعلامية تخدم التوجهات الإعلامية والتسويقية لمنتجات وخدمات ومبادرات البنك إضافة إلى العمل على التحرير والنشر الصحفي في وسائل الإعلام.",
    ProjectStartDate: "2021-08-01T00:00:00",
    ProjectFinishDate: "2022-08-01T00:00:00",
    BIProjectStartDate: "2021-08-01T08:00:00",
    BIProjectFinishDate: "2022-08-01T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الاعلامية",
    EstimatedBudget: "2600000.000000",
    ApprovedBudget: "2424200.000000",
    ContractValue: "2424200.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "2424200.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة فكرة مضيئة ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: "دانيا عثمان المنيع Dania O. Almanea",
    sector_efada: "تم الانتهاء من الاعمال وجاري رفع الفاتورة ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2424200.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "83f8ec0e-7674-eb11-8af0-005056921d78",
    ProjectName: "ابتكار وصناعة الأدوات التسويقية لمنتجات التمويل الاجتماعي",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-011",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "منيره حمد بن عبيد Munirah H. Bin obaid",
    ProjectDescription:
      "حملات تسويقية و توعوية لمنتجات الاسر المنتجة كجزء من اختصاص البنك كمظلة للاسر المنتجة",
    ProjectStartDate: "2021-06-21T00:00:00",
    ProjectFinishDate: "2022-12-06T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "271",
    BudgetItemName: "الأسر المنتجة",
    EstimatedBudget: "8000000.000000",
    ApprovedBudget: "6116390.000000",
    ContractValue: "6116390.000000",
    RevisedContractValue: "6116390.000000",
    PaidAmount: "6116390.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "وكالة مروان لدعاية والإعلان والعلاقات العامة للتسويق",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "خالد راشد الثويني Khaled R Althowaini",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: "دانيا عثمان المنيع Dania O. Almanea",
    sector_efada: "تم رفع المتطلبات المالية وأغلاق المشروع ",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "2727182.00",
    SpentYearBudget: "2727182.000000",
  },
  {
    ProjectUID: "76f78015-8274-eb11-8af0-005056921d78",
    ProjectName:
      "تقديم الخدمات الاستشارية لتنفيذ أعمال المراجعة الداخلية على إدارة تقنية المعلومات",
    Department: "إدارة المراجعة التشغيلية وتقنية المعلومات",
    ProjectCode: "IN-21-001",
    ProjectOwner: "محمد قعدان مرزوق العتيبي Mohammed G Alotaibi",
    boardinitiative: "لا",
    ProjectManager: "محمد فهد سليمان الرضيان Mohammed F. Alrodyan",
    ProjectDescription:
      "الاستعانة بشركة استشارية متخصصة لتنفيذ أعمال المراجعة على الإدارة العامة لتقنية المعلومات",
    ProjectStartDate: "2021-09-08T00:00:00",
    ProjectFinishDate: "2021-12-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "2310",
    BudgetItemName: "الخدمات الاستشارية",
    EstimatedBudget: "400000.000000",
    ApprovedBudget: "400000.000000",
    ContractValue: "400000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "400000.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة بروتيفيتي ممبر فيرم السعودية للاستشارات الادارية",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع المراجعة الداخلية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المراجعة الداخلية",
    ProgramManager: " ",
    ProjectOwner1: "محمد قعدان مرزوق العتيبي Mohammed G Alotaibi",
    ProjectOfficerContact: " ",
    sector_efada: "تم اكتمال المشروع وتسليم المخرجات والتوجيه بصرف المستحقات",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "359999.55",
    SpentYearBudget: "359999.550000",
  },
  {
    ProjectUID: "07e4f787-8974-eb11-8af0-005056921d78",
    ProjectName: "تنفيذ الاعمال الهندسية المطلوبة لتشغيل جادة 30 - بريدة",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-20-015",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: "غير موجودة بياناتها في قائمة التمويل الاجتماعي",
    ProjectStartDate: "2020-11-15T00:00:00",
    ProjectFinishDate: "2021-01-10T00:00:00",
    BIProjectStartDate: "2020-11-15T08:00:00",
    BIProjectFinishDate: "2021-01-10T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "s",
    EstimatedBudget: "3933890.000000",
    ApprovedBudget: "3933890.000000",
    ContractValue: "3933890.000000",
    RevisedContractValue: "4326654.000000",
    PaidAmount: "3211378.16",
    RemainingAmount: "1115276.490000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "شركة الراجحي للبناء والتعمير",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "غدير الحارثي Gadeer Alharthi",
    sector_efada:
      "الجادة في مرحلة التشغيل وجاري صرف المستخلص الختامي وحجز 10% من قيمة العقد حتى الاستلام النهائي للأعمال",
    pmo_efada:
      "في انتظار الإفادة بالمنافع المكتسبة حالياُ مثل الإيرادات الايجارية",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "93c4effd-8974-eb11-8af0-005056921d78",
    ProjectName:
      "توريد اثاث لفروع بنك التنمية الاجتماعية في ( خميس مشيط-الدمام-تبوك) جادة 30",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-012",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      "تغيير عدد 21 فرع و تضمين عدد من الفروع لمبادرة جادة 30 وهي كالتالي ( حائل - جدة - الجوف - جازان - ينبع - المدينة المنورة - نجران - عرعر -القنفذه- حفر الباطن - بيشه - القريات - النماص - مكة المكرمة - الطائف - المجمعة - الخرج - الرس - الباحة - الدوادمي - وادي الدواسر )",
    ProjectStartDate: "2021-07-31T00:00:00",
    ProjectFinishDate: "2022-02-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "محذوف من قائمة الخدمات الأخيرة",
    EstimatedBudget: "3500000.000000",
    ApprovedBudget: "3500000.000000",
    ContractValue: "1830898.000000",
    RevisedContractValue: "1860586.000000",
    PaidAmount: "0.00",
    RemainingAmount: "1860586.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "مؤسسة النقاء العربي للتجارة",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "غدير الحارثي Gadeer Alharthi",
    sector_efada:
      "تم توريد وتركيب الاثاث لفروع خميس مشيط، تبوك والدمام، وجاري صرف مستحقات المتعاقد",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "1860586.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "bbd591b0-c674-eb11-8af0-005056921d78",
    ProjectName:
      "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-20-018",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "فهد علي عبدالله العواد Fahad A. Alawad",
    ProjectDescription:
      "رفع الحوكمة والقدرات للجهات الشريكة في تقديم الإقراض للأسر المنتجة",
    ProjectStartDate: "2020-12-24T00:00:00",
    ProjectFinishDate: "2021-06-24T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "25125",
    BudgetItemName: "الاسر المنتجة",
    EstimatedBudget: "2300000.000000",
    ApprovedBudget: "3000000.000000",
    ContractValue: "3000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "3000000.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة برايس واتر هاوس",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "نهى ناصر بن جريد Noha N. Binjuraid",
    sector_efada: "تم الانتهاء من تسليم المخرجات",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "87fcd659-c974-eb11-8af0-005056921d78",
    ProjectName:
      "تقديم خدمات استشارية في تطوير وتقييم نماذج الأعمال والعمليات والتحليل وبناء الأسس اللازم لتكاملها مع الأنظمة التقنية",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-20-011",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectDescription: null,
    ProjectStartDate: "2020-10-27T00:00:00",
    ProjectFinishDate: "2021-10-27T00:00:00",
    BIProjectStartDate: "2020-02-02T08:00:00",
    BIProjectFinishDate: "2021-10-27T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "25322",
    BudgetItemName: "الامتياز التجاري",
    EstimatedBudget: "914000.000000",
    ApprovedBudget: "914000.000000",
    ContractValue: "914000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "914000.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة أم القرى",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "عهود خالد الربيعة Ahood K ALrabiah",
    ProjectOwner1: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectOfficerContact: " ",
    sector_efada: "تم الانتهاء من تسليم المخرجات",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "0f9f9ad6-c974-eb11-8af0-005056921d78",
    ProjectName: "تقديم خدمات استشارية وتطوير الاعمال",
    Department: "مكتب إدارة مشاريع الأعمال",
    ProjectCode: "BU-20-004",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عهود خالد الربيعة Ahood K ALrabiah",
    ProjectDescription: null,
    ProjectStartDate: "2020-04-23T00:00:00",
    ProjectFinishDate: "2021-04-22T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "2301814",
    BudgetItemName: "الخدمات الاستشارية",
    EstimatedBudget: "1500000.000000",
    ApprovedBudget: "1496243.000000",
    ContractValue: "1496243.700000",
    RevisedContractValue: "0.000000",
    PaidAmount: "1496243.70",
    RemainingAmount: "253705.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة المجمعة",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectOfficerContact: "عهود خالد الربيعة Ahood K ALrabiah",
    sector_efada: "تم الانتهاء من تسليم المخرجات واغلاق المشروع",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "4b70164d-ca74-eb11-8af0-005056921d78",
    ProjectName:
      "زيادة نطاق عمل - تقديم الخدمات الاستشارية لتقييم وتحليل عمليات الإقراض والتحصيل",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-20-002",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectDescription: null,
    ProjectStartDate: "2020-02-21T00:00:00",
    ProjectFinishDate: "2020-04-21T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "2301817",
    BudgetItemName:
      "زيادة نطاق لمشروع تقديم الخدمات الاستشارية لتقييم وتحليل جميع عمليات الإقراض والتحصيل بالبنك",
    EstimatedBudget: "2714250.000000",
    ApprovedBudget: "246750.000000",
    ContractValue: "246750.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "246750.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة كي بي إم جي الفوزان وشركاه محاسبون ومراجعون قانونيون",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "سعيد صالح عبدالله الزهراني saeed s. alzahrani",
    ProjectOfficerContact: " ",
    sector_efada: "تم إغلاق المشروع وصرف كامل مستحقاته.",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6fb4fc1e-f574-eb11-8af1-005056921d78",
    ProjectName:
      "اعداد حقيبة تدريبية للطفل ومجموعة قصصية مختصة بالادخار والثقافة المالية",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-19-003",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خواطر احمد عبدالله الخويطر Khawater A Alkhowaiter",
    ProjectDescription: null,
    ProjectStartDate: "2019-12-10T00:00:00",
    ProjectFinishDate: "2020-12-10T00:00:00",
    BIProjectStartDate: "2019-12-10T08:00:00",
    BIProjectFinishDate: "2020-12-10T17:00:00",
    PlannedCompletePercent: "0",
    ActualCompletePercent: 100,
    BudgetItemNo: "232014",
    BudgetItemName: "تصميم برامج التوفير والادخار",
    EstimatedBudget: "588215.000000",
    ApprovedBudget: "588215.000000",
    ContractValue: "588215.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "588215.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة المجمعة",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "87b3ddbd-fd74-eb11-8af1-005056921d78",
    ProjectName: "تصميم وتنفيذ ركن توعوي للطفل",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-20-005",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خواطر احمد عبدالله الخويطر Khawater A Alkhowaiter",
    ProjectDescription:
      "إيجاد برنامج يعزز الوعي المالي وثقافة الادخار لدى الأطفال ويتيح لهم التعامل بشكل حقيقي مع حسابهم الادخاري من خلال استخدام أفضل الممارسات التقنية وبرقابة من الآباء وباستهداف شريحة الأطفال من عمر 6- 18 سنة",
    ProjectStartDate: "2020-06-28T00:00:00",
    ProjectFinishDate: "2022-02-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "232021",
    BudgetItemName: "تصميم برامج التوفير والادخار",
    EstimatedBudget: "1750000.000000",
    ApprovedBudget: "17100000.000000",
    ContractValue: "1795500.000000",
    RevisedContractValue: "1974900.000000",
    PaidAmount: "1974900.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "مكتب وسم الاستدامة للخدمات التجارية",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: " ",
    sector_efada: "تم الانتهاء من تسليم المخرجات",
    pmo_efada:
      "تم اضافة طلب تغيير تمديد في المدة والتكاليف والكميات بنسبة 10 % من الميزانية المعتمدة",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "287b41e3-0175-eb11-8af1-005056921d78",
    ProjectName: "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-20-012",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription:
      "يهدف هذا البرنامج إلى تحقيق أهداف القطاع الاستراتيجية وذلك من خلال انشاء انظمة تشغيلية متكاملة لتصميم وتطوير وتنفيذ عمليات وإجراءات إدارة التمويل للمنشآت الصغيرة والناشئة ويكون الحل المقدم قابل لأتمتة مستقبلا",
    ProjectStartDate: "2020-10-29T00:00:00",
    ProjectFinishDate: "2021-10-29T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "25322",
    BudgetItemName:
      "دراسات استشارية لتنمية قطاع المنشآت الصغيرة والناشئة والتمويل الأصغر2020",
    EstimatedBudget: "7212269.800000",
    ApprovedBudget: "7212269.800000",
    ContractValue: "7021269.800000",
    RevisedContractValue: "7722275.300000",
    PaidAmount: "7722275.3",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "شركة ديلويت اند توش الشرق الاوسط المحدودة",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 6426,
    ActualResourceHours: 6426,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عزت فيصل العنقري Ezzat F AlAngari",
    sector_efada:
      "المشروع بمرحلة الاغلاق وجاري العمل على انهاء إجراءات صرف مستحقات الشركة عدد 3 فواتير ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "1227338.650000",
  },
  {
    ProjectUID: "94bf2681-9069-43d1-a6bf-25894ca82a37",
    ProjectName:
      "تمويــل أول عميــل مــن خــلال منصــة ( ptway ) منتج نفاذ White Labelling",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-21-001",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: null,
    ProjectManager: "عبدالله احمد العودان Abdullah A Alodan",
    ProjectDescription:
      "تمويــل أول عميــل مــن خــلال منصــة (twayمنتج نفاذ White Labelling)",
    ProjectStartDate: "2021-01-18T00:00:00",
    ProjectFinishDate: "2021-08-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: null,
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "100",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: null,
    NotAligned: null,
    AlignedComments: null,
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "وليد سليمان النزهه Waleed S. Alnozha",
    ProjectOwner1: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectOfficerContact: "تركي عبدالمحسن المنيف Turki A Almunaif",
    sector_efada:
      "يوجد 190 طلب من خلال المنصة هذا الأسبوع. تمويل 6 طلبات بقيمة 286 الف",
    pmo_efada: null,
    cat_efada: "التكامل التقني",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "3e9243b1-0491-4b77-8e8d-268e452d661b",
    ProjectName: "مقر البنك الجديد",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-20-004",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "نوره احمد علي الشهري Norah A. Alshahri",
    ProjectDescription: "مقر البنك الجديد",
    ProjectStartDate: "2020-02-04T00:00:00",
    ProjectFinishDate: "2022-02-28T00:00:00",
    BIProjectStartDate: "2020-02-04T08:00:00",
    BIProjectFinishDate: "2021-09-28T17:00:00",
    PlannedCompletePercent: "0",
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "174799045.000000",
    ApprovedBudget: "174799045.000000",
    ContractValue: "174799045.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "121799045.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "عبد العزيز سعد الرصيص",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "تم تنفيذ المشروع وجاري استكمال اجراءات الصرف ",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "b4375743-5d39-43b7-92fb-2d7c64d51d60",
    ProjectName: "توريد وشراء سيارات البنك",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-052",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "توريد وشراء سيارات البنك ",
    ProjectStartDate: "2021-12-30T00:00:00",
    ProjectFinishDate: "2022-02-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: "0.000000",
    ApprovedBudget: "1340000.000000",
    ContractValue: "1340000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "1340000.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "الملحم وتوكيلات الجزيرة",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "عبدالرحمن صالح الحسن Abdulrhman Al-Hassan",
    sector_efada: "تم صرف المستخلص الختامي ",
    pmo_efada: "لا يوجد تفاصيل للمشروع",
    cat_efada: null,
    YearBudget: "1340000.00",
    SpentYearBudget: "1340000.000000",
  },
  {
    ProjectUID: "d542271c-fedb-492c-899b-4463949f6744",
    ProjectName: "تجديد اتفاقية الرخص المؤسسية لمنتجات مايكروسوفت - Ms project",
    Department: "مكتب إدارة المشاريع المؤسسي",
    ProjectCode: "ST-22-026",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "سعد محمد بخيت الدوسري Saad M Aldosari",
    ProjectDescription:
      "تجديد اتفاقية الرخص المؤسسية لمنتجات مايكروسوفت - Ms project",
    ProjectStartDate: "2022-04-17T00:00:00",
    ProjectFinishDate: "2022-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "433613.250000",
    ContractValue: "433613.250000",
    RevisedContractValue: "0.000000",
    PaidAmount: "433613.25",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 336,
    ActualResourceHours: 336,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "عبدالله عبدالعزيز الناصر Abdullah A. Alnasser",
    ProjectOfficerContact: " ",
    sector_efada: "تم توفير وتركيب الرخص ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "433613.25",
    SpentYearBudget: "433613.250000",
  },
  {
    ProjectUID: "80905885-c634-4330-b0f0-46ebaa2fc134",
    ProjectName: "تعديلات على نماذج الصرف وقيود التسوية",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-22-012",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "مسفر محمد شبيب العجالين MESFER M. ALAJALIN",
    ProjectDescription: "تعديلات على نماذج الصرف وقيود التسوية",
    ProjectStartDate: "2021-12-01T00:00:00",
    ProjectFinishDate: "2022-05-01T00:00:00",
    BIProjectStartDate: "2021-12-01T08:00:00",
    BIProjectFinishDate: "2022-06-09T17:00:00",
    PlannedCompletePercent: "100",
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada: "تم إطلاق المشروع بنجاح ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "df50063e-8cfc-4816-9a9c-4d8274dd00b2",
    ProjectName:
      "تنفيذ الاعمال الهندسية لفرع بنك التنمية الاجتماعية في خميس مشيط (مشروع جادة30)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-017",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      'مدمج في النظام باسم "مشروع تأسيس4 مباني جادة30، امل اضافته كمشروع مستقل',
    ProjectStartDate: "2021-08-11T00:00:00",
    ProjectFinishDate: "2022-02-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "1800000.000000",
    ApprovedBudget: "1800000.000000",
    ContractValue: "1807512.000000",
    RevisedContractValue: "1987747.950000",
    PaidAmount: "999232.00",
    RemainingAmount: "988515.950000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "الراجحي للبناء والتعمير ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الإنتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "غدير الحارثي Gadeer Alharthi",
    sector_efada:
      "تم الانتهاء من المشروع و الافتتاح التجريبي للجادة في 21 يوليو",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "1807512.00",
    SpentYearBudget: "999232.000000",
  },
  {
    ProjectUID: "774bb06d-63fd-435c-8b27-4fa75a26cb5d",
    ProjectName: "تنفيذ حقيبة تدريبية لمحتوي الكتروني متكامل في العمل الحر",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-20-019",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالله سعيد عوض السبيعي abdullah s. alsubaie",
    ProjectDescription:
      "تنفيذ حقيبة تدريبية لمحتوي الكتروني متكامل في العمل الحر",
    ProjectStartDate: "2020-12-27T00:00:00",
    ProjectFinishDate: "2021-06-30T00:00:00",
    BIProjectStartDate: "2020-12-27T08:00:00",
    BIProjectFinishDate: "2021-06-30T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: "90000.000000",
    ApprovedBudget: "90000.000000",
    ContractValue: "90000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "90000.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة العاج الفضي",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "سعد حمد سعد بن عيد SAAD H. BINEID",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "عبدالله سعيد عوض السبيعي abdullah s. alsubaie",
    sector_efada: "تم إغلاق المشروع وصرف كامل مستحقاته.",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "4d242970-f940-4c75-9e4d-647ab7ad66d3",
    ProjectName: "خدمة VPN لدعم العمل عن بعد",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-032",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "فهد إبراهيم المناع fahad i. almnaa",
    ProjectDescription: "خدمة VPN لدعم العمل عن بعد",
    ProjectStartDate: "2021-11-11T00:00:00",
    ProjectFinishDate: "2022-02-10T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "127120.000000",
    ContractValue: "127120.000000",
    RevisedContractValue: "127120.000000",
    PaidAmount: "127120.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 360,
    ActualResourceHours: 360,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "تم اغلاق المشروع و اطلاق النظام بنجاح ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "127120.00",
    SpentYearBudget: "127120.000000",
  },
  {
    ProjectUID: "f36f2086-f093-465b-abed-8535cdae4353",
    ProjectName: "توريد اثاث فرع جادة 30 ببريدة",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-20-014",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: "x",
    ProjectStartDate: "2020-11-15T00:00:00",
    ProjectFinishDate: "2021-01-10T00:00:00",
    BIProjectStartDate: "2020-11-15T08:00:00",
    BIProjectFinishDate: "2021-01-10T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "1675712.000000",
    ApprovedBudget: "1679339.250000",
    ContractValue: "1679339.000000",
    RevisedContractValue: "1675711.000000",
    PaidAmount: "1633880.39",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "مؤسسة النقاء العربي",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "وليد سليمان النزهه Waleed S. Alnozha",
    sector_efada:
      "تم صرف كامل المستحقات والجادة في مرحلة التشغيل، والمتبقي من العقد عبارة عن وفر في قيمة العقد",
    pmo_efada:
      "في انتظار الإفادة بالمنافع المكتسبة حالياُ مثل الإيرادات الايجارية",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "86332aea-29c8-46e8-9650-8f0c53ef3405",
    ProjectName: "تنفيذ برامج تدريبية لمنتجات التمويل الاجتماعي",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-20-017",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "غاده عبدالله الحربي Gadah A Alharbi",
    ProjectDescription: "تنفيذ برامج تدريبية لمنتجات التمويل الاجتماعي",
    ProjectStartDate: "2020-12-21T00:00:00",
    ProjectFinishDate: "2021-06-30T00:00:00",
    BIProjectStartDate: "2020-12-21T08:00:00",
    BIProjectFinishDate: "2021-06-30T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: "43700.000000",
    ApprovedBudget: "43700.000000",
    ContractValue: "43700.000000",
    RevisedContractValue: "28750.000000",
    PaidAmount: "28750.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "أدوات الأحتراف",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "سعد حمد سعد بن عيد SAAD H. BINEID",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "غاده عبدالله الحربي Gadah A Alharbi",
    sector_efada: "تم إغلاق المشروع وصرف كامل مستحقاته.",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "9a721bd9-b9dd-4b44-aaba-961c97944e9a",
    ProjectName:
      "تنفيذ الاعمال الهندسية لفرع بنك التنمية الاجتماعية في تبوك (مشروع جادة30)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-020",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: "تأهيل وتنفيذ جادة 30 لفرع تبوك\r\n\r\n",
    ProjectStartDate: "2021-08-29T00:00:00",
    ProjectFinishDate: "2022-02-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "1800000.000000",
    ApprovedBudget: "1800000.000000",
    ContractValue: "2546790.000000",
    RevisedContractValue: "2325550.820000",
    PaidAmount: "1195716.00",
    RemainingAmount: "1129834.820000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "الشروق الرائدة للمقاولات العامة ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الإنتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "غدير الحارثي Gadeer Alharthi",
    sector_efada:
      "تم الانتهاء من المشروع و الافتتاح التجريبي للجادة في 20 مايو ",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "2546790.00",
    SpentYearBudget: "1195716.000000",
  },
  {
    ProjectUID: "e6e103f3-4c99-ec11-8b00-98566de81707",
    ProjectName: "تنفيذ الية الرسوم السنوية للمشاريع",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-069",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription: null,
    ProjectStartDate: "2021-02-01T00:00:00",
    ProjectFinishDate: "2022-02-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 80,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "80",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "تم طلب تغيير على المتطلبات وجاري العمل علي تنفيذه",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "ABDULAZIZ SAUD ALHARBI",
    sector_efada:
      "تم إعادة الاختبارات واتضح إستمرار وجود تباين ، وتم الاجتماع و الاتفاق مع تقنية المعلومات على إضافة حقل للتحقق من الرسوم و ذلك لضمان دقة البيانات بتاريخ 25/7/2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "d8569cee-5399-ec11-8b00-98566de81707",
    ProjectName: "ربط قاعدة بيانات مركز الاحياء",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-22-084",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هدى عثمان احمد الزهراني huda o. alzahrani",
    ProjectDescription: null,
    ProjectStartDate: "2021-06-08T00:00:00",
    ProjectFinishDate: "2022-07-26T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 90,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "90",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "تم الربط على البوابة السابقة وأجل الإطلاق ليتم على المنصة الجديدة وتم تضمينه في الإطلاق الثاني",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "Saad Saud Almutairi",
    sector_efada:
      "يتم التنفيذ كجزء من منصة الاسر المنتجة الجديدة وستكون في المرحلة الثانية للاطلاق المنتهية في 15 سبتمبر",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "c4644123-e720-4c93-aa0b-a86cd0a5caeb",
    ProjectName:
      "تقديم الخدمات الاستشارية لإعداد اللوائح والهياكل التنظيمية لمؤسستي تمكين واستدامة لدعم القطاع غير الربحي",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-20-007",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectDescription:
      "توفير تصميم مؤسسي محدد لمؤسسة أهلية وذلك لتحقيق تمكين وبناء قدرات اللجان والجمعيات الاهلية ",
    ProjectStartDate: "2020-08-16T00:00:00",
    ProjectFinishDate: "2020-10-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "25127",
    BudgetItemName: "الاسر المنتجة",
    EstimatedBudget: "600000.000000",
    ApprovedBudget: "756327.000000",
    ContractValue: "756327.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "756327.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "مؤسسة الأداء المتوازن ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "سعيد صالح عبدالله الزهراني saeed s. alzahrani",
    ProjectOfficerContact: "عهود خالد الربيعة Ahood K ALrabiah",
    sector_efada: "تم إغلاق المشروع وصرف كامل مستحقاته.",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "2f57f844-6b81-40b9-b7e6-ac0b4f40e721",
    ProjectName:
      "تمويل أول عميل من خلال منصة Passionueurs (منتج نفاذ White Labelling)",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-21-013",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالله احمد العودان Abdullah A Alodan",
    ProjectDescription:
      "تمويل أول عميل من خلال منصة Passionueurs (منتج نفاذ White Labelling)",
    ProjectStartDate: "2021-08-01T00:00:00",
    ProjectFinishDate: "2021-09-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 100,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: null,
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectOfficerContact: "وليد سليمان النزهه Waleed S. Alnozha",
    sector_efada: null,
    pmo_efada: null,
    cat_efada: "التكامل التقني ",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "8b027666-f066-4979-8eca-af242e6f09dd",
    ProjectName: "تطوير في نظام حاسب للمستخلصات المدفوعة",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-22-010",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "مسفر محمد شبيب العجالين MESFER M. ALAJALIN",
    ProjectDescription: "تطوير في نظام حاسب للمستخلصات المدفوعة",
    ProjectStartDate: "2021-10-01T00:00:00",
    ProjectFinishDate: "2022-03-24T00:00:00",
    BIProjectStartDate: "2021-10-01T08:00:00",
    BIProjectFinishDate: "2022-04-01T17:00:00",
    PlannedCompletePercent: "100",
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada: "تم إطلاق المشروع بنجاح ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "4ced001f-e8f0-42d9-8212-c56b808cccb0",
    ProjectName:
      "توقيع عقود التمويل والمستندات التابعة لها عن طريق خدمة قبول بالإضافة إلى أتمتة سند لأمر",
    Department: "إدارة الإئتمان",
    ProjectCode: "BU-22-117",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "محمد حسن محمد باعبدالله Mohammed H. Baabdullah",
    ProjectDescription:
      "توقيع عقود التمويل والمستندات التابعة لها عن طريق خدمة قبول بالإضافة إلى أتمته سند لأمر ",
    ProjectStartDate: "2022-01-01T00:00:00",
    ProjectFinishDate: "2022-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 70,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متوقع التأخير/ملاحظة مهمة",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "70",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "بشأن خدمة توقيع عقود التمويل عن طريق قبول للمنتجات (ناشئ – حل – عربات – خريجين) فهو مجدول على أن يتم الإطلاق بتاريخ 04/08/2022 وأما بشأن مشروع السند لأمر فلا زلنا بانتظار معالجة الملاحظات على الوثيقة.",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "عبدالمجيد صالح الكريديس Abdulmajed S. AlKriedees",
    ProjectOfficerContact: " ",
    sector_efada:
      "حسب افادة إدارة تقنية المعلومات بانه تم التوجيه من قبل مجلس التغيير بانه سيتم تأجيل الاطلاق الى الأسبوع القادم نظرا لإطلاق نظام الاسر المنتجة التاريخ المتوقع 11-8-2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d33b501b-9eb3-4886-935b-cdffb3182d30",
    ProjectName: "تطوير هوية منافذ البيع للأسر المنتجة",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-021",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز مطر اللويحق Abdulaziz M Alluwaihiq",
    ProjectDescription: "تطوير هوية منافذ البيع للأسر المنتجة",
    ProjectStartDate: "2021-12-07T00:00:00",
    ProjectFinishDate: "2022-01-17T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "100000.000000",
    ApprovedBudget: "75900.000000",
    ContractValue: "75900.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "75900.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "نقطة و خط",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "100",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    sector_efada: "تم إغلاق المشروع وصرف كامل مستحقاته.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "75900.00",
    SpentYearBudget: "75900.000000",
  },
  {
    ProjectUID: "eadbb0d9-c05e-47ab-ad47-d8dcbd0ec366",
    ProjectName: "أتمته التمويل غير المباشر من راس مال البنك",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-22-007",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "حماد عبدالله صالح المحيسن Hammad A. AlMuhaysin",
    ProjectDescription: "أتمته التمويل غير المباشر من راس مال البنك ",
    ProjectStartDate: "2021-12-01T00:00:00",
    ProjectFinishDate: "2022-05-01T00:00:00",
    BIProjectStartDate: "2021-12-01T08:00:00",
    BIProjectFinishDate: "2022-05-01T17:00:00",
    PlannedCompletePercent: "100",
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada: "تم إطلاق المشروع بنجاح ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "df4e3ce7-e961-49e7-832e-e67ceb2d6055",
    ProjectName: "التمويل الدوار وشرائح التمويل",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-21-003",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription: "التمويل الدوار وشرائح التمويل",
    ProjectStartDate: "2021-05-15T00:00:00",
    ProjectFinishDate: "2022-01-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (1)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "100",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada: "تم اطلاق المشروع بتاريخ 9-6-2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "0ac9881d-4bab-4cdc-a9c6-ef7bf3454532",
    ProjectName:
      "توريد وتركيب وتوحيد أجهزة البصمة لنظام الحضور والانصراف الالكتروني",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-064",
    ProjectOwner: "فواز عبدالله العمران Fawaz A Alomran",
    boardinitiative: "لا",
    ProjectManager: "عبدالله فهد الدعفس Abdullah Fahad Al-Dafas",
    ProjectDescription:
      "توريد وتركيب وتوحيد أجهزة البصمة لنظام الحضور والانصراف الالكتروني لبنك التنمية الاجتماعية بالإدارة العامة وفروعه",
    ProjectStartDate: "2022-02-01T00:00:00",
    ProjectFinishDate: "2022-05-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 100,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1193608.000000",
    ContractValue: "1193608.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "مؤسسة البرامج الدولية لتقنية نظم المعلومات ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "ناصر محمد الهدهود Nasser M. AlHadhoud",
    ProjectOfficerContact: " ",
    sector_efada: "تم الانتهاء من المشروع فنياً وجاري استكمال اجراءات الصرف ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1193608.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "2cfa604a-34b3-4463-9e72-9ce8810c2891",
    ProjectName: "قياس رضا العملاء",
    Department: "إدارة تجربة العملاء",
    ProjectCode: "ST-21-019",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "ماجد عبدالله العنزي majed a. alanazi",
    ProjectDescription: "قياس رضا العملاء",
    ProjectStartDate: "2021-09-19T00:00:00",
    ProjectFinishDate: "2022-06-05T00:00:00",
    BIProjectStartDate: "2021-06-01T09:00:00",
    BIProjectFinishDate: "2022-06-06T11:00:00",
    PlannedCompletePercent: "100",
    ActualCompletePercent: 99,
    BudgetItemNo: "داخلي ",
    BudgetItemName: "داخلي ",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (1)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: '"في اختبار UAT "',
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "عبدالله ردن عبدالله العصيمي abdullah r. alossimi",
    ProjectOfficerContact: " ",
    sector_efada:
      "التأخير بسبب وجود ملاحظات لم يتم مراعاتها من فريق تقنية المعلومات على الرغم من وجودها في وثيقة متطلبات الأعمال، يجري الآن اختبار المنصة من فريق الجودة في إدارة تقنية المعلومات بالتزامن مع فريق إدارة تجربة العملاء ومن ثم الإطلاق في حال معالجة جميع الملاحظات. ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "fa834a0b-be0f-4e59-912d-d36abe058df3",
    ProjectName: "نظام الاصول الثابته",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-21-004",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "فهد عائش العتيبي Fahad A. Alotaibi",
    ProjectDescription: "نظام الاصول الثابته",
    ProjectStartDate: "2021-09-20T00:00:00",
    ProjectFinishDate: "2021-12-31T00:00:00",
    BIProjectStartDate: "2021-08-29T08:00:00",
    BIProjectFinishDate: "2021-09-02T17:00:00",
    PlannedCompletePercent: "100",
    ActualCompletePercent: 99,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "60000.000000",
    ApprovedBudget: "60000.000000",
    ContractValue: "41055.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "41055.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "مجموعة النظم",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الانتهاء من المشروع وصرف المستحقات ورفع طلب اغلاق على النظام وجاري الحصول على الموافقات اللازمة",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "41055.00",
    SpentYearBudget: "41055.000000",
  },
  {
    ProjectUID: "7a2871df-de24-4d9b-85c4-f1d26190cb1e",
    ProjectName: "تدقيق ومراجعة القوائم المالية للسنة المالية 2021م",
    Department: "إدارة التقارير والميزانية",
    ProjectCode: "FI-22-004",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "تركي خالد الجبرين TURKI K. ALJEBREEN",
    ProjectDescription:
      "القيام بأعمال التدقيق والمراجعة (Auditing) للقوائم المالية للسنة المالية 2021م المعدة وفقا للمعايير الدولية لإعداد التقارير المالية (IFRS) وكافة الافصاحات والايضاحات المرفقة وإصدار تقرير المراجعة المستقل والذي يبين رأي المراجع الخارجي حول عدالة القوائم المالية التي سيتم اعدادها بموجب المعايير الدولية لإعداد التقارير المالية (IFRS) من كافة النواحي الجوهرية وذلك وفقاً لمعايير المراجعة المعتمدة في المملكة العربية السعودية.\r\n",
    ProjectStartDate: "2022-03-20T00:00:00",
    ProjectFinishDate: "2022-08-20T00:00:00",
    BIProjectStartDate: "2022-03-20T08:00:00",
    BIProjectFinishDate: "2022-08-21T17:00:00",
    PlannedCompletePercent: "86",
    ActualCompletePercent: 97,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1500000.000000",
    ContractValue: "862500.000000",
    RevisedContractValue: "862500.000000",
    PaidAmount: "0.00",
    RemainingAmount: "862500.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany:
      "شركة سليمان عبدالله الخراشي وشركاه محاسبون ومراجعون قانونيون",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "عادل عبدالله الدحيم Adel A. Alduhaim",
    ProjectOfficerContact: " ",
    sector_efada:
      "تمت موافقة لجنة المراجعة ومجلس الإدارة على إصدار القوائم المالية لكن لم تصدر بعد ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1500000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "5c8b21da-6f74-eb11-8af0-005056921d78",
    ProjectName:
      "أنظمة الضوابط الأمنية ورقابتها - أداة أمنية لفحص ومراقبة البنية التحتية والخدمات الإلكترونية",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-21-035",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "طارق سليمان المحمود Tarek S Almahmoud",
    ProjectDescription:
      "أنظمة وأدوات لمراقبة وفحص وقياس تطبيق ضوابط هيئة الأمن السيبراني والتشريعات ذات العلاقة للحد من المخاطر الأمنية المترتبة ، ولتعزيز قدرات الأمن السيبراني في البنك .",
    ProjectStartDate: "2022-01-16T00:00:00",
    ProjectFinishDate: "2025-01-16T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 96,
    BudgetItemNo: "",
    BudgetItemName: "أنظمة الضوابط الأمنية ورقابتها ",
    EstimatedBudget: "226963.770000",
    ApprovedBudget: "226963.770000",
    ContractValue: "226963.770000",
    RevisedContractValue: "226963.770000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة الحماية المرنة للاتصالات وتقنية المعلومات",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "اصدار التوصية",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 664,
    ActualResourceHours: 281,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التنفيذ ويسير حسب المخطط",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "64d66bf0-2a74-eb11-8af0-005056921d78",
    ProjectName: "مشروع تشغيل مركز دلني للأعمال",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-20-001",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "بدر سليمان عبدالرحمن العكيل BADR S. ALAKEEL",
    ProjectDescription: null,
    ProjectStartDate: "2020-02-05T00:00:00",
    ProjectFinishDate: "2022-02-05T00:00:00",
    BIProjectStartDate: "2020-02-05T08:00:00",
    BIProjectFinishDate: "2022-02-05T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 95,
    BudgetItemNo: "25423",
    BudgetItemName: "بيت المحترف",
    EstimatedBudget: "72000000.000000",
    ApprovedBudget: "69231750.000000",
    ContractValue: "69231750.000000",
    RevisedContractValue: "75924067.000000",
    PaidAmount: "46955050.00",
    RemainingAmount: "28969017.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "شركة الخليج للتدريب والتعليم",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "95",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "جودي سالم صالح الدبيبي Judi S. Aldibibi",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "تم اكتمال المشروع فنيا ومتبقي دفعات أخيرة.",
    pmo_efada:
      "تم اضافة طلب تغيير بتمديد مدة المشروع بمقدار 3 شهور و 15 يوم وزيادة تكلفة المشروع بنسبة 9.9 %",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "364a0054-21c8-4fad-8205-946b81bf1450",
    ProjectName:
      "تنفيذ الاعمال الهندسية لفرع بنك التنمية الاجتماعية في الدمام (مشروع جادة30)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-007",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: "تأهيل وتنفيذ جادة 30 لفرع الدمام\r\n\r\n",
    ProjectStartDate: "2021-11-15T00:00:00",
    ProjectFinishDate: "2022-03-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 90,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "1800000.000000",
    ApprovedBudget: "1800000.000000",
    ContractValue: "2758280.000000",
    RevisedContractValue: "3019847.990000",
    PaidAmount: "1019492.25",
    RemainingAmount: "1694158.500000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "الراجحي للبناء والتعمير ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "90",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الإنتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "غدير الحارثي Gadeer Alharthi",
    sector_efada: "تم الانتهاء من المشروع و الافتتاح التجريبي للجادة",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "55ef630a-4299-ec11-8b00-98566de81707",
    ProjectName: "بناء نظام إلكتروني للتحليل الائتماني والمالي لطلبات التمويل",
    Department: "إدارة الإئتمان",
    ProjectCode: "BU-22-065",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "بدر فهد الشعيبي Bader F. Alshouiby",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2022-07-30T00:00:00",
    BIProjectStartDate: "2021-05-01T08:00:00",
    BIProjectFinishDate: "2022-06-26T12:00:00",
    PlannedCompletePercent: "100",
    ActualCompletePercent: 72,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (1)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "72",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      '"المرحلة الأولى (ORR) : تم الإطلاق بتاريخ 26/5/2022 المرحلة الثانية (القوائم المالية) : تاريخ الانتهاء 18-08-2022"',
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تحقيق الاستدامة المالية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "عبدالمجيد صالح الكريديس Abdulmajed S. AlKriedees",
    ProjectOfficerContact: "ABDULAZIZ SAUD ALHARBI",
    sector_efada:
      "تم تسليم جميع متطلبات الاعمال لإدارة التقنية وتم انتقال ملكية المرحلة الاولى للمشروع لإدارة المخاطر وتم الاطلاق والمرحلة الثانية ( التحليل المالي ) لدى إدارة تقنية المعلومات للتنفيذ وتم استلام ايميل من تقنية المعلومات بطلب التأجيل حتى تاريخ 15-8-2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "5ba5be6e-2742-4fcf-ab11-2ca4daf2532b",
    ProjectName:
      "تنفيذ خدمات إعلامية للافتتاح فرع البنك بخميس مشيط والدمام (جادة30)",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-013",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "فيصل فهد عبدالله الخليفة Faisal F. Alkhalifa",
    ProjectDescription: "تنفيذ خدمات إعلامية لإفتتاح فرع البنك بخميس مشيط",
    ProjectStartDate: "2021-08-01T00:00:00",
    ProjectFinishDate: "2022-07-31T00:00:00",
    BIProjectStartDate: "2021-08-01T08:00:00",
    BIProjectFinishDate: "2022-07-31T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 93,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية",
    EstimatedBudget: "1000000.000000",
    ApprovedBudget: "799676.000000",
    ContractValue: "799676.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "799676.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة وصفة الإبداع لدعاية والإعلان ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "محمد علوش محمد الهديب mohammed a. alhedaib",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: "دانيا عثمان المنيع Dania O. Almanea",
    sector_efada: null,
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "799676.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "e6972e12-4f99-ec11-8b00-98566de81707",
    ProjectName: "تطوير الية تقديم زود للاسر المنتجة",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-074",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هيفاء عبدالله عبدالرحمن السيف Haifa Al-Saif",
    ProjectDescription: null,
    ProjectStartDate: "2021-11-01T00:00:00",
    ProjectFinishDate: "2022-08-25T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 78,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "78",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "سيطلق بتاريخ 2022/08/30 ضمن مشروع تطوير بوابة الاسر المنتجة",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: "Khalid Abdulaziz Alothman",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "9deba39f-29a0-4da4-9c6f-9f993504ad6b",
    ProjectName:
      "تطبيق منظومة إدارة الجودة وفقاً لمتطلبات المواصفة القياسية (الأيزو 9001 – 2015) و (الأيزو 10015-2019 ) على ادارات وفروع بنك التنمية الاجتماعية",
    Department: "إدارة تميز العمليات",
    ProjectCode: "SS-22-026",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالله عبدالرحمن غنيم الغنيم abdullah a. alghonaim",
    ProjectDescription:
      "تطبيق منظومة إدارة الجودة وفقاً لمتطلبات المواصفة القياسية (الأيزو 9001 – 2015) و (الأيزو 10015-2019 ) على ادارات وفروع بنك التنمية الاجتماعية",
    ProjectStartDate: "2021-09-05T00:00:00",
    ProjectFinishDate: "2022-07-05T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 92,
    BudgetItemNo: "1805",
    BudgetItemName: "-2310 - الخدمات الاستشارية ",
    EstimatedBudget: null,
    ApprovedBudget: "540500.000000",
    ContractValue: "540500.000000",
    RevisedContractValue: "540500.000000",
    PaidAmount: "270250.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبداللطيف محمد عرفه ABDULATEEF M ARAFA",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التنفيذ ويسير حسب المخطط",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "270250.000000",
  },
  {
    ProjectUID: "7f9befaf-7eb4-4f28-b9c5-3fc749ad5125",
    ProjectName: "طلب صرف دفعة تالية لمُنتج رواد الأعمال",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-118",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription: "طلب صرف دفعة تالية لمُنتج رواد الأعمال",
    ProjectStartDate: "2022-03-01T00:00:00",
    ProjectFinishDate: "2022-05-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 90,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "90",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "جاهز للإطلاق متبقي إعتماد الإجراءات",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada:
      "في انتظار اعتماد الإدارة المالكة للإجراء (إدارة العمليات البنكية) منذ تاريخ 25/7/2022 وذلك لتتم عملية الإطلاق",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d7974756-5499-ec11-8b00-98566de81707",
    ProjectName: "اتمتة استقطاع كفلاء المنشآت",
    Department: "إدارة الإئتمان",
    ProjectCode: "BU-22-087",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "محمد حسن محمد باعبدالله Mohammed H. Baabdullah",
    ProjectDescription: null,
    ProjectStartDate: "2022-02-27T00:00:00",
    ProjectFinishDate: "2022-06-27T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 81,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "81",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "تم إرسال المشروع إلى قطاع الأعمال للاختبار UAT بتاريخ 31-07-2022",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "عبدالمجيد صالح الكريديس Abdulmajed S. AlKriedees",
    ProjectOfficerContact: "عبدالعزيز حسن خليل الاحمدي Abdulaziz H. AlAhmadi",
    sector_efada:
      "تم تسليم الاختبارات من قبل تقنية المعلومات للإدارة المالكة بتاريخ 31-7-2022 التاريخ المتوقع لانتهاء اختبار قبول المستخدم 8-8-2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "8fbe459c-6b74-eb11-8af0-005056921d78",
    ProjectName: "تطوير مكتب إدارة المشاريع المؤسسي في بنك التنمية الاجتماعية",
    Department: "مكتب إدارة المشاريع المؤسسي",
    ProjectCode: "ST-20-001",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "محمد مسفر محمد الأحمري mohammed m. alahmari",
    ProjectDescription:
      "تطوير ادارة الاستراتيجية و المشاريع بالاستناد إلى أفضل التجارب والممارسات العالمية المشتملة على إدارة المشاريع والبرامج وباستخدام الأنظمة المساندة",
    ProjectStartDate: "2020-01-11T00:00:00",
    ProjectFinishDate: "2022-05-27T00:00:00",
    BIProjectStartDate: "2020-11-19T08:00:00",
    BIProjectFinishDate: "2022-05-18T17:00:00",
    PlannedCompletePercent: "100",
    ActualCompletePercent: 89,
    BudgetItemNo: "PR20/028",
    BudgetItemName: "",
    EstimatedBudget: "8000000.000000",
    ApprovedBudget: "7500000.000000",
    ContractValue: "7500000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "4000000.00",
    RemainingAmount: "3500000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة أم القرى",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "محمد مسفر محمد الأحمري mohammed m. alahmari",
    ProjectOwner1: "عبدالله عبدالعزيز الناصر Abdullah A. Alnasser",
    ProjectOfficerContact: " ",
    sector_efada: "تم اطلاق النظام وانتقاله الى مرحلة تشغيل النظام",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "f7ba5736-2c74-eb11-8af0-005056921d78",
    ProjectName:
      "توريد وتركيب أجهزة تقنية المعلومات جادة 30 (خميس مشيط - تبوك - الدمام )",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-022",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      "إيجاد نموذج للفرع يعتمد على التفاعل الرقمي مع العملاء والتواصل الغير مباشر لتقديم الخدمات والمنتجات",
    ProjectStartDate: "2022-01-02T00:00:00",
    ProjectFinishDate: "2022-06-16T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 86,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "3000000.000000",
    ApprovedBudget: "3000000.000000",
    ContractValue: "1330683.000000",
    RevisedContractValue: "1330683.000000",
    PaidAmount: "0.00",
    RemainingAmount: "1330683.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "86",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "غدير الحارثي Gadeer Alharthi",
    sector_efada:
      "تم الانتهاء من اعمال التوريد لفرعي تبوك و خميس مشيط وتم بدء الاعمال في جادة الدمام",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "1330683.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "34d3fcf3-d1ec-4e98-8874-9f7cfe8fafde",
    ProjectName:
      "اطــلاق الحزمــة الثالثــة مــن خدمــات التمويــل فــي تطبيــق الجــوال",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-20-008",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription:
      "اطــلاق الحزمــة الثالثــة مــن خدمــات التمويــل فــي تطبيــق الجــوال ( سيولة و رواد الأعمال)",
    ProjectStartDate: "2020-06-15T00:00:00",
    ProjectFinishDate: "2021-09-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 84,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التطبيقات",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "84",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      '"تم معالجة الملاحظات الواردة من قبل قطاع الأعمال بواسطة الزملاء في إدارة التطبيقات يوم الأربعاء الموافق 27 / 7 / 2022 ومازال في مرحلة الاختبار لدى قطاع الأعمال."',
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الانتهاء من اختبار قبول المستخدم وإرسال الملاحظات بتاريخ 1/8/2022 وفي انتظار معالجتها",
    pmo_efada: "في انتظار التواريخ الجديدة من تقنية المعلومات",
    cat_efada: "التطبيقات",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b8a13b29-0942-44a8-850b-a01fa70dc82a",
    ProjectName: "اطار إدارة المخاطر",
    Department: "إدارة تقييم ومعالجة المخاطر",
    ProjectCode: "RI-21-002",
    ProjectOwner:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    boardinitiative: "لا",
    ProjectManager: "احمد مبارك عبدالله الدوسري Ahmed M Aldosari",
    ProjectDescription: "اطار إدارة المخاطر",
    ProjectStartDate: "2021-12-22T00:00:00",
    ProjectFinishDate: "2022-08-19T00:00:00",
    BIProjectStartDate: "2021-08-01T08:00:00",
    BIProjectFinishDate: "2024-08-01T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 83,
    BudgetItemNo: "526",
    BudgetItemName: "الخدمات الاستشارية مراحل",
    EstimatedBudget: "9000000.000000",
    ApprovedBudget: "1035000.000000",
    ContractValue: "1035000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "ديلويت اند توش السعودية للاستشارات الحدودة",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "إدارة المخاطر",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تحقيق الاستدامة المالية",
    PortfoilioName: "إدارة المخاطر",
    ProgramManager: " ",
    ProjectOwner1:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الانتهاء من مرحلة تقييم الوضع الحالي والمقارنة المعيارية وتحديد وتحليل الفجوات لرفع أداء إدارة المخاطر ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1035000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "9a88832e-0b4b-4236-8055-1893500a6ac2",
    ProjectName: "موقع البنك الجديد (Website)",
    Department: "إدارة تجربة العملاء",
    ProjectCode: "ST-22-027",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "عبدالله ردن عبدالله العصيمي abdullah r. alossimi",
    ProjectDescription: "موقع البنك الجديد ",
    ProjectStartDate: "2022-02-20T00:00:00",
    ProjectFinishDate: "2022-08-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 81,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 368,
    ActualResourceHours: 368,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "عبدالله ردن عبدالله العصيمي abdullah r. alossimi",
    ProjectOfficerContact: " ",
    sector_efada:
      " يجري الآن الاختبار من قبل الشركة ومن ثم تسليم الأكواد الخاصة بواجهات الموقع الرسمي في تاريخ ٩ أغسطس ومن ثم يتم الاختبار في البنك من قبل فريق تجربة العملاء، يتبعه أعمال الفريق التقني في البنك، ثم تضمين المحتوى المجهز مسبقًا ثم الإطلاق",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b55a7fc9-5724-4a56-8a39-f6375aa144a4",
    ProjectName: "حملات نشر ثقافة الادخار والتوعية المالية لمختلف فئات المجتمع",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-21-045",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خواطر احمد عبدالله الخويطر Khawater A Alkhowaiter",
    ProjectDescription:
      "حملة أسبوع المال العالمي - حملة اليوم العالمي للادخار - منصة تعليمية للأطفال - مؤتمر الادخار- التطوع",
    ProjectStartDate: "2021-11-25T00:00:00",
    ProjectFinishDate: "2022-10-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 89,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "3500000.000000",
    ApprovedBudget: "3499450.000000",
    ContractValue: "3499450.000000",
    RevisedContractValue: "3849050.000000",
    PaidAmount: "3069050.00",
    RemainingAmount: "779700.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة الاتجاه الرقمي للتطوير و الاستثمار التجاري ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "89",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: " ",
    sector_efada: "قيد التنفيذ و يسير حسب المخطط",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "1363900.000000",
  },
  {
    ProjectUID: "b5a39ea6-7474-eb11-8af0-005056921d78",
    ProjectName: "خدمة تم للنقل التشاركي",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-21-023",
    ProjectOwner: "محمد إبراهيم علي العريني Mohammed I. Al Orini",
    boardinitiative: "لا",
    ProjectManager: "شايع عايض المطيري Shaya A. almutairi",
    ProjectDescription: "الاشتراك في خدمة تم المقدمة من خلال شركة علم",
    ProjectStartDate: "2021-09-15T00:00:00",
    ProjectFinishDate: "2022-09-15T00:00:00",
    BIProjectStartDate: "2020-08-24T08:00:00",
    BIProjectFinishDate: "2021-08-25T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 80,
    BudgetItemNo: "232012",
    BudgetItemName: "توفير رسائل نصيه",
    EstimatedBudget: "33090.000000",
    ApprovedBudget: "33090.000000",
    ContractValue: "33090.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة علم",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "80",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: "محمد إبراهيم علي العريني Mohammed I. Al Orini",
    ProjectOfficerContact: " ",
    sector_efada: "المشروع تحت التنفيذ حسب المخطط",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "9f4956d3-3593-4d98-86e7-2e4be207b8c8",
    ProjectName: "برنامج تأهيل وتدريب العاملين فى القطاع الغير الربحى",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-025",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "اسماء مبارك بالعبيد Asma M. Balobaid",
    ProjectDescription: "برنامج تأهيل وتدريب العاملين فى القطاع الغير الربحى ",
    ProjectStartDate: "2021-09-19T00:00:00",
    ProjectFinishDate: "2022-09-19T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 67,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "3000000.000000",
    ApprovedBudget: "2610000.000000",
    ContractValue: "2610000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "1942500.14",
    RemainingAmount: "667499.860000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "الأصول للتدريب",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "67",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "جودي سالم صالح الدبيبي Judi S. Aldibibi",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "عبدالله سعيد عوض السبيعي abdullah s. alsubaie",
    sector_efada:
      "بلغ عدد مستفيدي التدريب حتى تاريخه من دورات تدريب العاملين 571 مستفيد، وتم تأهيل عدد 122 مرشد معتمد. تم إصدار تقرير دراسة الاحتياجات التدريبية للقطاع غير الربحي.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2610000.00",
    SpentYearBudget: "1942500.140000",
  },
  {
    ProjectUID: "72532029-151c-46f3-8908-a01d19a55673",
    ProjectName:
      "تقديم خدمات استشارية لتطبيق التحول الى اساس الاستحقاق المحاسبي واعداد المركز المالي الافتتاحي على اساس الاستحقاق",
    Department: "إدارة التقارير والميزانية",
    ProjectCode: "FI-21-007",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "عادل عبدالله الدحيم Adel A. Alduhaim",
    ProjectDescription: "مشروع التحول الي أساس الاستحقاق المحاسبي",
    ProjectStartDate: "2021-12-15T00:00:00",
    ProjectFinishDate: "2022-11-14T00:00:00",
    BIProjectStartDate: "2020-05-15T08:00:00",
    BIProjectFinishDate: "2022-11-14T17:00:00",
    PlannedCompletePercent: "91",
    ActualCompletePercent: 75,
    BudgetItemNo: "2310",
    BudgetItemName: "استشاريه",
    EstimatedBudget: "7000000.000000",
    ApprovedBudget: "11000000.000000",
    ContractValue: "5750000.000000",
    RevisedContractValue: "6321527.000000",
    PaidAmount: "4979500.00",
    RemainingAmount: "1342027.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "كي بي ام جي الفوزان KPMG ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "معلق",
    ContractStatus: "معلق",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تحقيق الاستدامة المالية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "ماجد محمد الدخيل Maged M. Aldakheel",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم إيقاف المشروع بتاريخ 18/07/2022لتعذر تنفيذ احد المخرجات المرتبط بإطلاق نظام ERP",
    pmo_efada:
      "تم ايقاف المشروع حسب خطاب سعادة الرئيس لتعذر تنفيذ احد المخرجات قبل انطلاق نظام ERP",
    cat_efada: "الأنظمة و التطوير ",
    YearBudget: "1112527.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "f95428bd-f899-ec11-8b02-0050569272df",
    ProjectName: "تطوير خدمة موعد",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-111",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: null,
    ProjectStartDate: "2022-04-15T00:00:00",
    ProjectFinishDate: "2022-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 85,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "85",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "لم يتم البدء بالتطوير - بانتظار وثيقة الربط الصحيحة من الشركة المزودة ",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "منيره عبدالله علي السديس Muneera A. AlSudays",
    sector_efada:
      "الان في مرحلة الاختبار للربط بين خدمة موعد ونظام إدارة الطوابير في الفروع ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "b502d22f-bf74-eb11-8af0-005056921d78",
    ProjectName: "تقديم خدمات استشارية وتنفيذ المعسكرات التدريبية المتخصصة",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-026",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "ديما إبراهيم الباز Dima A. Albaz",
    ProjectDescription: null,
    ProjectStartDate: "2021-10-24T00:00:00",
    ProjectFinishDate: "2022-10-24T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 68,
    BudgetItemNo: "273",
    BudgetItemName: "البيت المحترف",
    EstimatedBudget: "4500000.000000",
    ApprovedBudget: "1533882.380000",
    ContractValue: "1533882.380000",
    RevisedContractValue: "0.000000",
    PaidAmount: "230082.35",
    RemainingAmount: "1303800.030000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "أطياف الابتكار (هيود)",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "68",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تمت مراجعة مخرجات معسكر الايديا ثون 2 واستلام محتوى معسكر تجسير 1 لتنفيذه في 24 يوليو.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ad7c4b13-7c07-4966-8176-b6ad8916f6d8",
    ProjectName: "نظام حزمة أنظمة تمويل الأسر المنتجة CRM",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-20-008",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "Khalid Abdulaziz Alothman",
    ProjectDescription: "اطلاق نظام البلاغات CRM  في مركز الاتصال الموحد",
    ProjectStartDate: "2020-08-16T00:00:00",
    ProjectFinishDate: "2023-04-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 71,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "11000000.000000",
    RevisedContractValue: "11000000.000000",
    PaidAmount: "6925184.05",
    RemainingAmount: "4074815.950000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم اطلاق المرحلة الاولى و جاري العمل على اطلاق المرحلة الثانية ",
    pmo_efada: "\\",
    cat_efada: "الأنظمة و التطوير",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "5f59f4a0-adce-4efb-8eac-9943aa15b818",
    ProjectName: "تطوير في نظام B2B وتطبيق الالية الجديدة",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-22-013",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "مسفر محمد شبيب العجالين MESFER M. ALAJALIN",
    ProjectDescription: "تطوير في نظام B2B وتطبيق الالية الجديدة ",
    ProjectStartDate: "2022-04-01T00:00:00",
    ProjectFinishDate: "2022-09-01T00:00:00",
    BIProjectStartDate: "2022-04-01T08:00:00",
    BIProjectFinishDate: "2022-09-01T17:00:00",
    PlannedCompletePercent: "79",
    ActualCompletePercent: 70,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada:
      "في انتظار رد إدارة الحوكمة على طلب مشاركة بيانات العناوين للموظفين مع البنك العربي الوطني لاستكمال الفحص واطلاق المشروع",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "df3cdbf2-e0fe-4d5e-b084-24a3aadc5b80",
    ProjectName: "تأهيل فرعي(خميس مشيط و بريدة)بوسائط سمعية وبصرية",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-040",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "تأهيل فرعي(خميس مشيط و بريدة)بوسائط سمعية وبصرية",
    ProjectStartDate: "2022-01-15T00:00:00",
    ProjectFinishDate: "2022-06-07T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 87,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "5000000.000000",
    ContractValue: "3753377.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "3753377.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "العرض المتقن",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "87",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    sector_efada:
      "تم التوريد لفرع خميس مشيط. ومتبقي فرع بريدة لارتباطه بمشروع تأهيل منطقة خدمة العملاء",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "5000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "f4a6ca5a-03ea-46d7-b260-f5899faabecf",
    ProjectName: "مشروع خدمات استشارية وفنية لادارة المخاطر",
    Department: "إدارة تقييم ومعالجة المخاطر",
    ProjectCode: "RI-21-001",
    ProjectOwner:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    boardinitiative: "لا",
    ProjectManager: "راشد علي احمد الراشد Rashed A. AlRashed",
    ProjectDescription: "مشروع خدمات استشارية وفنية لادارة المخاطر",
    ProjectStartDate: "2021-07-29T00:00:00",
    ProjectFinishDate: "2022-07-29T00:00:00",
    BIProjectStartDate: "2021-07-15T08:00:00",
    BIProjectFinishDate: "2022-07-15T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 69,
    BudgetItemNo: "2310",
    BudgetItemName: "الخدمات الاستشارية",
    EstimatedBudget: "836000.000000",
    ApprovedBudget: "836000.000000",
    ContractValue: "836000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة الامير سطام",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "إدارة المخاطر",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "إدارة المخاطر",
    ProgramManager: " ",
    ProjectOwner1:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    ProjectOfficerContact: " ",
    sector_efada: "قائم حسب المخطط",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d4f7d798-204c-4950-bc63-f1a93c35932e",
    ProjectName: "تصميم وتنفيذ حزمة أنظمة تمويل الاسر المنتجة (المنصة الجديدة)",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-20-020",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "هدى عثمان احمد الزهراني huda o. alzahrani",
    ProjectDescription:
      "تصميم وتنفيذ حزمة أنظمة تمويل الاسر المنتجة (المنصة الجديدة)",
    ProjectStartDate: "2020-05-04T00:00:00",
    ProjectFinishDate: "2022-08-25T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 64,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "64",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "تم إطلاق المرحلة الأولى 26/7/2022",
    PlannedResourceHours: 6408,
    ActualResourceHours: 4922,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم اطلاق المنصة للمرحلة الاولى في 26 يوليو، المرحلة الثانية تكون في 15سبتمبر، والثالثة في 23 فبراير 2023",
    pmo_efada: "في انتظار تواريخ الاطلاق الجديدة للمرحلة الثانية والثالثة",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "befe6305-6bae-4651-a061-9aa47d72956c",
    ProjectName: "تقديم خدمات التصميم الهندسي جادة 30 المرحلة الثانية",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-041",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: "تقديم خدمات التصميم الهندسي",
    ProjectStartDate: "2022-02-20T00:00:00",
    ProjectFinishDate: "2022-11-20T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 61,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: "0.000000",
    ApprovedBudget: "2100000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: null,
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "61",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "غدير الحارثي Gadeer Alharthi",
    sector_efada:
      "التأخر في بدء تنفيذ المشروع يعود الى تأخر جامعة المجمعة في انهاء التعاقد مع الشركة المنفذة، مما أثر على تأخر طرح مشاريع جادة30 المرحلة الثانية",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "2100000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ba000ba1-8931-4e4d-8182-b5fe7419f530",
    ProjectName: "تقديم خدمات الدعم المحاسبي للإدارة المالية",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-21-001",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "فهد عائش العتيبي Fahad A. Alotaibi",
    ProjectDescription: "مشروع الدعم المحاسبي",
    ProjectStartDate: "2022-02-06T00:00:00",
    ProjectFinishDate: "2023-02-06T00:00:00",
    BIProjectStartDate: "2022-02-06T08:00:00",
    BIProjectFinishDate: "2023-02-06T17:00:00",
    PlannedCompletePercent: "60",
    ActualCompletePercent: 62,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "4669000.000000",
    ApprovedBudget: "4669000.000000",
    ContractValue: "4600000.000000",
    RevisedContractValue: "4600000.000000",
    PaidAmount: "0.00",
    RemainingAmount: "4600000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة الامير سطام",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada: "تم انتهاء جزء من الدعم المحاسبي ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4600000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "3db15a45-dc62-4ce1-bb18-d13e2acc27d8",
    ProjectName: "تطوير استراتيجية ونموذج تمويل العمل الحر",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-21-053",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "فيصل علي باقيس Faisal A Baqees",
    ProjectDescription: "تطوير نموذج العمل لمنتج نفاذ",
    ProjectStartDate: "2022-02-06T00:00:00",
    ProjectFinishDate: "2022-08-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 74,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "3000000.000000",
    ApprovedBudget: null,
    ContractValue: "3122010.800000",
    RevisedContractValue: "3432650.800000",
    PaidAmount: "191302.5",
    RemainingAmount: "3241348.300000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة ديليوت اند توش ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "74",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "محمد إبراهيم علي العريني Mohammed I. Al Orini",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الموافقة على طلب التغيير زيادة الكميات وتم رفعها في النظام ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3432650.80",
    SpentYearBudget: "191302.500000",
  },
  {
    ProjectUID: "42c55b53-076c-4aa0-8a4c-bb4b01002aa5",
    ProjectName: "تأسيس وتشغيل مطبخ مجتمعي بمدينة الرياض (قرطبة)",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-014",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "أسعد زهير الزغيبي Asaad Z. Alzughaibi",
    ProjectDescription: "انشاء مطبخ مجتمعي نموذجي",
    ProjectStartDate: "2022-01-20T00:00:00",
    ProjectFinishDate: "2022-08-20T00:00:00",
    BIProjectStartDate: "2021-06-30T08:00:00",
    BIProjectFinishDate: "2024-03-14T17:00:00",
    PlannedCompletePercent: "80",
    ActualCompletePercent: 60,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "3400000.000000",
    ApprovedBudget: "9576580.000000",
    ContractValue: "4000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "2000000.00",
    RemainingAmount: "2000000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "جمعية أعمال للتنمية الأسرية",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "60",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    sector_efada:
      "تم الانتهاء من الارضيات و تمديدات الغاز, وجاري العمل على أعمال الستانلس ستيل، وغرف التبريد، بالاضافة الى تجهيز تصاميم الاثاث.",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "2000000.000000",
  },
  {
    ProjectUID: "19bbe9df-0375-eb11-8af1-005056921d78",
    ProjectName:
      "إنشاء أجنحة للفعاليات والمعارض ومنافذ بيع مؤقته للأسر المنتجة ورصد الأثر",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-015",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز عبدالرحمن عبدالعزيز العتيق abdulaziz a. alateeg",
    ProjectDescription:
      "بناء الأجنحة وتجهيزات المشاركة في الفعاليات والمعارض المؤقتة",
    ProjectStartDate: "2021-12-30T00:00:00",
    ProjectFinishDate: "2022-12-30T00:00:00",
    BIProjectStartDate: "2021-12-30T08:00:00",
    BIProjectFinishDate: "2022-12-30T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 57,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية (مرحل)",
    EstimatedBudget: "6900000.000000",
    ApprovedBudget: "6866675.000000",
    ContractValue: "6866675.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "1293175.00",
    RemainingAmount: "5573500.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة الموسع ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "محمد علوش محمد الهديب mohammed a. alhedaib",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: "اشواق عمر إبراهيم السليم Ashwag O. Al-Saliem",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "6866675.00",
    SpentYearBudget: "1293175.000000",
  },
  {
    ProjectUID: "66d81aeb-1973-4b97-8e2b-b12e0905232b",
    ProjectName:
      "تقديم خدمات وأدوات لتطوير منهجية تجربة العميل وتحسين مسارات كل العملاء",
    Department: "إدارة تجربة العملاء",
    ProjectCode: "ST-21-016",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "عامر عمير عامر السبيعي Amer O Alsubaie",
    ProjectDescription:
      "تقديم خدمات استشارية وتطوير منهجية تجربة العميل وتحسين مسارات الخدمة",
    ProjectStartDate: "2022-01-16T00:00:00",
    ProjectFinishDate: "2022-09-19T00:00:00",
    BIProjectStartDate: "2022-03-13T08:00:00",
    BIProjectFinishDate: "2022-09-08T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 55,
    BudgetItemNo: "2311",
    BudgetItemName: "نفقات الابحاث والدراسات",
    EstimatedBudget: "4500000.000000",
    ApprovedBudget: "4500000.000000",
    ContractValue: "3998895.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "3998895.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "شركة بيم للاستشارات والابحاث",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "عبدالله ردن عبدالله العصيمي abdullah r. alossimi",
    ProjectOfficerContact: " ",
    sector_efada: "المشروع يسير وفق المخطط",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4500000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ff1f8b2d-200b-454b-8242-c5e0185c322b",
    ProjectName: "تصميم حقائب تدريبية وتحويلها الى حقائب تفاعلية",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-018",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "عبدالله سعيد عوض السبيعي abdullah s. alsubaie",
    ProjectDescription: "تصميم حقائب تدريبية وتحويلها الى حقائب تفاعلية",
    ProjectStartDate: "2021-09-01T00:00:00",
    ProjectFinishDate: "2022-06-01T00:00:00",
    BIProjectStartDate: "2021-06-21T08:00:00",
    BIProjectFinishDate: "2021-12-20T17:00:00",
    PlannedCompletePercent: "0",
    ActualCompletePercent: 79,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "3000000.000000",
    ApprovedBudget: "1391977.250000",
    ContractValue: "1391977.250000",
    RevisedContractValue: "1530352.250000",
    PaidAmount: "893059.81",
    RemainingAmount: "637292.440000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة الخبرات الذكية",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "79",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "عبدالله سعيد عوض السبيعي abdullah s. alsubaie",
    sector_efada:
      "تم استلام كامل الحقائب الورقية وعددها (16) واستلام (4) حقائب تفاعلية وجاري العمل على اعتماد ملف استضافة المنصة",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ca71dd2e-f888-42c8-be3c-ada660bb6147",
    ProjectName: "تقديم خدمات استشاري وتطوير منتجات",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-21-034",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription: "تقديم خدمات استشاري وتطوير منتجات ",
    ProjectStartDate: "2022-09-01T00:00:00",
    ProjectFinishDate: "2023-03-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 12,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3000000.000000",
    ContractValue: "3000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "12",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التأهيل اللاحق.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "fc9ea948-f499-ec11-8b01-0050569272df",
    ProjectName: "اتاحة خيار الامر المستديم (مصرف الراجحي)",
    Department: "إدارة العمليات البنكية",
    ProjectCode: "SS-22-105",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "تركي صالح محمد اليوسف Turki Al Yousef",
    ProjectDescription: null,
    ProjectStartDate: "2022-02-01T00:00:00",
    ProjectFinishDate: "2023-07-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 46,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا",
    NotAligned: "التواريخ",
    AlignedComments: "مطلوب تواريخ",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبدالعزيز عبدالله عثمان العتيق abdulaziz a. alateeq",
    ProjectOfficerContact: "فيصل شباب الغامدي Faisal S. Alghamdi",
    sector_efada:
      "تم الانتهاء من صياغة الاتفاقيات ومراجعتها مع إدارتي الحوكمة والقانونية وارسالها للبنوك (من المهم مراجعة التواريخ المقترحة من تقنية المعلومات للتطوير على النظام )",
    pmo_efada: "غير متوائم ",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "f3983d67-6574-eb11-8af0-005056921d78",
    ProjectName:
      "استكمال تنفيذ المرحلة الثالثة من اعمال المحتوى الوثائقي للبنك",
    Department: "إدارة الوثائق والمحفوظات",
    ProjectCode: "SS-21-010",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "نعم",
    ProjectManager: "محمد سليمان الصقعبي Mohammed S Alsaqabi",
    ProjectDescription: null,
    ProjectStartDate: "2021-06-07T00:00:00",
    ProjectFinishDate: "2024-06-06T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 45,
    BudgetItemNo: "31152",
    BudgetItemName: "مستحقات اصول ثابته سابقة",
    EstimatedBudget: "7619000.000000",
    ApprovedBudget: "7619000.000000",
    ContractValue: "7619000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "1736695.73",
    RemainingAmount: "6834478.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة القلعة للمستودعات المحدودة (InfoFort)",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: " ",
    ProjectOwner1: "يوسف عبدالعزيز صالح الباحوث Yousef A. AlBahooth",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التنفيذ ويسير حسب المخطط",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "0a50c635-6cf7-4fc2-9bde-ab064b08dff7",
    ProjectName: "التقديم الإلكتروني للتمويل",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-005",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "الهنوف فهد الموكاء AlHanof F. AlMouka",
    ProjectDescription: "التقديم الإلكتروني للتمويل 2.0",
    ProjectStartDate: "2021-04-01T00:00:00",
    ProjectFinishDate: "2022-12-29T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 45,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (1)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      " تم اعداد الخطة الزمنية للمشروع و حالياً في مرحلة التطوير (في الـ Backend development) كما و تم الانتهاء من تطوير منتج العمل الحر و جاري عمل الاختبارات من قبل قسم الجودة . و فيما يخص تطوير منتج قرض الاسرة: تم الانتهاء بنسبة 70% من مهام التطوير ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "c9609c5b-f819-444c-b185-4ade4f0abc72",
    ProjectName: "القياس العاشر",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-106",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عفراء علي محمد السويلم Afra A Alswailem",
    ProjectDescription: "القياس العاشر",
    ProjectStartDate: "2022-03-30T00:00:00",
    ProjectFinishDate: "2022-10-29T00:00:00",
    BIProjectStartDate: "2022-03-30T08:00:00",
    BIProjectFinishDate: "2022-10-19T17:00:00",
    PlannedCompletePercent: "59",
    ActualCompletePercent: 44,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (1)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم ظهور نتائج التقييم الأولية وجاري الأخذ بالملاحظات استعداداً لتصحيح الأدلة",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "bc765a3e-de8c-4241-9140-8da026706bf9",
    ProjectName: "إعادة بناء تطبيق الجوال",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-020",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "الهنوف فهد الموكاء AlHanof F. AlMouka",
    ProjectDescription: "بناء تطبيق الجوال على تقنية PWA",
    ProjectStartDate: "2021-11-30T00:00:00",
    ProjectFinishDate: "2021-12-29T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 44,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التطبيقات",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      " تم اعداد الخطة الزمنية للمشروع و حالياً في مرحلة التطوير (في الـ Backend development) كما و تم الانتهاء من تطوير منتج العمل الحر و جاري عمل الاختبارات من قبل قسم الجودة . و فيما يخص تطوير منتج قرض الاسرة: تم الانتهاء بنسبة 70% من مهام التطوير ",
    pmo_efada: "لا يوجد تفاصيل للمشروع",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6671c86b-cc7a-4601-accf-06ce4343646a",
    ProjectName: "تأسيس وتشغيل مطبخ مجتمعي بمدينة الرياض (المروج)",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-015",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "أسعد زهير الزغيبي Asaad Z. Alzughaibi",
    ProjectDescription: "تشغيل مطبخ مجتمعي نموذجي",
    ProjectStartDate: "2021-11-30T00:00:00",
    ProjectFinishDate: "2022-09-01T00:00:00",
    BIProjectStartDate: "2021-06-30T08:00:00",
    BIProjectFinishDate: "2022-02-14T17:00:00",
    PlannedCompletePercent: "0",
    ActualCompletePercent: 31,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "16600000.000000",
    ApprovedBudget: "6717720.000000",
    ContractValue: "6717720.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "6717720.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "جمعية أعمال للتنمية الأسرية",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متوقع التأخير/ملاحظة مهمة",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "31",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    sector_efada:
      "تأخر المشروع ناتج عن بطء إجراءات التعاقد مع أمانة منطقة الرياض حيث تم توقيع عقد الاستئجار 16 يونيو و استلام الموقع في 19 يونيو . تم تطوير نموذج العمل المبدئي و التصاميم الفنية المبدئية.",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "0c6e23b3-7874-eb11-8af0-005056921d78",
    ProjectName: "تطوير بوابة الكترونية للتدريب وبناء القدرات",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-032",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "اسماء مبارك بالعبيد Asma M. Balobaid",
    ProjectDescription: "تطوير منظومة متكاملة للخدمات غير المالية",
    ProjectStartDate: "2021-10-24T00:00:00",
    ProjectFinishDate: "2022-09-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 45,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "8000000.000000",
    ApprovedBudget: "220250.000000",
    ContractValue: "2202250.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "451375.00",
    RemainingAmount: "1750875.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "مؤسسة التناغم التقني",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "45",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "بانتظار اعتماد خطة عمل المشروع ",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "رشا عبدالعزيز محمد برخيل Rasha A. Albarkheel",
    sector_efada:
      "تم الانتهاء من مسودة ملف التكامل التقني بعد التنسيق مع جميع الإدارات المعنية، والان في مرحلة الاعتماد النهائي. يتم حاليا موائمة إصدارات بوابة التدريب مع اصدارات بوابة البنك الجديدة.",
    pmo_efada: "",
    cat_efada: "الأنظمة و التطوير ",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "638f41d8-1975-eb11-8af1-005056921d78",
    ProjectName:
      "تأهيل وتمويل العلامات التجارية وتطويرها لمسار الإمتياز التجاري",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-042",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سيف عبدالله ابراهيم الفرهود SAIF A. ALFARHOOD",
    ProjectDescription:
      "تصميم نموذج يعزز الاستقلال المالي المشاريع منتاهية الصغر من خلال تأهيل علامتها التجارية وتطويرها واعتمادها وتقديم الدعم التشغيلي و التسويقي ومتابعة أدائها وتقويم أعمالها",
    ProjectStartDate: "2022-02-14T00:00:00",
    ProjectFinishDate: "2024-08-14T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 25,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "9270210.000000",
    ApprovedBudget: "9270210.000000",
    ContractValue: "9250600.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "902060.00",
    RemainingAmount: "8348540.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة الخليج",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "25",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "سيف عبدالله ابراهيم الفرهود SAIF A. ALFARHOOD",
    sector_efada:
      "جاري العمل على تصميم وتنفيذ البوابة الالكترونية بالتنسيق مع إدارة تقنية المعلومات. تم اعداد معايير مبدئية لتأهيل العلامات التجارية و جاري اعتمادها",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "902060.000000",
  },
  {
    ProjectUID: "7edbeff4-17a1-4df3-850a-20f15980892f",
    ProjectName: "تكاليف استقطاب ورعاية المشاريع مع الجهات الشريكة - ريادة",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-012",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "يوسف خالد يوسف الخميس Yousef K. Alkhamis",
    ProjectDescription:
      "تكاليف استقطاب ورعاية المشاريع مع الجهات الشريكة - ريادة",
    ProjectStartDate: "2022-02-13T00:00:00",
    ProjectFinishDate: "2022-12-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 35,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "20000000.000000",
    ContractValue: null,
    RevisedContractValue: "0.000000",
    PaidAmount: "8435100",
    RemainingAmount: "11564900.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "35",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada:
      "الهدف من المشروع تدريب وتأهيل ودراسة طلبات التمويل الخاصة وعقد الاتفاقيات والشراكات مع الجهات الخارجية بغرض النفع لمستفيدي وعملاء البنك -معهد ريادة الأعمال الوطني -مركز التنمية الصناعية بالجبيل -الغرف التجارية ( القريات – ينبع – حائل – جازان – القصيم –",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "17000000.00",
    SpentYearBudget: "8435100.000000",
  },
  {
    ProjectUID: "f944f4f0-1fdb-4e09-b210-4046532eb624",
    ProjectName: "بناء منصة وسيطة بين البنك ومنصات العمل الحر",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-22-025",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "بثينة يوسف الخليل Buthaina Y Alkhlil",
    ProjectDescription: "بناء منصة وسيطة بين البنك ومنصات العمل الحر",
    ProjectStartDate: "2022-07-13T00:00:00",
    ProjectFinishDate: "2023-05-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 16,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "6900000.000000",
    ContractValue: "6900000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "6900000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "المنصات",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "16",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "تم الانتهاء من توقيع التقييم الفني في 13 يونيو",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "محمد إبراهيم علي العريني Mohammed I. Al Orini",
    ProjectOfficerContact: "منيره عبدالله علي السديس Muneera A. AlSudays",
    sector_efada:
      "تحت اجراءات التعاقد, تم عقد اجتماعات مبدئية مع الشركة للتخطيط للمشروع, ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3450000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "9fe464d1-fc74-eb11-8af1-005056921d78",
    ProjectName: "أجهزة نقاط البيع - بند حلول أنظمة المدفوعات الالكترونية",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-002",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز مطر اللويحق Abdulaziz M Alluwaihiq",
    ProjectDescription:
      "تقديم حزمة من الخدمات من خلال بناء وتشغيل أنظمة المدفوعات الإلكترونية للمساعدة على تنظيم حسابات وفوترة عملاء البنك و تمكينهم من حلول الدفع الرقمية المتقدمة و قياس الأثر الإقراضي",
    ProjectStartDate: "2021-02-21T00:00:00",
    ProjectFinishDate: "2022-02-21T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "25121",
    BudgetItemName: "الاسر المنتجة",
    EstimatedBudget: "5000000.000000",
    ApprovedBudget: "5000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "5000000.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "جيديا",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "سيكون ضمن مشروع البنية التحتية لأنظمة المدفوعات الالكترونية وتم ارفاق نموذج الغاء ودمج المشروع ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "f3cdddb8-3992-4b02-bfb1-c0656719bb4f",
    ProjectName: "اطلاق مسابقة التميز المؤسسي لوسطاء التمويل",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-22-061",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "لولوه ابراهيم صالح الدفاع Luluh I. Aldaffaa",
    ProjectDescription: "جايزة التميز المؤسسي لوسطاء التمويل\r\n\r\n",
    ProjectStartDate: "2022-07-01T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 18,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "4000000.000000",
    ContractValue: "394923800.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "18",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "لولوه ابراهيم صالح الدفاع Luluh I. Aldaffaa",
    sector_efada:
      "تم انهاء 3 اجتماعات مع الشركة بانتظار التصور الابداعي + [حتى الان لم يتم استلام دفعات ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6d984262-c274-eb11-8af0-005056921d78",
    ProjectName:
      "عمليات الأمن السيبراني وتقييم المخاطر بحسب ضوابط الأمن السيبراني والمعيار العالمي ISO 27001",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-21-036",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "طارق سليمان المحمود Tarek S Almahmoud",
    ProjectDescription: null,
    ProjectStartDate: "2022-01-17T00:00:00",
    ProjectFinishDate: "2025-01-17T00:00:00",
    BIProjectStartDate: "2022-01-04T08:00:00",
    BIProjectFinishDate: "2025-03-18T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 33,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "2297700.000000",
    ApprovedBudget: "2297700.000000",
    ContractValue: "2297700.000000",
    RevisedContractValue: "2297700.000000",
    PaidAmount: "1104000",
    RemainingAmount: "2297700.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "الشركة السعودية للحاسبات الالكترونية المحدودة",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 2320,
    ActualResourceHours: 46,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التنفيذ ويسير حسب المخطط",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "1104000.000000",
  },
  {
    ProjectUID: "a9e119d6-625b-4732-b2ac-55cf531e38e6",
    ProjectName:
      "خدمات استشارية لتطوير الإطار العام للادخار واستخدام تطبيقات الاقتصاد السلوكي",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-121",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خولة ابراهيم ناصرالهديب Khawla Al-Hodaib",
    ProjectDescription:
      "عمل الدراسات و الأبحاث لتطوير المبادرات و خطط العمل الحالية وقياس اثر البرامج و المنتجات الادخارية باستخدام تطبيقات الاقتصاد السلوكي",
    ProjectStartDate: "2022-05-01T00:00:00",
    ProjectFinishDate: "2023-05-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 21,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "4800000.000000",
    ContractValue: "4800000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "شركة رشد للاستشارات الادارية ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "21",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 856,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم توقيع العقد بتاريخ 8 يونيو مع شركة رشد للاستشارات الادارية وتم البدء في التنفيذ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d3876d7b-047f-4821-8dfb-9238bca4002f",
    ProjectName: "توسيع نطاق برنامج إمبريتك السعودية",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-043",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "غاده عبدالله الحربي Gadah A Alharbi",
    ProjectDescription: "توسيع نطاق برنامج إمبريتك السعودية ",
    ProjectStartDate: "2022-04-19T00:00:00",
    ProjectFinishDate: "2023-04-19T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 40,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "5000000.000000",
    ContractValue: "5000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "1000000.00",
    RemainingAmount: "4000000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جمعية أعمال للتنمية الأسرية",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "40",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "جاري تنفيذ الورش على مستوى مناطق المملكة حتى 10 ديسمبر 2023م.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "5000000.00",
    SpentYearBudget: "1000000.000000",
  },
  {
    ProjectUID: "b7430586-4f99-ec11-8b00-98566de81707",
    ProjectName: "وزرد التحليل المالي",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-075",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خواطر احمد عبدالله الخويطر Khawater A Alkhowaiter",
    ProjectDescription: null,
    ProjectStartDate: "2022-05-01T00:00:00",
    ProjectFinishDate: "2022-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 32,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "32",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "في مرحلة التطوير",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: "ابراهيم علي حسين حبتري ibrahim a. habtari",
    sector_efada:
      "يتم العمل على التطوير التقني للمشروع بعد اشعار الإدارات المعنية ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "dfd277e7-780e-4581-83a1-4260f09c90df",
    ProjectName: "خدمات تنفيذ الية العمل للمنتجات - خدمات تقنية",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-026",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription:
      "\r\nتنفيذ الية العمل لمنتجات المنشآت - خدمات تقنية\r\n",
    ProjectStartDate: "2022-07-25T00:00:00",
    ProjectFinishDate: "2023-07-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 18,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "30000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "18",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada: "إجراءات توقيع العقد والاجتماع مع الشركة ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "faa132de-476b-4191-bbe6-7da27abf3a6d",
    ProjectName: "تأهيل جادة الرياض (تنفيذ الاعمال الهندسية لجادة 30 الرياض)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-129",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      "تأهيل جادة الرياض (تنفيذ الاعمال الهندسية لجادة 30 الرياض)",
    ProjectStartDate: "2022-08-01T00:00:00",
    ProjectFinishDate: "2022-10-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 11,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2500000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "11",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada:
      "متأخر في اجراءات الترسية وهو لدى لجنة فحص العروض الثانية من تاريخ 19 يوليو، والآن بمرحلة التأهيل منذ 3 أغسطس",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2500000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ef35725a-fd8a-419a-8ef8-17157619590b",
    ProjectName: "تطوير قسم اختبار التطبيقات 2021-2023",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-014",
    ProjectOwner: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    boardinitiative: "لا",
    ProjectManager: "نجلاء عبدالرحمن ناصر الشلفان Najla Al-Shalfan",
    ProjectDescription: "تطوير قسم اختبار التطبيقات 2021-2023",
    ProjectStartDate: "2022-02-06T00:00:00",
    ProjectFinishDate: "2025-02-06T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 27,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "3500000.000000",
    ApprovedBudget: "4169997.750000",
    ContractValue: "4169997.750000",
    RevisedContractValue: "4169997.750000",
    PaidAmount: "57500.00",
    RemainingAmount: "3961497.860000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "شركة طاقم الاعمال التوسعية للتجارة ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يوسف حمد الدخيل Yousuf H. AlDakhil",
    ProjectOfficerContact: " ",
    sector_efada:
      "جاري العمل على: 1)انشاء بيئة العمل الاختبارية 2)توريد وتركيب وتشغيل ادوات الاختبار 3)تطوير الوثائق والاجراءات 4)مرحلة المشروع التجريبي 5)تطوير فريق العمل 6)مرحلة التقييم الغير رسمي ",
    pmo_efada: "تم توقيع العقد و حالياً بانتظار ميثاق المشروع و خطة المشروع ",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "57500.000000",
  },
  {
    ProjectUID: "b966c453-4e02-4c59-a679-d094fb20351f",
    ProjectName: "الخسائر الائتمانية المتوقعة",
    Department: "إدارة الإئتمان",
    ProjectCode: "BU-22-017",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالله حسان عطيه Abdallah H. Attia",
    ProjectDescription: "الخسائر الائتمانية المتوقعة",
    ProjectStartDate: "2022-08-01T00:00:00",
    ProjectFinishDate: "2023-07-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "خدمات استشارية",
    EstimatedBudget: null,
    ApprovedBudget: "6000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تحقيق الاستدامة المالية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "عبدالمجيد صالح الكريديس Abdulmajed S. AlKriedees",
    ProjectOfficerContact: "Hassan F. Algarni",
    sector_efada: "تم انتقال المشروع الي قطاع المالية ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "6000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6bd373d7-0e68-4484-9254-d128146b2e0a",
    ProjectName: "تطبيق استراتيجية التحول الرقمي",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-067",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عفراء علي محمد السويلم Afra A Alswailem",
    ProjectDescription: "تطبيق استراتيجية التحول الرقمي",
    ProjectStartDate: "2022-05-31T00:00:00",
    ProjectFinishDate: "2023-05-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 27,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1791700.000000",
    ContractValue: "1737650.000000",
    RevisedContractValue: "1737650.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "شركة ديفوتيم السعودية المحدودة",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم ظهور نتائج التقييم الأولية وجاري الأخذ بالملاحظات استعداداً لتصحيح الأدلة",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1737650.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "807c599e-f574-eb11-8af1-005056921d78",
    ProjectName: "تأسيس وتشغيل مساحة العمل المشترك المرحلة الأولى (جادة 30)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-20-003",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      "توفير بيئة عمل جاذبة لرواد الاعمال وأصحاب المنشآت لخلق فرص تمويلية من قبل البنك",
    ProjectStartDate: "2020-04-22T00:00:00",
    ProjectFinishDate: "2023-10-21T00:00:00",
    BIProjectStartDate: "2020-04-22T08:00:00",
    BIProjectFinishDate: "2023-10-21T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 54,
    BudgetItemNo: "2411211",
    BudgetItemName: "الترميمات والتحسينات",
    EstimatedBudget: "22999200.000000",
    ApprovedBudget: "22999200.000000",
    ContractValue: "22999200.000000",
    RevisedContractValue: "22999200.000000",
    PaidAmount: "12380910.00",
    RemainingAmount: "10618290.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "أماكن الاعمال المحدودة",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "54",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "غدير الحارثي Gadeer Alharthi",
    sector_efada: "تم استلام فرعي تبوك وخميس مشيط والبدء بالتشغيل التجريبي",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6ae49406-559d-ec11-8b02-0050569272df",
    ProjectName: "تطوير نظام إدارة المشاريع ورفع الحوكمة",
    Department: "مكتب إدارة المشاريع المؤسسي",
    ProjectCode: "ST-22-001",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "امل سعد خنجي Amal S. Khunji",
    ProjectDescription: null,
    ProjectStartDate: "2022-03-21T00:00:00",
    ProjectFinishDate: "2023-03-20T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 26,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "4000000.000000",
    ContractValue: "3991605.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة نود لتقنية المعلومات",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "فهد عبدالرحمن محمد الرواف fahad a. alrawaf",
    ProjectOwner1: "عبدالله عبدالعزيز الناصر Abdullah A. Alnasser",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة الترسية",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "3bb4f78b-14cd-43f0-b77f-7cb73aed2969",
    ProjectName:
      "اعداد دراسات بحثية اقتصادية وتحليلية لقياس الأثر الاقتصادي والاجتماعي لمنتجات البنك",
    Department: "إدارة قياس الأثر",
    ProjectCode: "ST-21-022",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "سمير سراج عثمان فلاته sameer s. fallatah",
    ProjectDescription:
      "اعداد وتطوير دراسات بحثية اقتصادية وتحليلية لقياس الأثر الأقتصادي والاجتماعي لمنتجات بنك التنمية الاجتماعية",
    ProjectStartDate: "2022-03-10T00:00:00",
    ProjectFinishDate: "2022-09-10T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 26,
    BudgetItemNo: "2310",
    BudgetItemName: "الخدمات الاستشارية",
    EstimatedBudget: "3000000.000000",
    ApprovedBudget: "2998000.000000",
    ContractValue: "2998000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة المجمعة",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "عبدالمجيد عبدالرحمن بن رشيد Abdulmajeed A. Binrushaid",
    ProjectOfficerContact: " ",
    sector_efada: null,
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "2998000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ec7ee3e4-8d74-eb11-8af0-005056921d78",
    ProjectName: "تطبيق وتشغيل مكتب البنية المؤسسية لإدارة تقنية المعلومات",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-025",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "كامل صطام جراد Kamel S Jarad",
    ProjectDescription: null,
    ProjectStartDate: "2022-01-27T00:00:00",
    ProjectFinishDate: "2025-01-26T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 25,
    BudgetItemNo: "2413115",
    BudgetItemName: "",
    EstimatedBudget: "4800000.000000",
    ApprovedBudget: "4800000.000000",
    ContractValue: "4800000.000000",
    RevisedContractValue: "5999181.000000",
    PaidAmount: "935132.01",
    RemainingAmount: "5064049.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "التطبيقات",
    AwardedCompany: "شركة ديفوتيم السعودية المحدودة",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 58096,
    ActualResourceHours: 17319,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الانتهاء من استراتيجية البنية المؤسسية وجاري العمل على اعتمادها ، بالتوازي مع العمل على توثيق الوضع الحالي للاعمال والتطبيقات والبيانات والتقنية وأمن المعلومات ",
    pmo_efada: "تم توقيع العقد و حالياً بانتظار ميثاق المشروع و خطة المشروع ",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "957794fe-5dae-4926-9b6c-dbc044f990a0",
    ProjectName: "تنفيذ الية العمل للمنتجات - خدمات استشارية",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-047",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription:
      "يهدف هذا المشروع الي تطبيق الحل التقني لتطوير النموذج التشغيلي لمنتجات التمويل لعملاء بنك التنمية الاجتماعية في قطاع الأعمال ، من خلال تطوير وتنفيذ 10 منتجات تمويلية لقطاع الاعمال كما سيتم تنفيذ هذا المشروع بالتزامن مع اطلاق مشروع (تنفيذ الية العمل لمنتجات المنشآت - خدمات تقنية",
    ProjectStartDate: "2022-07-25T00:00:00",
    ProjectFinishDate: "2023-07-25T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 18,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "12000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "18",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada: "إجراءات توقيع العقد والاجتماع مع الشركة ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "8000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "085d106c-6c74-eb11-8af0-005056921d78",
    ProjectName: "تطوير تطبيق التحليل المالي على الأجهزة الذكية",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-21-051",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "خواطر احمد عبدالله الخويطر Khawater A Alkhowaiter",
    ProjectDescription:
      "تحسين التطبيق الحالي وفق متطلبات القطاع - المرحلة الأولى - اتاحة بقية خدمات الادخار",
    ProjectStartDate: "2022-03-09T00:00:00",
    ProjectFinishDate: "2022-09-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 36,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "5000000.000000",
    ApprovedBudget: "5000000.000000",
    ContractValue: "1840000.000000",
    RevisedContractValue: "1840000.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "التطبيقات",
    AwardedCompany: "شركة ترميز الرقمية ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "36",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "تم استلام وثيقة متطلبات الأعمال بتاريخ 1/8 وجاري مراجعتها",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التنفيذ: حسب المخطط .",
    pmo_efada: "",
    cat_efada: "التطبيقات ",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "89f236ae-0977-4672-b1cb-5bc59d4126cc",
    ProjectName: "توريد وتركيب نظام ادارة المواقف والزوار",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-107",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "معاذ احمد محمد بامسعود muath a. bamasoud",
    ProjectDescription:
      "توريد وتركيب نظام ادارة المواقف والزوار وربطه مع نظام الدخول والخروج والحضور الالكتروني لبنك التنمية الاجتماعية بالإدارة العامة بحي الغدير",
    ProjectStartDate: "2022-04-20T00:00:00",
    ProjectFinishDate: "2022-08-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 24,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1599995.000000",
    ContractValue: "1599995.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "مؤسسة البرامج الدوليه ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 648,
    ActualResourceHours: 329,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada:
      "نود الاحاطة حتى تاريخه لم يتم اعتماد الأجهزة التقنية من قبل إدارة تقنية المعلومات ، لذا قد يكون هناك تأخير في تسليم المشروع بالتاريخ المحدد مسبقاً",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "f704c371-b574-eb11-8af0-005056921d78",
    ProjectName: "معالجة المعلقات المالية",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-21-005",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "حماد عبدالله صالح المحيسن Hammad A. AlMuhaysin",
    ProjectDescription: null,
    ProjectStartDate: "2021-12-20T00:00:00",
    ProjectFinishDate: "2022-12-20T00:00:00",
    BIProjectStartDate: "2021-02-22T08:00:00",
    BIProjectFinishDate: "2022-12-20T17:00:00",
    PlannedCompletePercent: "57",
    ActualCompletePercent: 23,
    BudgetItemNo: "2301826",
    BudgetItemName: "خدمات استشارية لمعالجة المعلقات المالية",
    EstimatedBudget: "2500000.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "2750000.000000",
    RevisedContractValue: "2750000.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة الامير سطام",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم البدء بمطابقة حسابات الإدارة العامة والفروع بشكل كامل والتحقق من قاعدة البيانات المستلمة ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "2750000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b2233eae-5e58-4cc7-ab58-1114dbd3b1b2",
    ProjectName:
      "تعهيد وتشغيل عمليات التمويل لمنتج أفق من خلال التقنيات المالية",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-20-115",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription:
      "تعهيد وتشغيل عمليات التمويل لمنتج أفق من خلال التقنيات المالية ",
    ProjectStartDate: "2022-06-01T00:00:00",
    ProjectFinishDate: "2024-05-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 20,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "BEEHIVE",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "20",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عبدالعزيز حسن خليل الاحمدي Abdulaziz H. AlAhmadi",
    sector_efada:
      "تم تسليم وثيقة متطلبات الأعمال وخطة المشروع بتاريخ 1/8/2022 تم البدء بالاختبارات التجريبية بالمرحلة الأولى بتاريخ 2/8/2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ac31de83-c06a-4ab1-96df-9d867dfbd25e",
    ProjectName: "دراسات استشارية لتطوير منتجات التمويل الاجتماعي",
    Department: "إدارة تمويل الأفراد",
    ProjectCode: "BU-22-007",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هند مياح الحربي Hind M Alharbi",
    ProjectDescription: "دراسات استشارية لتطوير منتجات التمويل الاجتماعي",
    ProjectStartDate: "2022-09-21T00:00:00",
    ProjectFinishDate: "2023-05-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 13,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "13",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم اعتماد معايير نموذج التأهيل اللاحق للشركة بتاريخ 2 أغسطس وسيتم الانتهاء من اكمالها بمنصة اعتماد خلال الأسبوع القادم ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b457dcd0-2c2c-4c7b-8420-b54a5c7ab993",
    ProjectName: "تقديم الخدمات غير المالية للمشاريع متناهية الصغر والعمل الحر",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-127",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "بدر سليمان عبدالرحمن العكيل BADR S. ALAKEEL",
    ProjectDescription:
      "تقديم الخدمات غير المالية من خلال برامج واستشارات موجهه لأصحاب المشاريع وأصحاب الأفكار لتمكينه ومساعدتهم لاكتشاف مشاريعه او تجويل أفكارهم الى مشاريع واقعية",
    ProjectStartDate: "2022-08-31T00:00:00",
    ProjectFinishDate: "2023-08-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 11,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "24906500.000000",
    ContractValue: "24906500.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "24906500.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "11",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "بدر سليمان عبدالرحمن العكيل BADR S. ALAKEEL",
    sector_efada:
      "تم استلام العروض الفنية في 28 يونيو وجاري العمل على إنهاء التقييم الفني.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "68e05623-2a75-eb11-8af1-005056921d78",
    ProjectName: "إستبدال نظام الاتصالات الإدارية",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-21-021",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالله سليمان عبدالله الحمود ABDULLAH S. ALHAMOD",
    ProjectDescription: null,
    ProjectStartDate: "2022-02-13T00:00:00",
    ProjectFinishDate: "2024-03-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 21,
    BudgetItemNo: "3112",
    BudgetItemName: "تقنية المعلومات ",
    EstimatedBudget: "3500000.000000",
    ApprovedBudget: "3500000.000000",
    ContractValue: "895896.000000",
    RevisedContractValue: "895896.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "شركة أعمال الحلول المترابطة",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada:
      "جاري العمل على اختبار نظام اللجان وتدريب المستخدمين على وظائف النظام ",
    pmo_efada: "",
    cat_efada: "الأنظمة و التطوير",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "78120924-a6f2-427d-9a6e-585f69ddb40c",
    ProjectName: "التطوير الالكتروني للخدمات الغير مالية للأسر المنتجة",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-028",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "أمل محمد المحيميد Amal M. Almohaimeed",
    ProjectDescription: "اطلاق منصة الخدمات غير المالية",
    ProjectStartDate: "2022-06-08T00:00:00",
    ProjectFinishDate: "2022-12-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 11,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "2300000.000000",
    ContractValue: "2300000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "2300000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "المنصات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "اصدار التوصية",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "11",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: '"تم ارسال التقييم النهائي الخاص بالمتطلبات التقنية "',
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الانتهاء من التقييم الفني بتاريخ 30 يونيو , واستلام ملاحظات لجنة فحص العروض الثانية بتاريخ 2 أغسطس والرد عليها من قبل قطاع الاعمال في حينه.",
    pmo_efada:
      "مسمى سابق (تطوير منظومة الخدمات غير المالية (بوابة رقمية للبرامج والمنتجات) ",
    cat_efada: "المنصات",
    YearBudget: "2300000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "4ba6e9da-f399-ec11-8b01-0050569272df",
    ProjectName:
      "تمويل شريحة القطاع الخاص بشكل مؤتمت بالكامل (مسار بوابة الجهات الحكومية)",
    Department: "إدارة تمويل الأفراد",
    ProjectCode: "BU-22-104",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالله ابراهيم عبدالرحمن الفايز Abdullah I. Al-Fayez",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-25T00:00:00",
    ProjectFinishDate: "2022-09-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 20,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "20",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "في مرحلة التطوير",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "فيصل شباب الغامدي Faisal S. Alghamdi",
    sector_efada:
      "تم اكتمال و تسليم كافة المتطلبات و الوثائق اللازمة و مراجعتها و معالجة ملاحظات شريك الاعمال عليها ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "a8497ef5-f799-ec11-8b02-0050569272df",
    ProjectName: "ربط قاعدة بيانات مركز جنى",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-22-109",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هدى عثمان احمد الزهراني huda o. alzahrani",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-25T00:00:00",
    ProjectFinishDate: "2022-09-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 20,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "20",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "ضمن الاطلاق الثاني لمنصة الأسر المنتجة",
    PlannedResourceHours: 568,
    ActualResourceHours: 113,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "Saad Saud Almutairi",
    sector_efada:
      "يتم التنفيذ كجزء من منصة الاسر المنتجة الجديدة في المرحلة الثانية للاطلاق المنتهية في 15 سبتمبر",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "0fc8470b-fb80-4d10-a798-9416702792f7",
    ProjectName:
      "تأهيل وتجهيز فروع بنك التنمية الاجتماعية بوسائط سمعية وبصرية لعدد (14) فرع",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-021",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "تطوير منظومة الفروع لعدد ( 14 ) فرع",
    ProjectStartDate: "2022-06-01T00:00:00",
    ProjectFinishDate: "2023-12-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 11,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "28000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "اصدار التوصية",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "11",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "رميح عبدالرحمن صالح الرميح romaih a. alromaih",
    sector_efada:
      "تم ايقاف المشروع لطلب موافقة هيئة كفاءة الانفاق على البنود في 20 يوليو، وتمت الموافقة والان المشروع في مرحلة التأهيل منذ 2 اوغسطس ",
    pmo_efada:
      "مسمى سابق تطوير منظومة الفروع لعدد 14 فرع (المرحلة الثانية وتشمل 7 فروع)",
    cat_efada: null,
    YearBudget: "14000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "2703aff6-3ab5-48ba-b472-cdb74bc87497",
    ProjectName: "مشروع مراجعة الضمانات وإعادة تقييمها",
    Department: "إدارة الإئتمان",
    ProjectCode: "BU-22-010",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "محمد فيصل محمد العتيبي Mohammed F. AlOtaibi",
    ProjectDescription: "مشروع مراجعة الضمانات وإعادة تقييمها",
    ProjectStartDate: "2022-07-31T00:00:00",
    ProjectFinishDate: "2023-07-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 13,
    BudgetItemNo: "",
    BudgetItemName: "الخدمات الاستشارية",
    EstimatedBudget: null,
    ApprovedBudget: "5000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "اعتماد محضر فحص العروض",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "13",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "عبدالمجيد صالح الكريديس Abdulmajed S. AlKriedees",
    ProjectOfficerContact: " ",
    sector_efada: "اعداد واعتماد محضر لجنة فحص العروض ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2500000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "5475eb06-556b-4dec-b2d6-1e5c53aaf23b",
    ProjectName: "تطوير وبناء السوق الالكتروني لمنتج تمويل السيارات",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-22-022",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "عبدالله احمد العودان Abdullah A Alodan",
    ProjectDescription: "تطوير وبناء السوق الالكتروني لمنتج تمويل السيارات",
    ProjectStartDate: "2022-03-24T00:00:00",
    ProjectFinishDate: "2022-12-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 17,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "5002500.000000",
    ContractValue: "5002500.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "5002500.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "17",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "إفادتنا بالترسية مع شركة شور والمشروع في مرحلة إعداد العقد",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "محمد إبراهيم علي العريني Mohammed I. Al Orini",
    ProjectOfficerContact: "منيره عبدالله علي السديس Muneera A. AlSudays",
    sector_efada:
      "في مرحلة التعاقد.تم عقد اجتماعات مبدئية مع الشركة المنفذة للتخطيط للمشروع",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "5002500.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6779a8e3-0b95-496f-b25c-6458594e31e0",
    ProjectName: "إقامة ملتقيات الفروع التطويرية",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-128",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "مقرن سعود الوبران Mugren S. Alwabran",
    ProjectDescription: "إقامة ملتقيات الفروع التطويرية",
    ProjectStartDate: "2022-08-31T00:00:00",
    ProjectFinishDate: "2023-08-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 13,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "اعتماد محضر فحص العروض",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "13",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم ارسال التقييم الفني إلى لجنة فحص العروض بتاريخ 15/5/2022، في مرحلة التأهيل اللاحق من تاريخ 20/6/2022،، تم الغاء دعودة التأهيل بتاريخ 2022/6/23 م لعدم استكمال بعض المستندات للجنة فحص العروض وجاري طلب مستندات من الشركة بشان مجال التصنيف بتاريخ 2022-6",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "887791fe-70e4-45ef-aadf-52f70f3793fa",
    ProjectName: "مشروع تنفيذ خدمات إبداعية للبنك ومنتجاته",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-025",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "سندس محمد جان Sondos M. Jan",
    ProjectDescription: "مشروع تنفيذ خدمات إبداعية للبنك ومنتجاته",
    ProjectStartDate: "2022-08-15T00:00:00",
    ProjectFinishDate: "2023-08-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 17,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية ",
    EstimatedBudget: null,
    ApprovedBudget: "9000000.000000",
    ContractValue: "8934000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة اكوان للدعاية والاعلان ",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التعاقد",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "9000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "946998cc-9ff8-4be0-a966-598a609a96bb",
    ProjectName: "خدمات قانونيه لما بعد تحول رأس المال البشري",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-21-034",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "ندى سعد الفليج Nada s alflaij",
    ProjectDescription: "خدمات قانونيه لما بعد تحول رأس المال البشري",
    ProjectStartDate: "2022-03-27T00:00:00",
    ProjectFinishDate: "2023-03-26T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 17,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2636000.000000",
    ContractValue: "2527754.620000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة المجمعة ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "2322a00c-c99e-ec11-8b02-0050569272df",
    ProjectName: "تفعيل التميّز التشغيلي والمؤسسي ونشر ثقافتها لتعزيز الأداء",
    Department: "إدارة تميز العمليات",
    ProjectCode: "SS-22-008",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "نعم",
    ProjectManager: "بدر عبدالمحسن عقيش Bader A. Augaish",
    ProjectDescription: null,
    ProjectStartDate: "2022-03-27T00:00:00",
    ProjectFinishDate: "2022-12-26T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 16,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: "1183765.000000",
    ContractValue: "1183765.000000",
    RevisedContractValue: "1183765.000000",
    PaidAmount: "0.00",
    RemainingAmount: "1183765.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: null,
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبداللطيف محمد عرفه ABDULATEEF M ARAFA",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التنفيذ ويسير حسب المخطط",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "1400000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "1e2c0a48-bdfb-4f60-a14c-023877dc4dc8",
    ProjectName: "إقامة فعاليات العمل الحر",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-22-015",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عادل عبدالله سعد الجويان adel a aljoyan",
    ProjectDescription: "إقامة فعاليات العمل الحر ",
    ProjectStartDate: "2022-09-01T00:00:00",
    ProjectFinishDate: "2024-09-29T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 13,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2300000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "اصدار التوصية",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "13",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "محمد إبراهيم علي العريني Mohammed I. Al Orini",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم تشكيل اللجنة الفنية بتاريخ 16 يونيو 2022 وتم الانتهاء من التقييم الفني وجاري العمل على فتح العروض المالية ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2300000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "58536f23-0558-4a0b-900d-1d0859d18c96",
    ProjectName: "تقديم خدمات عملية التحصيل المنشآت",
    Department: "إدارة متابعة وتحصيل المنشأت",
    ProjectCode: "BU-22-005",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "فهد عبدالله محمد الفرحان FAHAD A. ALFRHAN",
    ProjectDescription: "تقديم خدمات عملية التحصيل المنشآت",
    ProjectStartDate: "2022-08-01T00:00:00",
    ProjectFinishDate: "2023-08-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 8,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "50600000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "8",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تحقيق الاستدامة المالية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "ماجد فهد محمد المديان MAJED F. ALMADYAN",
    ProjectOfficerContact: " ",
    sector_efada:
      " تم استلام ايميل بتاريخ 7-6-2022 من إدارة العقود والمشتريات يتضمن افادة هيئة كفاءة الانفاق بان يتم مخاطبة وزارة لمالية وفقاً للمادة 95 وعليه تم محاطبة وزارة المالية من قبل إدارة العقود والمشتريات تاريخ 21-7-2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "40480000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "c4718da4-5499-ec11-8b00-98566de81707",
    ProjectName:
      "تطوير الية التقديم و الية العمل الداخلية لإدارة المشاريع الناشئة (المرحلة الأولى)",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-088",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-01T00:00:00",
    ProjectFinishDate: "2022-11-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 20,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "20",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "تم تزويدنا بوثيقة متطلبات الاعمال بعد عقد ورش العمل وجاري مراجعتها",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "ABDULAZIZ SAUD ALHARBI",
    sector_efada:
      "تم معالجة ملاحظات التقنية للمرة الرابعة ، وعقد أربعة ورش عمل لمناقشتها ، وإرسالها للتقنية للاعتماد النهائي بتاريخ 1/8/2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "c9f0ded3-bcb3-46ed-882a-9a08b3486e90",
    ProjectName:
      "منافذ بيع مؤقتة للأسر المنتجة لفعاليات اليوم الوطني (سوق الدار 92)",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-031",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هاله مساعد صقر الروقي Hallah M. Alroqi",
    ProjectDescription: "مبادرة 92 فعالية",
    ProjectStartDate: "2022-07-01T00:00:00",
    ProjectFinishDate: "2023-01-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 10,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "10000000.000000",
    ContractValue: "10000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "10000000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "10",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الانتهاء من تقييم العروض وارسالها الى لجنة فحص العروض متوقع ان يتم اصدار التوصية في 4 اوغسطس",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "10000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "e196ac34-f999-ec11-8b02-0050569272df",
    ProjectName: "أتمتة خدمات الفروع لعملاء القروض الاجتماعية",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-112",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: null,
    ProjectStartDate: "2021-11-01T00:00:00",
    ProjectFinishDate: "2023-06-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 20,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "20",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "Khalid Abdulaziz Alothman",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "a2033fa4-d39e-ec11-8b02-0050569272df",
    ProjectName: "اتفاقية سمة",
    Department: "إدارة العمليات البنكية",
    ProjectCode: "SS-22-042",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "تركي صالح محمد اليوسف Turki Al Yousef",
    ProjectDescription: null,
    ProjectStartDate: "2022-01-01T00:00:00",
    ProjectFinishDate: "2024-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 14,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "48000000.000000",
    ContractValue: "48000000.000000",
    RevisedContractValue: null,
    PaidAmount: "4719537.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبدالعزيز عبدالله عثمان العتيق abdulaziz a. alateeq",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "11600000.00",
    SpentYearBudget: "4719537.000000",
  },
  {
    ProjectUID: "b1d0ffcc-d174-eb11-8af0-005056921d78",
    ProjectName: "مشروع تنفيذ برنامج امبرتك",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-20-016",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "غاده عبدالله الحربي Gadah A Alharbi",
    ProjectDescription: "إقامة ورش تنمية المهارات السلوكية لرواد الأعمال",
    ProjectStartDate: "2020-02-20T00:00:00",
    ProjectFinishDate: "2024-02-20T00:00:00",
    BIProjectStartDate: "2020-11-17T08:00:00",
    BIProjectFinishDate: "2024-07-01T17:00:00",
    PlannedCompletePercent: "0",
    ActualCompletePercent: 45,
    BudgetItemNo: "25424",
    BudgetItemName: "بيت المحترف",
    EstimatedBudget: "9530137.500000",
    ApprovedBudget: "9530137.500000",
    ContractValue: "9530137.500000",
    RevisedContractValue: "0.000000",
    PaidAmount: "2859041.25",
    RemainingAmount: "6671096.250000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جمعية ريادة الاعمال",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "45",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "غاده عبدالله الحربي Gadah A Alharbi",
    sector_efada:
      "سيتم تعديل اتفاقية هذا المشروع بحيث يتم من خلالها فقط الإشراف على تنفيذ الورش في مشروع (توسيع نطاق امبريتك) مقابل رسوم إدارية, وفك الارتباط عن باقي المبلغ.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "a2bf0174-2375-eb11-8af1-005056921d78",
    ProjectName: "تطوير بوابة الكترونية للتقييم الذاتي لوسطاء التمويل",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-21-011",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "هدى عثمان احمد الزهراني huda o. alzahrani",
    ProjectDescription: "تقييم الجهات الشريكة ذاتيا من خلال منصة الكترونية",
    ProjectStartDate: "2021-09-01T00:00:00",
    ProjectFinishDate: "2023-10-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 24,
    BudgetItemNo: "",
    BudgetItemName: "الاسر المنتجة",
    EstimatedBudget: "1700000.000000",
    ApprovedBudget: "1700000.000000",
    ContractValue: "1187743.000000",
    RevisedContractValue: "1187743.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "الشركة الوطنية لخدمة البيانات والحلول المتكاملة",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "24",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "في مرحلة التطوير من الشركة واعتماد الخطة",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم اعتماد وثيقة توصيف المتطلبات البرمجية SRS في 26 يوليو. جاري العمل على وثائق التكامل مع الانظمة وتصاميم الواجهات ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1187743.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "3c513365-f799-ec11-8b02-0050569272df",
    ProjectName: "مشاركة الجمعيات في التمويل المباشر",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-22-108",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هدى عثمان احمد الزهراني huda o. alzahrani",
    ProjectDescription: null,
    ProjectStartDate: "2022-10-01T00:00:00",
    ProjectFinishDate: "2022-12-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 20,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (1)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "20",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "في حاجة لإفادة تقنية المعلومات بحالة المشروع",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "Saad Saud Almutairi",
    sector_efada:
      "الجزء الاول: تم توضيح متطلبات التغيير على مسار التمويل النقدي للعمل الحر وفي انتظار رفع طلب التغيير من الادارة المالكة. الجزء الثاني: تم اعداد وتسليم وثيقة متطلبات الاعمال للتغيير على نظام زيارات المشروع لتقنية المعلومات في 23 مارس",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "e74e6e98-6314-4c57-8a1b-827a463f8098",
    ProjectName:
      "تقييم الثغرات الأمنية واختبار الاختراق ومراجعة الأكواد البرمجية",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-21-031",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "طارق سليمان المحمود Tarek S Almahmoud",
    ProjectDescription:
      "تقييم الثغرات الأمنية واختبار الاختراق ومراجعة الأكواد البرمجية ",
    ProjectStartDate: "2021-11-07T00:00:00",
    ProjectFinishDate: "2024-11-07T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 13,
    BudgetItemNo: "3115",
    BudgetItemName: "تقنية المعلومات 2020",
    EstimatedBudget: "672175.000000",
    ApprovedBudget: "672175.000000",
    ContractValue: "672175.000000",
    RevisedContractValue: "672175.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "مؤسسة رموز التقنيات للأمن السيبراني",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    ProjectOfficerContact: " ",
    sector_efada: "في التنفيذ ويسير حسب المخطط",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "47b711cf-aa09-408b-971b-897363790a2f",
    ProjectName: "الخارطة التفاعلية",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-063",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectDescription: "تصميم ونشر خارطة تفاعلية للخدمات المقدمة\r\n",
    ProjectStartDate: "2022-04-15T00:00:00",
    ProjectFinishDate: "2022-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 12,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "500000.000000",
    ContractValue: "500000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "500000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "اصدار التوصية",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "12",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "تم ارسال التقييم النهائي للعروض الفنية للشركات لقطاع الاعمال",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "سعيد صالح عبدالله الزهراني saeed s. alzahrani",
    ProjectOfficerContact: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    sector_efada:
      "تم الانتهاء من تقييم العروض الفنية بعد طلب ادارة تقنية المعلومات لخطابات التزام من الشركات، وحاليا في مرحلة التأهيل اللاحق.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d2d0c54b-a579-476b-8dda-2663c1f4a531",
    ProjectName: "منافذ البيع الدائمة",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-030",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز مطر اللويحق Abdulaziz M Alluwaihiq",
    ProjectDescription: "منافذ البيع الدائمة",
    ProjectStartDate: "2022-10-30T00:00:00",
    ProjectFinishDate: "2023-07-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 6,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "89750000.000000",
    ContractValue: "89750000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "89750000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "6",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "سيتم تشغيله من خلال اتفاقيات.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "fe123629-fc86-4c95-bea7-633fa36b58da",
    ProjectName: "تجسير الأسر المنتجة",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-034",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منى عبدالكريم الشمري Mona A alshamri",
    ProjectDescription: "تجسير الأسر المنتجة",
    ProjectStartDate: "2022-09-29T00:00:00",
    ProjectFinishDate: "2023-09-29T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 10,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "12000000.000000",
    ContractValue: "12000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "12000000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "10",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "جودي سالم صالح الدبيبي Judi S. Aldibibi",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "منى عبدالكريم الشمري Mona A alshamri",
    sector_efada:
      "تم طرح الكراسة في 23 يونيو 2022م, تم استلام عدد 6 عروض فنية بتاريخ 31 يوليو , وجاري تقييمها حاليا , متوقع الانتهاء من التقييم بتاريخ 8 أغسطس",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "12000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "cf190ba4-32fe-474b-91d1-b91d54814d8a",
    ProjectName:
      "توريد أجهزة تقنية المعلومات لجادة الرياض (إعداد مواصفات - تقييم فني - مراجعة واستلام)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-116",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      "توريد أجهزة تقنية المعلومات لجادة الرياض (إعداد مواصفات - تقييم فني - مراجعة واستلام)",
    ProjectStartDate: "2022-05-31T00:00:00",
    ProjectFinishDate: "2022-07-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 43,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1950000.000000",
    ContractValue: "1649998.000000",
    RevisedContractValue: "1649998.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "حلول الانظمة المرنة للاتصالات",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "43",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تحقيق الاستدامة المالية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "غدير الحارثي Gadeer Alharthi",
    sector_efada: "تمت التسرية في 23 مايو وتم توقيع العقد في 12يونيو",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1649998.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6735b519-dc25-4989-b19d-14dd158e9118",
    ProjectName: "مشروع تشغيل إدارة حملات التسويق في قنوات التواصل الإجتماعية",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-020",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "حنان عبدالرحمن الدليمي Hanan A. Al Delaimi",
    ProjectDescription:
      "مشروع تشغيل إدارة حملات التسويق في قنوات التواصل الإجتماعية ",
    ProjectStartDate: "2022-03-28T00:00:00",
    ProjectFinishDate: "2023-03-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 10,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية ",
    EstimatedBudget: "2699050.000000",
    ApprovedBudget: "2498835.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "2498835.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة الوقفة الكاملة للدعاية والإعلان (فول ستوب )",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "خالد راشد الثويني Khaled R Althowaini",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: "دانيا عثمان المنيع Dania O. Almanea",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2498835.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "5e93c1bc-c5c3-4386-92a3-513c34e99ca0",
    ProjectName: "مشروع تطوير محفظة الكترونية ادخارية من خلال تطبيق أجهزة ذكية",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-002",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "فارس حمد محمد بن جميعة Faris H. Bin Jumayah",
    ProjectDescription:
      "مشروع تطوير محفظة الكترونية ادخارية من خلال تطبيق أجهزة ذكية",
    ProjectStartDate: "2022-05-22T00:00:00",
    ProjectFinishDate: "2023-02-22T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 13,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3500000.000000",
    ContractValue: "3500000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "اصدار التوصية",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "13",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: " لم يتم استلام المتطلبات ",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: "ابراهيم علي حسين حبتري ibrahim a. habtari",
    sector_efada:
      "تم استبعاد العرض الاول من قبل لجنة فحص العروض وذلك بسبب تأخر الشركة في تزويد اللجنة بتصنيف المقاولين , وتم الاجتماع مع الشركة الثانية لتخفيض عرضها المالي وتم استلام موافقتها بتاريخ 3 أغسطس. ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "f2081216-a40b-4991-9f60-5dbb3bf4b273",
    ProjectName: "دراسة وضع آلية لاحتساب حجم مبيعات الاسر المنتجة",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-22-039",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هديل عبدالله إبراهيم فرساني Hadeel A. Farasani",
    ProjectDescription: "دراسة وضع آلية لاحتساب حجم مبيعات الاسر المنتجة ",
    ProjectStartDate: "2022-09-29T00:00:00",
    ProjectFinishDate: "2023-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 8,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "8",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: " ",
    sector_efada: "تم طرح الكراسة وتاريخ فتح العروض في 4 اغسطس",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "a7fb9950-3106-4b1e-82da-aa8f3fd5a531",
    ProjectName: "تأهيل فروع البنك في (جدة، مكة المكرمة، المدينة المنورة)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-130",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription:
      "تأهيل فروع البنك في (جدة، مكة المكرمة، المدينة المنورة)",
    ProjectStartDate: "2022-11-01T00:00:00",
    ProjectFinishDate: "2023-10-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 6,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: "4922633.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: null,
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "6",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: null,
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "29d2f9d7-d85d-4d09-88ae-bd939b54d5bf",
    ProjectName: "مراجعة نظام التصنيف الائتماني والتقييم الذاتي فنيا وتقنيا",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-22-120",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هدى عثمان احمد الزهراني huda o. alzahrani",
    ProjectDescription:
      "مراجعة نظام التصنيف الائتماني والتقييم الذاتي فنيا وتقنيا\r\n\r\n",
    ProjectStartDate: "2022-06-01T00:00:00",
    ProjectFinishDate: "2023-11-23T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 8,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "3500000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "8",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: " ",
    sector_efada: "تم الطرح وتقدمت شركتين حتى تاريخ 9 اغسطس",
    pmo_efada: "من مشاريع التحول الوطني",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "21db326f-04af-43f0-ac80-005199b779b1",
    ProjectName: "التأهيل والتدريب المختص لمنسوبي الشركاء في القطاع غير الربحي",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-032",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "اسماء مبارك بالعبيد Asma M. Balobaid",
    ProjectDescription: "تأهيل العاملين في القطاع الغير ربحي ",
    ProjectStartDate: "2022-09-29T00:00:00",
    ProjectFinishDate: "2023-09-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 10,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "5000000.000000",
    ContractValue: "5000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "5000000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "10",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم طرح الكراسة 27 يونيو 2022م, تم استلام العروض الفنية في 27 يوليو وفي مرحلة التقييم الفني ومتوقع الانتهاء منها في 4 أغسطس",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "59cfad33-0a1b-4e4b-8176-14904de56dbc",
    ProjectName: "تقديم خدمات استشارية لفعاليات المنشآت",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-008",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription: "تطوير إجراءات وعمليات إدارة العمل الحر",
    ProjectStartDate: "2022-10-02T00:00:00",
    ProjectFinishDate: "2023-10-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: "4140000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: null,
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada:
      "بانتظار اعتماد صاحب الصلاحية بالنظام إدارة المشتريات والعقود ",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "4140000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "0d9b928e-6966-4eff-9ab2-50a810fa4e1a",
    ProjectName: "تقديم الخدمات الاستشارية للحصول على شهادة الاعتماد CIPS",
    Department: "إدارة المشتريات والعقود",
    ProjectCode: "SS-22-068",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "lamia N. aldeghaither",
    ProjectDescription:
      "تقديم الخدمات الاستشارية للحصول على شهادة الاعتماد CIPS",
    ProjectStartDate: "2022-02-14T00:00:00",
    ProjectFinishDate: "2023-02-14T00:00:00",
    BIProjectStartDate: "2022-03-17T08:00:00",
    BIProjectFinishDate: "2023-09-14T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 9,
    BudgetItemNo: "2310",
    BudgetItemName: "الخدمات الاستشارية",
    EstimatedBudget: null,
    ApprovedBudget: "362250.000000",
    ContractValue: "362250.000000",
    RevisedContractValue: "362250.000000",
    PaidAmount: "0.00",
    RemainingAmount: "362250.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "مؤسسة عيون المدن لتقنية المعلومات",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "خالد بن زيد الرويس Khalid Z. AlRuwais",
    ProjectOfficerContact: " ",
    sector_efada: "المشروع تحت التنفيذ وحسب المخطط",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "362250.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "c21a5114-ae55-464c-8ca7-68d675b35894",
    ProjectName: "تأهيل فرع البنك في مدينة الجوف",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-131",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "تأهيل فرع البنك في مدينة الجوف",
    ProjectStartDate: "2022-11-01T00:00:00",
    ProjectFinishDate: "2023-10-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 6,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: "1021027.500000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: null,
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز المشاركة المجتمعية وتطوير قنوات التوزيع (الفروع) والمباني",
    ProjectProgress: "6",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: null,
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "52dc9d41-fb0f-4b1d-874b-790bc2b10651",
    ProjectName: "تقديم الاستشارات والخدمات لدعم العمليات التشغيلية للمنشآت",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-009",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription:
      "تقديم الاستشارات والخدمات لدعم العمليات التشغيلية للمنشآت",
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2023-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 8,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "8250000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "8",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة الطرح",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "9e904557-b1cd-4db6-963e-e39a7fd2fe3e",
    ProjectName: "تطويرات وتحسينات تقنية لمنتج نفاذ",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-22-023",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "أمجاد ناصر المعجل Amjad N. Almojel",
    ProjectDescription: "تطويرات وتحسينات تقنية لمنتج نفاذ",
    ProjectStartDate: "2022-07-01T00:00:00",
    ProjectFinishDate: "2023-04-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 12,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "11212500.000000",
    ContractValue: "11212500.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "12",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "تشكيل لجنة دراسة العروض الفنية 26/7/2022",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "محمد إبراهيم علي العريني Mohammed I. Al Orini",
    ProjectOfficerContact: "منيره عبدالله علي السديس Muneera A. AlSudays",
    sector_efada:
      "تم الطرح بتاريخ 29 مايو، تم التمديد بتاريخ تاريخ 9 يونيو لمدة أسبوع، تم تمديد الطرح بتاريخ 16 يونيو حتى تاريخ 30 يونيو، تم تمديد الطرح بتاريخ 28 يونيو حتى تاريخ 21 يوليو، تم تشكيل اللجنة بتاريخ 25/7 وجاري العمل على التقييم الفني للعروض المتقدمة، تم ارسال استفسار للجنة فحص العروض بتاريخ 3 اغسطس حسب طلب ادارة تقنية المعلومات, بانتظار تزويدنا بالملحق التفصيلي من قبل الشركة",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "6500000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "7855e91f-de48-4922-84a9-0b9f5511f1f3",
    ProjectName:
      "تأثيث فروع البنك (جدة، مكة المكرمة، المدينة المنورة، جازان، حائل، الجوف)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-134",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription:
      "تأثيث فروع البنك (جدة، مكة المكرمة، المدينة المنورة، جازان، حائل، الجوف)",
    ProjectStartDate: "2022-11-01T00:00:00",
    ProjectFinishDate: "2023-03-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 6,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: "4968632.500000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: null,
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز المشاركة المجتمعية وتطوير قنوات التوزيع (الفروع) والمباني",
    ProjectProgress: "6",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: null,
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6bee3a30-7fd6-4825-ac3f-259f160779f2",
    ProjectName: "تطوير منظومة مكتب إدارة المشاريع في قطاع الاعمال",
    Department: "مكتب إدارة مشاريع الأعمال",
    ProjectCode: "BU-22-048",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "وليد سليمان النزهه Waleed S. Alnozha",
    ProjectDescription: "تطوير منظومة مكتب إدارة المشاريع في قطاع الاعمال",
    ProjectStartDate: "2022-10-01T00:00:00",
    ProjectFinishDate: "2023-10-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 10,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "10000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "10",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "عبدالعزيز عبدالله الغريري Abdulaziz A. Algheriri",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم طرح المشروع بتاريخ (20 يوليو)، وسيتم فتح العروض بـ (4 أغسطس)",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6a5c19b6-a6d0-48dd-a3ab-26423af3b160",
    ProjectName: "تأهيل فرع البنك في مدينة حائل",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-132",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "تأهيل فرع البنك في مدينة حائل",
    ProjectStartDate: "2022-11-01T00:00:00",
    ProjectFinishDate: "2023-03-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 6,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: "976752.500000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: null,
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز المشاركة المجتمعية وتطوير قنوات التوزيع (الفروع) والمباني",
    ProjectProgress: "6",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: null,
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "de091ad4-1cbe-482f-8afc-5b1803b05f5d",
    ProjectName: "تأهيل فرع البنك في جازان",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-133",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "تأهيل فرع البنك في جازان",
    ProjectStartDate: "2022-11-01T00:00:00",
    ProjectFinishDate: "2023-03-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 6,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: "1070880.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: null,
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز المشاركة المجتمعية وتطوير قنوات التوزيع (الفروع) والمباني",
    ProjectProgress: "6",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: null,
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "08ad1a85-daaf-489b-8174-6c4613228d36",
    ProjectName: "تحديث الدليل الاجرائي الخاص بتنظيم عمل الأسر المنتجة",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-036",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "علي عوض علي الغامدي ali a. alghamdi",
    ProjectDescription: "تحديث الدليل الإجرائي",
    ProjectStartDate: "2022-09-29T00:00:00",
    ProjectFinishDate: "2023-05-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 8,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2000000.000000",
    ContractValue: "2000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "2000000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "8",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم رفع طلب الشراء في بوابة العقود والمشتريات بتاريخ 27 يونيو 2022م.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "559a7fb8-077c-4f81-9d34-73ef9dad1ba1",
    ProjectName:
      "تشغيل المرحلة الثانية لعدد 8 مواقع مساحات العمل المشتركة لبنك التنمية (جادة 30)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-019",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      "تشغيل المرحلة الثانية لعدد 6 مواقع مساحات العمل المشتركة لبنك التنمية (جادة 30) ",
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-12-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 6,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "28000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "6",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: "مرتبط بمخرجات مشاريع تأهيل جادة30",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "7000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "5a6e928f-06f1-4864-aeaa-fd2a9b7dfa97",
    ProjectName: "مشروع التوعية المالية و التثقيف المالي",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-085",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "ياسمين عبدالعزيز السديس Yasmin A. Al Sudais",
    ProjectDescription:
      "اطلاق حملة توعوية بهدف تعزيز ثقافة الادخار والتوعية بالتخطيط والإدارة المالية لمختلف فئات المجتمع\r\n",
    ProjectStartDate: "2022-08-22T00:00:00",
    ProjectFinishDate: "2022-09-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 11,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3500000.000000",
    ContractValue: "3500000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "11",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 1120,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: " ",
    sector_efada: "تم الانتهاء من التققيم الفني 26/07/2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "0cad2bc0-f499-ec11-8b01-0050569272df",
    ProjectName: "منتج التعليم",
    Department: "إدارة تمويل الأفراد",
    ProjectCode: "BU-22-106",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "بسمه ابراهيم محمد العيسى basma aleissa",
    ProjectDescription: null,
    ProjectStartDate: "2022-05-01T00:00:00",
    ProjectFinishDate: "2022-08-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا",
    NotAligned: "التواريخ",
    AlignedComments:
      "تاريخ تقنية المعلومات البداية 1 اغسطس 2023 والنهاية 31 ديسمبر 2023",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "فيصل شباب الغامدي Faisal S. Alghamdi",
    sector_efada:
      "المشروع غير متوائم ، بناء على توجية الرئيس التنفيذي تم الاجتماع مع جمعية تعلم لبحث سبل الشراكة واشراكهم في نموذج العمل ويتم الان دراسة نموذج العمل من قبل الجمعية وفي انتظار الرد",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "ab2fc33d-0da8-4679-b97a-6c4e771ce8a9",
    ProjectName: "تشغيل مركز دلني للأعمال 2",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-003",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "بدر سليمان عبدالرحمن العكيل BADR S. ALAKEEL",
    ProjectDescription: "تشغيل مركز دلني لأعمال 2",
    ProjectStartDate: "2022-11-01T00:00:00",
    ProjectFinishDate: "2024-11-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 6,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "40093500.000000",
    ContractValue: "40093500.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "40093500.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "6",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "جاري إعداد الكراسة بعد معالجة ملاحظات هيئة كفاءة الانفاق.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6058e92b-d462-4f61-bb13-ab1a5bac2963",
    ProjectName: "إقامة فعاليات المنشآت",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-004",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription: "إقامة فعاليات المنشآت",
    ProjectStartDate: "2022-09-01T00:00:00",
    ProjectFinishDate: "2023-09-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 7,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "7",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada:
      "انتظار افادة الإدارة المالكة حيال تسليم مكتب إدارة المشاريع كراسة المشروع والتاريخ المتوقع لتسليمها 23-6-2022 استكمال إجراءات الطرح من خلال الجامعة ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b9fd60d6-88d6-4111-b12f-e542f9230d33",
    ProjectName: "البنية التحتية لأنظمة المدفوعات الالكترونية",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-041",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "أسعد زهير الزغيبي Asaad Z. Alzughaibi",
    ProjectDescription: "البنية التحتية لأنظمة المدفوعات الالكترونية ",
    ProjectStartDate: "2022-10-30T00:00:00",
    ProjectFinishDate: "2023-04-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 7,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "5000000.000000",
    ContractValue: "5000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "5000000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "7",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "TBD",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    sector_efada:
      "تم مناقشة نموذج العمل يوم الاربعاء 15 يونيو وبناء على موافقة سعادة الرئيس تم البدء بالمرحلة التجريبية (pilot )، كما تم اعداد خطة لتنفيذ المشروع بعد المرحلة التجريبية وهي غير متوافقة حاليا مع تقنية المعلومات، التعميد والترسية: 30 اكتوبر2022م ، الاطلاق: 30 ابريل 2023م",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "5000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "686d4624-d69e-ec11-8b02-0050569272df",
    ProjectName: "تطوير وتشغيل منصة ذكاء الأعمال",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-049",
    ProjectOwner: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    boardinitiative: "لا",
    ProjectManager: "فوزي البيطار Faouzi El Bitar",
    ProjectDescription: null,
    ProjectStartDate: "2022-02-15T00:00:00",
    ProjectFinishDate: "2023-04-16T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 5,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "8000000.000000",
    ContractValue: "2955500.000000",
    RevisedContractValue: "2955500.000000",
    PaidAmount: "607604.59",
    RemainingAmount: "2347895.410000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "المنصات",
    AwardedCompany: "شركة مسارات الشبكة المحدودة",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 1688,
    ActualResourceHours: 686,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "عبدالعزيز حازم المزروع Abdulaziz H Al Mazrou",
    ProjectOfficerContact: "أنس حمدان الرويلي Anas H Alrowili",
    sector_efada:
      "تم تنفيذ ما يقارب ال 20.55% من مخرجات المشروع التالية: تنفيذ اعمال تصميم نمازج بيانات وبناء مستودعات1) بناء عمليات استخراج ونقل وتخزين البيانات 2) مكعبات البيانات 3) لوح المعلومات 4)",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "8000000.00",
    SpentYearBudget: "607604.590000",
  },
  {
    ProjectUID: "cc69148b-0c82-495d-80df-16a434a13c84",
    ProjectName: "مؤتمر التمويل التنموي 2",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-037",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "بدر سليمان عبدالرحمن العكيل BADR S. ALAKEEL",
    ProjectDescription: "مؤتمر التمويل التنموي 2",
    ProjectStartDate: "2022-12-12T00:00:00",
    ProjectFinishDate: "2023-08-21T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2000000.000000",
    ContractValue: "2000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "2000000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "جاري العمل على إعداد كراسة الشروط والمواصفات.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "117059bb-b6a1-43c0-b1bd-329cee5858a8",
    ProjectName: "تجهيز وتأثيث الفروع",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-054",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "تجهيز وتأثيث الفروع ",
    ProjectStartDate: "2022-10-31T00:00:00",
    ProjectFinishDate: "2023-07-10T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada:
      "تم تقسيم المشروع الى 3 مشاريع : تأهيل فروع البنك في (جدة، مكة المكرمة، المدينة المنورة) بالترميز BU-22-130 و مشروع تأهيل فرع البنك في مدينة الجوف بالترميز BU-22-131 ,ومشروع تأهيل فرع البنك في مدينة حائل بالترميز BU-22-132",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d293f783-2f93-4378-ba37-5e12f1ba24d1",
    ProjectName: "تطبيق الجوال (الحزمة الرابعة)",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-20-009",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالله رضوان دهني Abdullah R. Dehni",
    ProjectDescription:
      "اطـلاق الحزمـة الرابعـة مـن خدمـات التمويـل فـي تطبيـق الجـوال (تمويل العمل الحر النقدي ،تمويل الاسرة، خدمة المبالغ الزائدة ، خدمة حجز موعد )",
    ProjectStartDate: "2022-04-01T00:00:00",
    ProjectFinishDate: "2022-08-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 4,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التطبيقات",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "4",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      '"تاريخ الانتهاء الفعلي من تطبيق الجوال حسب ما وردنا من إدارة التطبيقات هو 3 / 11 / 2022"',
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectOfficerContact: "تركي عبدالمحسن المنيف Turki A Almunaif",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "التطبيقات",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "16f52ab4-a1c6-41f1-a0c7-7a963a9732c7",
    ProjectName: "المرحلة الثانية من منصة الحوافز",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-22-024",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالله احمد العودان Abdullah A Alodan",
    ProjectDescription: "المرحلة الثانية من منصة الحوافز",
    ProjectStartDate: "2022-07-15T00:00:00",
    ProjectFinishDate: "2023-04-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 12,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3900000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "12",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "تم الانتهاء من التقييم الفني بتاريخ 25/7/2022",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "محمد إبراهيم علي العريني Mohammed I. Al Orini",
    ProjectOfficerContact: "منيره عبدالله علي السديس Muneera A. AlSudays",
    sector_efada:
      "تم طرح الكراسة بتاريخ 30 مايو. ونظرا لعدم وجود متقدمين على الكراسة تم تمديد فترة الطرح لمدة أسبوعين إضافية الى تاريخ 30 يونيو.تم الاجتماع مع عدد من الشركات لشرح نطاق العمل المطلوب بتاريخ 15 يونيو. تم فتح العروض 30 يونيو. جاري العمل على التقييم الفني حيث تم طلب ملحق تفصيلي بالتقنيات المستخدمة وبانتظار رد الشركة ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d1778d33-b170-4f2d-b93b-88dc5f53d0e6",
    ProjectName: "دراسة مسحية للحاصلين على شهادات الأسر المنتجة",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-035",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "الاء خليل ابراهيم القويفلي Alaa K. Alqowaifli",
    ProjectDescription: "دراسة مسحية للحاصلين على شهادات الأسر المنتجة ",
    ProjectStartDate: "2022-12-11T00:00:00",
    ProjectFinishDate: "2023-08-20T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 6,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "6500000.000000",
    ContractValue: "6500000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "6500000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "6",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "سيتم تشغيله من خلال اتفاقية.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "6500000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "5d3c8a28-5099-ec11-8b00-98566de81707",
    ProjectName: "تقديم خدمات زود لعملاء العمل الحر",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-076",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هيفاء عبدالله عبدالرحمن السيف Haifa Al-Saif",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-01T00:00:00",
    ProjectFinishDate: "2022-08-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 21,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "21",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "تم تسليم المتطلبات إلى التطبيقات بتاريخ 2022/06/26 سيكون جزء من إطلاق LEN2",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: "ابراهيم علي حسين حبتري ibrahim a. habtari",
    sector_efada:
      "سيتم تنفيذ مشروع التطوير على LEN2 ، وحسب المفاهمة مع إدارة تقنية المعلومات سيتم تزويدنا بموعد الإطلاق",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "7d17dfb0-7199-4eac-b252-e4637f96eab6",
    ProjectName:
      "برنامج صناعة الكوادر البشرية المتخصصة في مجال الامتياز التجاري",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-042",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سيف عبدالله ابراهيم الفرهود SAIF A. ALFARHOOD",
    ProjectDescription:
      "برنامج صناعة الكوادر البشرية المتخصصة في مجال الامتياز التجاري",
    ProjectStartDate: "2022-06-25T00:00:00",
    ProjectFinishDate: "2023-06-25T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 6,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1000000.000000",
    ContractValue: "1000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "1000000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "6",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "جاري العمل على إعداد كراسة الشروط والمواصفات.",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "8af99b70-2b75-eb11-8af1-005056921d78",
    ProjectName:
      "التأمين على الحياة للمحفظة الاقراضية للبنك وتأمين مركبات النقل الموجه",
    Department: "إدارة العمليات البنكية",
    ProjectCode: "BU-21-019",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "محمد سعود البليهد Mohammed S. Alblaihed",
    ProjectDescription:
      "تامين الحياة على كامل محفظة القروض الاجتماعية والعمل الحر ضد حالات الوفاة والعجز الكلي",
    ProjectStartDate: "2021-10-20T00:00:00",
    ProjectFinishDate: "2022-10-19T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 3,
    BudgetItemNo: "241",
    BudgetItemName: "التامين على القروض الاجتماعية",
    EstimatedBudget: "154000000.000000",
    ApprovedBudget: "154000000.000000",
    ContractValue: "154000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبدالعزيز عبدالله عثمان العتيق abdulaziz a. alateeq",
    ProjectOfficerContact: " ",
    sector_efada: "جاري العمل على تسديد الفواتير المستحقة",
    pmo_efada: "",
    cat_efada: "الأنظمة و التطوير",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "65deb644-fa99-ec11-8b02-0050569272df",
    ProjectName: "مسارات منتج الترميم",
    Department: "إدارة تمويل الأفراد",
    ProjectCode: "BU-22-107",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "فواز محمد عبدالله الحربي fawaz m. alharbi",
    ProjectDescription: null,
    ProjectStartDate: "2022-08-01T00:00:00",
    ProjectFinishDate: "2022-11-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا",
    NotAligned: "التواريخ",
    AlignedComments:
      "تاريخ تقنية المعلومات البداية 1 اغسطس 2023 والنهاية 31 اغسطس 2023",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "فيصل شباب الغامدي Faisal S. Alghamdi",
    sector_efada:
      "المشروع غير متوائم ، وتم تسليم نطاق العمل لإدارة تقنية المعلومات للإفادة بالوقت المتوقع للتنفيذ، وبحث امكانية تقديم موعد التنفيذ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "1057a63e-361e-4349-b50e-952802614da4",
    ProjectName: "تكاليف تشغيلية لوسطاء التمويل",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-22-040",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectDescription: "تكاليف تشغيلية لوسطاء التمويل",
    ProjectStartDate: "2022-01-01T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 5,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "40000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "5",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: " ",
    sector_efada: "اتفاقيات مستمرة تمويل الاسر المنتجة مع وسطاء التمويل",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "40000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "77d44a8b-7674-eb11-8af0-005056921d78",
    ProjectName: "تأسيس وتشغيل منافذ بيع دائمة لمنتجات الاسر المنتجة",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-031",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هاله مساعد صقر الروقي Hallah M. Alroqi",
    ProjectDescription:
      "تأسيس 20 منفذ بيع دائم لبيع منتجات الاسر المنتجة وتشغيلها لمدة سنتين بالاضافة إلى تصميم هوية تجارية مسجلة",
    ProjectStartDate: "2021-11-04T00:00:00",
    ProjectFinishDate: "2024-03-04T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "5977815.000000",
    ApprovedBudget: "5977815.000000",
    ContractValue: "5977815.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "5977815.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "اروقة الريادة للتجارة",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم اعتماد موقع الرياض وجدة والخبر مبدئياً , تم الانتهاء من مرحلة تأهيل الأسر والعلامات التجارية لهم, وتطوير هوية 156 محتضن في ثلاثة مدن (الرياض-جدة-الخبر) .",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "784901c3-d252-4da6-859e-8039ca9551af",
    ProjectName: "تأهيل عدد 6 مواقع جادة 30 المرحلة الثانية",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-018",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      "تأهيل عدد 6 مواقع جادة 30 المرحلة الثانية في كل من (المدينة المنورة - جده - مكة المكرمة - جازان - الجوف - حائل)",
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-06-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 4,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: "19300000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: null,
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "4",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "غدير الحارثي Gadeer Alharthi",
    sector_efada: "مرتبط بمخرجات مشروع التصاميم الهندسية",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "19300000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6d1d187f-4c99-ec11-8b00-98566de81707",
    ProjectName: "إصدار تحسينات دورية ( ربع سنوية)",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-066",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription: null,
    ProjectStartDate: "2022-01-01T00:00:00",
    ProjectFinishDate: "2024-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 2,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "2",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "الاتفاق على عقد اجتماع لتحديد نطاق المشروع والجهة المالكة",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada:
      "لم يتم تنفيذ الخدمات للربع الثاني والمخطط إنجازه بتاريخ 30/6/2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "d271d7c1-831b-4e4b-a5d5-d5eb4ae16ee8",
    ProjectName: "تأثيث عدد 6 مواقع جادة 30 المرحلة الثانية",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-027",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: "تأثيث عدد 6 مواقع جادة 30 المرحلة الثانية ",
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2023-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 2,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: "8000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: null,
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "2",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: "مرتبط بمخرجات مشروع التصاميم الهندسية",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "8000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "270e875b-813c-48d4-b3e2-e22c2c2de9ea",
    ProjectName: "مشروع تطوير البرامج والتوجهات الاستراتيجية",
    Department: "إدارة قياس الأثر",
    ProjectCode: "ST-21-023",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectDescription: "مشروع تطوير البرامج والتوجهات الاستراتيجية",
    ProjectStartDate: "2022-07-17T00:00:00",
    ProjectFinishDate: "2023-03-16T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 1,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: "3000000.000000",
    ApprovedBudget: "7000000.000000",
    ContractValue: "7000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة ام القرى",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "عبدالمجيد عبدالرحمن بن رشيد Abdulmajeed A. Binrushaid",
    ProjectOfficerContact: " ",
    sector_efada: "تم التعميد بتاريخ 27 يونيو ",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "6000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "1c019995-1e74-eb11-8af0-005056921d78",
    ProjectName: "مشروع تقديم خدمات استشارية وفنية لتطوير وتمكين الاسر المنتجة",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-013",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "Khalid Abdulaziz Alothman",
    ProjectDescription: null,
    ProjectStartDate: "2021-08-16T00:00:00",
    ProjectFinishDate: "2023-04-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "17499995.000000",
    ApprovedBudget: "17499995.000000",
    ContractValue: "17499995.000000",
    RevisedContractValue: "17499995.000000",
    PaidAmount: "10063211.80",
    RemainingAmount: "7436783.490000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة المجمعة ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: " ",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "تحت التنفيذ- برنامج و يندرج تحته 5 محاور ",
    pmo_efada: "تحت التنفيذ",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "ea4f48ae-2274-eb11-8af0-005056921d78",
    ProjectName: "تطوير منظومة فروع البنك",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-009",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectDescription: "تفعيل مخرجات مشروع الدعم الاستراتيجي للفروع",
    ProjectStartDate: "2021-07-14T00:00:00",
    ProjectFinishDate: "2022-07-13T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "5000000.000000",
    ApprovedBudget: "5000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada:
      "سيتم رفع طلب إلغاء المشروع من النظام لعدم طرح المشروع في 2021 ولوجود مشروع بديل في النظام رقم BU-21-040",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "1230f0c3-2d74-eb11-8af0-005056921d78",
    ProjectName: "نظام إدارة المراجعة الداخلية",
    Department: "إدارة المراجعة التشغيلية وتقنية المعلومات",
    ProjectCode: "IN-21-002",
    ProjectOwner: "محمد قعدان مرزوق العتيبي Mohammed G Alotaibi",
    boardinitiative: "لا",
    ProjectManager: "محمد فهد سليمان الرضيان Mohammed F. Alrodyan",
    ProjectDescription: "شراء نظام للمراجعة الداخلية",
    ProjectStartDate: "2021-09-19T00:00:00",
    ProjectFinishDate: "2023-09-18T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "3112",
    BudgetItemName: "تقنية المعلومات",
    EstimatedBudget: "600000.000000",
    ApprovedBudget: "600000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع المراجعة الداخلية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المراجعة الداخلية",
    ProgramManager: " ",
    ProjectOwner1: "محمد قعدان مرزوق العتيبي Mohammed G Alotaibi",
    ProjectOfficerContact: " ",
    sector_efada: "لم يتم توقيع العقد وتمت الموافقة بإعادة طرح المشروع",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "7570ed02-3274-eb11-8af0-005056921d78",
    ProjectName:
      "تقديم استشارات و دراسات ائتمانية وتحليل مالي وفني لمتقدمي المسار الصحي",
    Department: "إدارة تمويل المنشأت",
    ProjectCode: "BU-21-008",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "احمد علي الزهراني Ahmad A ِAlzahrani",
    ProjectDescription:
      "يهدف هذا المشروع إلى التعاقد مع جهة متخصصة ذات خبرة في مجال التحليل المالي ودراسة الائتمان و المخاطر وتقييم الجدارة والاستحقاق ومتابعة جميع الطلبات الإقراض لعملاء المسار الصحي إضافة إلى تمكين ونقل الخبرات اللازمة ورفع كفاءة الموظفين لدى البنك",
    ProjectStartDate: "2021-06-22T00:00:00",
    ProjectFinishDate: "2022-06-21T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "25421",
    BudgetItemName:
      "بناء نظام الكتروني بنكي للتحليل الائتماني والمالي لطلبات التمويل ",
    EstimatedBudget: "2341463.000000",
    ApprovedBudget: "2341463.000000",
    ContractValue: "2341462.730000",
    RevisedContractValue: "0.000000",
    PaidAmount: "1812746.35",
    RemainingAmount: "528716.650000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "جامعة المجمعة معهد الدراسات و الخدمات الاستشارية",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: "احمد علي الزهراني Ahmad A ِAlzahrani",
    ProjectOfficerContact: "احمد علي الزهراني Ahmad A ِAlzahrani",
    sector_efada:
      "تم الانتهاء من اعمال المشروع وسداد جميع المستحقات المالية للمقاول ",
    pmo_efada: "لمراجعة بيانات الصرف المتبقية",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "390d09ce-3b74-eb11-8af0-005056921d78",
    ProjectName: "مشروع تصميم و تنفيذ مشاركات البنك في المؤتمرات و المعارض",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-003",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "محمد علوش محمد الهديب mohammed a. alhedaib",
    ProjectDescription:
      "يهدف هذا المشروع لتنفيذ مشاركات البنك في المعارض والمؤتمرات",
    ProjectStartDate: "2021-03-16T00:00:00",
    ProjectFinishDate: "2022-04-16T00:00:00",
    BIProjectStartDate: "2021-02-28T08:00:00",
    BIProjectFinishDate: "2021-03-01T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "23071",
    BudgetItemName: "تنظيم المعارض والندوات ",
    EstimatedBudget: "2752140.000000",
    ApprovedBudget: "2752137.750000",
    ContractValue: "2752137.750000",
    RevisedContractValue: null,
    PaidAmount: "2752137.75",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "مؤسسة التنفيذ العالي لتنظيم المعارض والمؤتمرات",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: null,
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: "دانيا عثمان المنيع Dania O. Almanea",
    sector_efada: "تم رفع طلب إغلاق المشروع ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "739618.00",
    SpentYearBudget: "739618.000000",
  },
  {
    ProjectUID: "3d988bf2-5074-eb11-8af0-005056921d78",
    ProjectName:
      "مشروع تقديم الدعم الإستراتيجي لتصميم شبكة الفروع وقنوات الخدمة والامتياز التجاري",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-20-010",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectDescription: null,
    ProjectStartDate: "2020-10-21T00:00:00",
    ProjectFinishDate: "2021-04-21T00:00:00",
    BIProjectStartDate: "2020-10-21T08:00:00",
    BIProjectFinishDate: "2021-04-21T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "25321",
    BudgetItemName:
      "تصميم واطلاق منظومة التمويل عبر الامتياز التجاري واستقطاب العلامات التجارية 2020",
    EstimatedBudget: "7000000.000000",
    ApprovedBudget: "7297900.000000",
    ContractValue: "7297900.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "8027690.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة ايه تي كيرني السعودية المحدودة ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "عهود خالد الربيعة Ahood K ALrabiah",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "c1be9aaf-6d74-eb11-8af0-005056921d78",
    ProjectName: "المرحلة الثانية من مشروع تطوير نموذج العمل (تقديم استشارات)",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-21-039",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription:
      "نظام الية العملية لنقل الطلب الائتماني والخدمات الإضافية للقطاع بين الإدارات المعنية",
    ProjectStartDate: "2021-11-15T00:00:00",
    ProjectFinishDate: "2022-11-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "18000000.000000",
    ApprovedBudget: "18000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عزت فيصل العنقري Ezzat F AlAngari",
    sector_efada: "جاري العمل على نموذج الغاء المشروع ودمجة مع مشروع اخر ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "0771a8ce-7374-eb11-8af0-005056921d78",
    ProjectName: "مؤتمر التمويل التنموي",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-010",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    ProjectDescription:
      "إقامة مؤتمريسلط الضوء على ماتقدمه الدولة ممثلة ببنك التنمية الاجتماعية في مجال التمويل الاصغر يتم من خلاله دعوة متخصصين في مجال التمويل الاصغر و عرض التجارب وأهم الدراسات بالإضافة إلى إقامة ورش العمل ودورات تدريبية على هامش الفعالية",
    ProjectStartDate: "2021-07-15T00:00:00",
    ProjectFinishDate: "2021-10-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "5000000.000000",
    ApprovedBudget: "5000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "لم يتم ترحيل المشروع ويوجد مشروع جديد في 2022",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "62f10be3-8274-eb11-8af0-005056921d78",
    ProjectName: "شراء نظام متابعة المعاملات القانونية",
    Department: "إدارة القضايا",
    ProjectCode: "LE-21-001",
    ProjectOwner: "Sameh Mohamed",
    boardinitiative: "لا",
    ProjectManager: "سامي صالح فاضل العمري sami s. alamri",
    ProjectDescription:
      "نظام إلكتروني متكامل احترافي خاص بعمل الادارة القانونية من قضايا و استشارات و تحقيق ، بأسلوب تقني حديث على ان تكون تطبيقاته تعمل بفعالية وأداء عالي بالإضافة إلى جاذبية التصميم وسهولة الاستخدام.",
    ProjectStartDate: "2021-06-01T00:00:00",
    ProjectFinishDate: "2021-12-30T00:00:00",
    BIProjectStartDate: "2021-06-01T08:00:00",
    BIProjectFinishDate: "2021-12-30T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "3112",
    BudgetItemName: "تقنية المعلومات",
    EstimatedBudget: "600000.000000",
    ApprovedBudget: "600000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "الإدارة القانونية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "الإدارة القانونية",
    ProgramManager: " ",
    ProjectOwner1: "ناصر عبدالعزيز بن فراج الثويني nasser a. althowaini",
    ProjectOfficerContact: " ",
    sector_efada:
      "بناء على توصية المجلس الاستشاري؛ جاري النظر عن مدى إمكانية الاستفادة من مشروع نظام الاتصالات الإدارية المطروح للبنك ، و تم الاجتماع مع الزملاء المسؤولين عن النظام و الاجتماع مع الشركة التي تعمل على المشروع و لازالت الاجتماعات قائمة، و لم يتحدد حتى الآن مدى تغطيتهم للمتطلبات القانونية بالشكل الكامل، عليه ما زالت الحاجة قائمة للمشروع.",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "56495302-8474-eb11-8af0-005056921d78",
    ProjectName:
      "المرحلة الأولى والثانية لتطوير نظام تخطيط موارد المؤسسات للانتقال من العمل على الأساس النقدي الى أساس الاستحقاق ERP",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-21-006",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "فهد عائش العتيبي Fahad A. Alotaibi",
    ProjectDescription:
      "تطوير نظام تخطيط موارد المؤسسات للانتقال من العمل على الأساس النقدي إلى أساس الاستحقاق تقنياً",
    ProjectStartDate: "2022-05-22T00:00:00",
    ProjectFinishDate: "2023-05-21T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "3000000.000000",
    ApprovedBudget: "5500000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "5500000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تحقيق الاستدامة المالية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم عقد اجتماعات وجاري العمل على مراجعة نطاق المشروع وتجهيز بطاقات الإجراءات والمتطلبات (BRD)",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "5500000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6d22444e-8574-eb11-8af0-005056921d78",
    ProjectName: "تطوير نظام مراجعة الأداء والاستراتيجية",
    Department: "إدارة التخطيط الاستراتيجي",
    ProjectCode: "ST-21-009",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "حازم يوسف اليوسف Hazim Ussef Al-Ussef",
    ProjectDescription: "تطوير نظام متخصص في متابعة الأداء والاستراتيجية",
    ProjectStartDate: "2023-01-01T00:00:00",
    ProjectFinishDate: "2023-12-30T00:00:00",
    BIProjectStartDate: "2021-06-01T08:00:00",
    BIProjectFinishDate: "2021-06-02T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "3112",
    BudgetItemName: "تقنية المعلومات",
    EstimatedBudget: "2000000.000000",
    ApprovedBudget: null,
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: " ",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم تأجيلة للسنة القادمة لوجود اعتمادية مع مشروع تطوير وتفعيل منهجية الأداء المؤسسي لمنظومة البنك وقطاعاته",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "622b1d20-8674-eb11-8af0-005056921d78",
    ProjectName:
      "تشغيل مساحات العمل المشترك - جادة 30 (المرحلة الثانية)(جازان-المدينة)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-044",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      "تشغيل مساحات العمل المشترك لعدد 2 فروع - المرحلة الثانية",
    ProjectStartDate: "2021-11-21T00:00:00",
    ProjectFinishDate: "2022-11-20T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "3111",
    BudgetItemName: "",
    EstimatedBudget: "4580000.000000",
    ApprovedBudget: "4580000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: "تم رفع طلب إلغاء لوجود مشروع بديل على النظام برقم BU-22-019",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "bb43ec17-8774-eb11-8af0-005056921d78",
    ProjectName: "خدمات ترويجية لخدمات البنك",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-010",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "خالد راشد الثويني Khaled R Althowaini",
    ProjectDescription: "حملات رقمية وترويجية لخدمات البنك",
    ProjectStartDate: "2021-06-09T00:00:00",
    ProjectFinishDate: "2021-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "5000000.000000",
    ApprovedBudget: "4000000.000000",
    ContractValue: "2923000.000000",
    RevisedContractValue: "3213030.000000",
    PaidAmount: "3213030.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة فكرة مضيئة للدعاية والاعلان",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "جاري رفع محضر إغلاق المشروع مع موافقة أمر التغير بإضافة 10% من قيمة المشروع ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "290300.00",
    SpentYearBudget: "290300.000000",
  },
  {
    ProjectUID: "4df58b8a-8874-eb11-8af0-005056921d78",
    ProjectName: "تطوير استراتيجية التسويق وتحسين تجربة العميل",
    Department: "إدارة تجربة العملاء",
    ProjectCode: "ST-21-006",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "عامر عمير عامر السبيعي Amer O Alsubaie",
    ProjectDescription: "بناء منتجات إبداعية وإعلامية للبنك",
    ProjectStartDate: "2021-05-30T00:00:00",
    ProjectFinishDate: "2021-05-31T00:00:00",
    BIProjectStartDate: "2021-05-30T08:00:00",
    BIProjectFinishDate: "2021-05-31T17:00:00",
    PlannedCompletePercent: "100",
    ActualCompletePercent: 0,
    BudgetItemNo: "2311",
    BudgetItemName: "",
    EstimatedBudget: "9000000.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: " ",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الغاء المشروع بناء علي توجيه من سعادة النائب و تقسيمها على اكثر من كراسة : كراسة تقديم خدمات استشارية و تطوير منهجية تجربة العميل و تحسين مسارات الخدمة ",
    pmo_efada: "في حاجة لاستكمال نموذج الغاء المشروع ",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d4877129-c374-eb11-8af0-005056921d78",
    ProjectName: "تشغيل وصيانة منصة ذكاء الأعمال",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-016",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز حازم المزروع Abdulaziz H Al Mazrou",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-29T00:00:00",
    ProjectFinishDate: "2023-12-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "4000000.000000",
    ApprovedBudget: "4000000.000000",
    ContractValue: "4000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "مخطط للطرح في Q4 ",
    pmo_efada: "في مرحلة فحص العروض ",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "4d9531e1-f074-eb11-8af1-005056921d78",
    ProjectName: "استقطاب وتأهيل شركاء التمويل متناهي الصغر",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-19-002",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد فايز الدوسري Khalid F Aldosari",
    ProjectDescription: null,
    ProjectStartDate: "2019-10-21T00:00:00",
    ProjectFinishDate: "2020-04-21T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "6000000.000000",
    ApprovedBudget: "3499567.050000",
    ContractValue: "3499567.050000",
    RevisedContractValue: "0.000000",
    PaidAmount: "2164856.40",
    RemainingAmount: "1334711.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة وافي العالمية",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada:
      "تم طلب الغاء المشروع لعدم القدرة على اقامة الملتقى السنوي بسبب جائحة كورونا ",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ac1650d6-f174-eb11-8af1-005056921d78",
    ProjectName: "مشروع عطاءات",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "ST-20-002",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription:
      "مشروع عطاءات يهدف الى دعم رواد الأعمال في قطاع المنشآت الصغيرة والمتوسطة المتخصصة في مجالات التوريد لتمكينهم من الفوز وتنفيذ المنافسات الحكومية المقدمة عبر منصة اعتماد",
    ProjectStartDate: "2022-08-01T00:00:00",
    ProjectFinishDate: "2022-08-31T00:00:00",
    BIProjectStartDate: "2020-07-14T08:00:00",
    BIProjectFinishDate: "2021-08-31T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة ثقة",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "90771740-fd74-eb11-8af1-005056921d78",
    ProjectName:
      "تقديم خدمات استشارية في تطوير أدلة ونماذج الزيارة الميدانية لضمان التزام الجهات الشريكة",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-21-043",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "اسامه محمد عبدالله الجار الله Osama M. Aljarallh",
    ProjectDescription: null,
    ProjectStartDate: "2022-08-15T00:00:00",
    ProjectFinishDate: "2023-02-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "25126",
    BudgetItemName: "الاسر المنتجة",
    EstimatedBudget: "2500000.000000",
    ApprovedBudget: "2500000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: " ",
    sector_efada:
      "المشروع مرتبط بإنتهاء مشروع تطوير منصة التقييم الذاتي المتوقر انتهاءه في 15 اغسطس 2022 وسيتم الطرح في يونيو",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "c3aaf378-ff74-eb11-8af1-005056921d78",
    ProjectName: "تفعيل وربط مركز التصديق الرقمي بأنظمة البنك",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-21-019",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "طارق سليمان المحمود Tarek S Almahmoud",
    ProjectDescription: null,
    ProjectStartDate: "2021-11-30T00:00:00",
    ProjectFinishDate: "2022-11-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "2310",
    BudgetItemName: "الخدمات الاستشارية",
    EstimatedBudget: "150000.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    ProjectOfficerContact: " ",
    sector_efada: "المشروع ملغي وجاري العمل على استكمال نموذج الاغلاق",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "a52bef22-1275-eb11-8af1-005056921d78",
    ProjectName: "نظام إدارة تخطيط الموارد المؤسسي (ERP)",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-017",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "نعم",
    ProjectManager: "محمد عبدالله السند Mohammed A. Alsanad",
    ProjectDescription: "تشغيل وتفعيل نظام إدارة تخطيط الموارد المؤسسي",
    ProjectStartDate: "2022-06-28T00:00:00",
    ProjectFinishDate: "2024-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "نظام إدارة تخطيط الموارد المؤسسي (ERP)",
    EstimatedBudget: "8000000.000000",
    ApprovedBudget: "10000000.000000",
    ContractValue: "16817394.700000",
    RevisedContractValue: "16817394.700000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "توقع العقد بتاريخ 22.06.2022 و تم اعداد مسودة اللجنة التوجيهية و اللجان الفرعية و بانتظار الموافقة على المرشحين كما وجاري العمل على استكمال وثائق خطة المشروع ",
    pmo_efada: "",
    cat_efada: "الأنظمة و التطوير",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "46f1405a-1d75-eb11-8af1-005056921d78",
    ProjectName: "نظام التصنيف الائتماني و بطاقة الاوزان الائتمانية",
    Department: "إدارة الإئتمان",
    ProjectCode: "BU-21-037",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "محمد الحميدي الحربي Mohammed A Alharbi",
    ProjectDescription:
      "هو نظام يساعد متخذ القرار لاتخاذ قرار ائتماني في ما يخص طلبات التمويل للمنشآت بناء على تصنيف درجة مخاطر العملاء بناء على تقييم جوانب تشمل القدرات الإدارة والقدرات المالية...الخ",
    ProjectStartDate: "2021-11-15T00:00:00",
    ProjectFinishDate: "2022-11-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "3112",
    BudgetItemName: "تقنية المعلومات",
    EstimatedBudget: "3000000.000000",
    ApprovedBudget: "3000000.000000",
    ContractValue: "3000000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "عبدالمجيد صالح الكريديس Abdulmajed S. AlKriedees",
    ProjectOfficerContact: "محمد الحميدي الحربي Mohammed A Alharbi",
    sector_efada:
      "تم ارفاق طلب الغاء المشروع نظراً لتنفيذ مشروع مشابه داخلياً باسم بناء نظام إلكتروني للتحليل الائتماني والمالي لطلبات التمويل رقم BU-22-065",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "7790b2de-1e75-eb11-8af1-005056921d78",
    ProjectName: "مشروع تطوير انظمة متعددة للقطاع (المرحلة الاولى)",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-21-038",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription:
      "نظام يساعد على الاطلاع على الحدود ومعرفة المتاح والمصروف",
    ProjectStartDate: "2021-11-15T00:00:00",
    ProjectFinishDate: "2022-11-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "4000000.000000",
    ApprovedBudget: "4000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عزت فيصل العنقري Ezzat F AlAngari",
    sector_efada: "جاري العمل على نموذج الغاء المشروع ودمجة مع مشروع اخر ",
    pmo_efada: "في حاجة لنموذج الغاء المشروع ودمجة مع مشروع اخر ",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b80b1dc8-2475-eb11-8af1-005056921d78",
    ProjectName: "مشروع خدمات اتصالية رقمية",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-004",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "حنان عبدالرحمن الدليمي Hanan A. Al Delaimi",
    ProjectDescription:
      "يهدف هذا المشروع لتطوير الاستراتيجية الرقمية لبنك التنمية الاجتماعية وإدارة القنوات الرقمية بما يخدم التوجهات الإعلامية والتسويقية لمنتجات وخدمات ومبادرات البنك ويشمل ذلك المحتوى والنشر والتقارير.",
    ProjectStartDate: "2021-11-16T00:00:00",
    ProjectFinishDate: "2022-11-16T00:00:00",
    BIProjectStartDate: "2021-03-25T08:00:00",
    BIProjectFinishDate: "2022-03-24T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية",
    EstimatedBudget: "2199605.000000",
    ApprovedBudget: "2199605.000000",
    ContractValue: "2199605.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "2199605.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "التقييم الفني",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "خالد راشد الثويني Khaled R Althowaini",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "جاري رفع ميثاق المشروع ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "663205.00",
    SpentYearBudget: "663205.000000",
  },
  {
    ProjectUID: "6bc1c6f0-f199-ec11-8b01-0050569272df",
    ProjectName:
      "مبادرة دعم المنشآت متناهية الصغر والصغيرة من خلال جهات متخصصة خارجية",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-098",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription: null,
    ProjectStartDate: "2023-02-01T00:00:00",
    ProjectFinishDate: "2023-06-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "ABDULAZIZ SAUD ALHARBI",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "66528f4a-f299-ec11-8b01-0050569272df",
    ProjectName: "تطوير برنامج التمويل غير المباشر- منشآت",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-099",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "نايف خالد ابراهيم الفعيم naif k. alfaeem",
    ProjectDescription: null,
    ProjectStartDate: "2022-10-01T00:00:00",
    ProjectFinishDate: "2023-01-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عبدالعزيز حسن خليل الاحمدي Abdulaziz H. AlAhmadi",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "be280fc0-f299-ec11-8b01-0050569272df",
    ProjectName:
      "تطبيق خدمة الدردشة الإلكترونية لتواصل العملاء مع البنك chatbot",
    Department: "إدارة تمويل المنشأت",
    ProjectCode: "BU-22-100",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-03-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "TBD",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada: "يدار المشروع من قبل قطاع الخدمات",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "32b991f8-f299-ec11-8b01-0050569272df",
    ProjectName: "التوسع مع البنك العربي لتقديم برنامج (زود الأجيال)",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-101",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "ابراهيم محمد احمد ابانمي ibrahim m. abanumay",
    ProjectDescription: null,
    ProjectStartDate: "2023-04-01T00:00:00",
    ProjectFinishDate: "2023-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: "ابراهيم علي حسين حبتري ibrahim a. habtari",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "846ece6c-f399-ec11-8b01-0050569272df",
    ProjectName: "الربط التقني مع بنك الفرنسي لبرنامج زود",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-102",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "ابراهيم محمد احمد ابانمي ibrahim m. abanumay",
    ProjectDescription: null,
    ProjectStartDate: "2022-05-25T00:00:00",
    ProjectFinishDate: "2022-06-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "طلب التغيير",
    Priority: "لا ينطبق",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "متأخر ( تم تأجيله من قبل البنك الفرنسي لعام 2023م)",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: "ابراهيم علي حسين حبتري ibrahim a. habtari",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "3d104e69-f899-ec11-8b02-0050569272df",
    ProjectName:
      "نقل أنظمة تشغيل جادة 30 التقنية (بنية تحتية - موقع الكتروني - تطبيق)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-110",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-01T00:00:00",
    ProjectFinishDate: "2023-01-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "TBD",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada:
      "•\tتم تجهيز كراسة بناء على توجيه الرئيس وإرسالها لتقنية المعلومات للمراجعة بتاريخ 24/7",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "dba5d3a9-f999-ec11-8b02-0050569272df",
    ProjectName: "اتمتىة مطابقة العمليات المحاسبية بجادة 30",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-113",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: null,
    ProjectStartDate: "2022-02-15T00:00:00",
    ProjectFinishDate: "2022-04-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا",
    NotAligned: "التواريخ",
    AlignedComments:
      "تاريخ تقنية المعلومات البداية 1 يوليو 2023 والنهاية 15 سبتمبر 2023",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "Hassan F. Algarni",
    sector_efada:
      "تم الاتفاق على تجهيز شاشة مطابقات بديلة بما يتواءم مع سياسات البنك ، واعطاء الصالحية للمطابقة علىنظام الأوراكل يعتمد على وجود سياسة واجراء بيع معتمد (مكتب اجراءات العمل - عمر الاجراء الحالي ١٨١ يوم) وتم التواصل مع المكتب لتسريع الاعتماد في النظام",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "cef773b1-549d-ec11-8b02-0050569272df",
    ProjectName:
      "الصيانة والدعم الفني لنظام إدارة المشاريع المؤسسي ببنك التنمية الاجتماعية",
    Department: "مكتب إدارة المشاريع المؤسسي",
    ProjectCode: "ST-22-012",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "سعد محمد بخيت الدوسري Saad M Aldosari",
    ProjectDescription: null,
    ProjectStartDate: "2022-03-21T00:00:00",
    ProjectFinishDate: "2023-03-20T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "566386.750000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "عبدالله عبدالعزيز الناصر Abdullah A. Alnasser",
    ProjectOfficerContact: " ",
    sector_efada:
      'تم دمج نطاق المشروع مع "تطوير نظام ادارة المشاريع ورفع الحوكمة - المرحلة الثانية" - تم مناقلة مبلغ "433,613.25" الى مشروع "تجديد اتفاقية الرخص المؤسسية لمنتجات مايكروسوفت - Ms project"',
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "566386.75",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "42c0245e-559d-ec11-8b02-0050569272df",
    ProjectName: "قياس مستوى خدمات ومنتجات البنك من خلال منهجية المتسوق الخفي",
    Department: "إدارة تجربة العملاء",
    ProjectCode: "ST-22-002",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "ماجد تايه شميلان العنزي majed t. alenazi",
    ProjectDescription: null,
    ProjectStartDate: "2022-04-01T00:00:00",
    ProjectFinishDate: "2023-06-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "عبدالله ردن عبدالله العصيمي abdullah r. alossimi",
    ProjectOfficerContact: " ",
    sector_efada:
      'سبب التأخير في الطرح: تم تغيير نطاق المشروع بالتالي تغير مسمى المشروع إلى: "قياس مستوى خدمات ومنتجات البنك من خلال منهجية المتسوق الخفي: و تم الانتهاء من RFP وسيتم رفعه إلى إدارة المشتريات قبل إجازة العيد',
    pmo_efada:
      'اسم المشروع سابقا "•\tرصد وتحليل مشاعر العملاء في وسائل التواصل الاجتماعي"',
    cat_efada: null,
    YearBudget: "1000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "e834b8a5-559d-ec11-8b02-0050569272df",
    ProjectName: "التمركز نحو تجربة العميل",
    Department: "إدارة تجربة العملاء",
    ProjectCode: "ST-22-003",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "عامر عمير عامر السبيعي Amer O Alsubaie",
    ProjectDescription: null,
    ProjectStartDate: "2022-10-31T00:00:00",
    ProjectFinishDate: "2023-10-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "10000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "عبدالله ردن عبدالله العصيمي abdullah r. alossimi",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة كتابة الكراسة",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "10000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "c33ce2f3-559d-ec11-8b02-0050569272df",
    ProjectName: "تطوير ادوات إدارة قياس الأثر",
    Department: "إدارة قياس الأثر",
    ProjectCode: "ST-22-004",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "سمير سراج عثمان فلاته sameer s. fallatah",
    ProjectDescription: null,
    ProjectStartDate: "2022-08-30T00:00:00",
    ProjectFinishDate: "2023-02-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "عبدالمجيد عبدالرحمن بن رشيد Abdulmajeed A. Binrushaid",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة الطرح ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "2f3aff48-569d-ec11-8b02-0050569272df",
    ProjectName: "تحديث استراتيجية البنك والنموذج المالي",
    Department: "إدارة التخطيط الاستراتيجي",
    ProjectCode: "ST-22-005",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مشاري عبدالرحمن المحيميد Mashari A. AlMeheimeed",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-12-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "مشاري عبدالرحمن المحيميد Mashari A. AlMeheimeed",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "e26523aa-569d-ec11-8b02-0050569272df",
    ProjectName: "تطوير وتفعيل منهجية الأداء المؤسسي لمنظومة البنك وقطاعاته",
    Department: "إدارة الأداء المؤسسي",
    ProjectCode: "ST-22-014",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "محمد فرج مهدي الشهراني Mohammed F. Alshahrani",
    ProjectDescription: null,
    ProjectStartDate: "2022-03-25T00:00:00",
    ProjectFinishDate: "2023-03-25T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "4000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "اعتماد محضر فحص العروض",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "حازم يوسف اليوسف Hazim Ussef Al-Ussef",
    ProjectOfficerContact: " ",
    sector_efada: "جاري اصدار خطاب الترسية ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "f58f2605-579d-ec11-8b02-0050569272df",
    ProjectName:
      "تطوير اطار عمل تحفيز القطاع الخاص للمشاركة في المسؤولية الاجتماعية وبناء منتجات ابتكارية",
    Department: "إدارة الابتكار والشراكات",
    ProjectCode: "ST-22-010",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "الدانة خليفه العجاجي Aldanah K Alajaji",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-01T00:00:00",
    ProjectFinishDate: "2023-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "4000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "الدانة خليفه العجاجي Aldanah K Alajaji",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4000000",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "8d3aef52-579d-ec11-8b02-0050569272df",
    ProjectName: "اعداد ملفات تنافسية البنك المحلية والإقليمية والعالمية",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-011",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الغاء المشروع وجاري العمل على نموذج الاغلاق وتم نقل الميزانية الى مشروع ST-22-028",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "e79208a8-579d-ec11-8b02-0050569272df",
    ProjectName: "تنفيذ خطط التسويق والانتشار لمنتجات البنك وخدماته لعام 2022",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-017",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "خالد راشد الثويني Khaled R Althowaini",
    ProjectDescription: null,
    ProjectStartDate: "2022-08-11T00:00:00",
    ProjectFinishDate: "2023-08-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية ",
    EstimatedBudget: null,
    ApprovedBudget: "19000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التعاقد",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "19000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "c24101f6-579d-ec11-8b02-0050569272df",
    ProjectName:
      "تطوير الهوية المؤسسية للبنك و امتداداته (الأبحاث التسويقية والعلامات التجارية)",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-006",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "فيصل فهد عبدالله الخليفة Faisal F. Alkhalifa",
    ProjectDescription: null,
    ProjectStartDate: "2022-10-01T00:00:00",
    ProjectFinishDate: "2023-10-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "الخدمات الاستشارية ",
    EstimatedBudget: null,
    ApprovedBudget: "7000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التقييم الفني",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "7000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "54446f4a-589d-ec11-8b02-0050569272df",
    ProjectName: "مشروع تنفيذ خدمات المحتوى و التواصل وإعداد سلسلة البودكاست",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-015",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "يارا خالد الشهري Yara K. Alshehri",
    ProjectDescription: null,
    ProjectStartDate: "2022-08-15T00:00:00",
    ProjectFinishDate: "2023-08-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية ",
    EstimatedBudget: null,
    ApprovedBudget: "5000000.000000",
    ContractValue: "4732343.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "تراكيب المحتوى للتجارة",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التعاقد",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "5000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "6caf7c9e-589d-ec11-8b02-0050569272df",
    ProjectName:
      "تجهيز و تنفيذ مشاركات و فعاليات بنك التنمية الاجتماعية لعام 2022",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-007",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectDescription: null,
    ProjectStartDate: "2022-05-30T00:00:00",
    ProjectFinishDate: "2023-05-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والعلاقات العامة",
    EstimatedBudget: null,
    ApprovedBudget: "19000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "اعتماد صاحب الصلاحية",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الترسية في 2 مايو وتم استلام الضمان المالي بتاريخ 3 مايو وجاري العمل على اعداد العقد",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "19000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "f54c36e0-589d-ec11-8b02-0050569272df",
    ProjectName: "صناعة وإدارة مكتبة المحتو ى السمعي والبصري",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-013",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "دانيا عثمان المنيع Dania O. Almanea",
    ProjectDescription: null,
    ProjectStartDate: "2022-10-01T00:00:00",
    ProjectFinishDate: "2023-03-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "الخدمات الاستشارية ",
    EstimatedBudget: null,
    ApprovedBudget: "1250000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1250000",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "4450f73a-599d-ec11-8b02-0050569272df",
    ProjectName: "تجهيز وتنفيذ خطة التواصل والظهور لمارثون الادخار المالي",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-024",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "فيصل فهد عبدالله الخليفة Faisal F. Alkhalifa",
    ProjectDescription: null,
    ProjectStartDate: "2022-07-01T00:00:00",
    ProjectFinishDate: "2023-07-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "تنظيم المعارض والندوات",
    EstimatedBudget: null,
    ApprovedBudget: "4000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "مرحلة تحديد النطاق وإعداد الكراسة ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "0920a788-599d-ec11-8b02-0050569272df",
    ProjectName:
      "تطوير الظهور الإعلامي والتواصل المؤسسي للبنك وإعداد المحتوى والتوثيق والتدريب الإعلامي",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-020",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "يارا خالد الشهري Yara K. Alshehri",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2023-06-21T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "8500000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "اعتماد محضر فحص العروض",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الترسية بتاريخ 2 مايو وبانتظار الضمان المالي من الشركة الفائزة",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "8500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "d5290c25-5a9d-ec11-8b02-0050569272df",
    ProjectName:
      "خدمات تسويق وحجز مساحات إعلانية في وسائل الإعلام الخارجية والرقمية وسائل التواصل الاجتماعي",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-022",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "حنان عبدالرحمن الدليمي Hanan A. Al Delaimi",
    ProjectDescription: null,
    ProjectStartDate: "2022-08-15T00:00:00",
    ProjectFinishDate: "2023-08-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية ",
    EstimatedBudget: null,
    ApprovedBudget: "17000000.000000",
    ContractValue: "16967755.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "الموج الابداعية للتقنية",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التعاقد",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "17000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "36013674-5a9d-ec11-8b02-0050569272df",
    ProjectName:
      "تنفيذ وترويج حملات إبداعية لقصص نجاح رواد الأعمال المدعومين من البنك",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-023",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "منيره حمد بن عبيد Munirah H. Bin obaid",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-25T00:00:00",
    ProjectFinishDate: "2023-12-25T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم الغاء المشروع وجاري العمل على نموذج الاغلاق وتم نقل الميزانية الى مشروع ST-22-028",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "4d44c9c1-5a9d-ec11-8b02-0050569272df",
    ProjectName: "الخدمات المساندة للمنشآت الصغيرة والناشئة",
    Department: "إدارة الابتكار والشراكات",
    ProjectCode: "ST-22-016",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "هند محمد صغير الدوسري hind m. aldossary",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-01T00:00:00",
    ProjectFinishDate: "2023-09-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "الخدمات الاستشارية",
    EstimatedBudget: null,
    ApprovedBudget: "4500000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "الدانة خليفه العجاجي Aldanah K Alajaji",
    ProjectOfficerContact: " ",
    sector_efada: "جاري رفع الكراسة في نظام المشتريات",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "d2728e5d-bf9e-ec11-8b02-0050569272df",
    ProjectName: "تسوير أراضي بنك التنمية الاجتماعية",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-001",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "معاذ احمد محمد بامسعود muath a. bamasoud",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2023-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "ناصر عبدالعزيز القديري Nasser A. AlQudairi",
    ProjectOfficerContact: " ",
    sector_efada: "من المتوقع طرح المشروع في الربع الثالث",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "755cc54f-c09e-ec11-8b02-0050569272df",
    ProjectName: "مولدات الطاقة الكهربائية",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-002",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز حمدان ال نزهان Abdulaziz H Alnzhan",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "7500000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "ناصر عبدالعزيز القديري Nasser A. AlQudairi",
    ProjectOfficerContact: " ",
    sector_efada: "من المخطط ان يطرح في الربع الثالث",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "7500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "a5b1e8ca-c39e-ec11-8b02-0050569272df",
    ProjectName: "تجهيزات النادي الرياضي",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-003",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز حمدان ال نزهان Abdulaziz H Alnzhan",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-15T00:00:00",
    ProjectFinishDate: "2022-09-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "600000.000000",
    ContractValue: "337360.550000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "اصدار امر الشراء",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "ناصر عبدالعزيز القديري Nasser A. AlQudairi",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "600000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "260b40b6-c69e-ec11-8b02-0050569272df",
    ProjectName: "تأهيل و تجهيز وتشغيل المساحات المخصصة للقهوة",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-004",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "معاذ احمد محمد بامسعود muath a. bamasoud",
    ProjectDescription: null,
    ProjectStartDate: "2022-03-31T00:00:00",
    ProjectFinishDate: "2022-03-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "100000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "4673b741-c79e-ec11-8b02-0050569272df",
    ProjectName: "فنون البرج",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-005",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "نعم",
    ProjectManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectDescription: null,
    ProjectStartDate: "2022-03-31T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2200000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "مرحلة المسار السريع ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2200000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "84a3ab84-c89e-ec11-8b02-0050569272df",
    ProjectName: "استبدال الرقم (9200) بالرقم (800)",
    Department: "إدارة تميز العمليات",
    ProjectCode: "SS-22-007",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "سكيت علي سكيت الزغيبي Skait Ali Alzoghaibi",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2024-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبداللطيف محمد عرفه ABDULATEEF M ARAFA",
    ProjectOfficerContact: " ",
    sector_efada: "مؤجل",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "bb1af75b-c99e-ec11-8b02-0050569272df",
    ProjectName: "تحويل مركز الاتصال إلى مركز خدمات",
    Department: "إدارة تميز العمليات",
    ProjectCode: "SS-22-009",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "ماجد سليمان سليمان الهدهود majed s. alhadhoud",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "500000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبداللطيف محمد عرفه ABDULATEEF M ARAFA",
    ProjectOfficerContact: " ",
    sector_efada: "تحديث تاريخ الطرح إلى Q3 2022 - جاري اعدد الكراسة ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "7005d5ab-c99e-ec11-8b02-0050569272df",
    ProjectName: "الدعم الفني لنظام المحتوى الوثائقي",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-010",
    ProjectOwner: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    boardinitiative: "لا",
    ProjectManager: "تركي عبدالعزيز ناصر بن ضبعان Turki A. Bin Dhabaan",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2025-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1000000.000000",
    ContractValue: "1000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "رميح عبدالرحمن صالح الرميح romaih a. alromaih",
    ProjectOfficerContact: " ",
    sector_efada: "حالياً في مرحلة التقييم الفني ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "600000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "ed5b4efd-c99e-ec11-8b02-0050569272df",
    ProjectName: "مشروع تجديد نظام العمل عن بعد",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-011",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "فهد إبراهيم المناع fahad i. almnaa",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-31T00:00:00",
    ProjectFinishDate: "2023-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1000000.000000",
    ContractValue: "1000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "مخطط للطرح في Q3 - جاري اعادة دراسة احتياج المشروع ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "300000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "15f1714c-ca9e-ec11-8b02-0050569272df",
    ProjectName:
      "تطبيق استراتيجيات تقنية المعلومات ورفع الالتزام بممارسات تقنية المعلومات",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-012",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "يوسف حمد الدخيل Yousuf H. AlDakhil",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2023-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3000000.000000",
    ContractValue: "3000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم ايقاف الطرح لوجود تداخل مع مشروع COBIT التابع لادارة الحوكمة و من المخطط اعادة طرح الكراسة في 18.08.2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "b329d9a0-ca9e-ec11-8b02-0050569272df",
    ProjectName: "تصنيف ونقل بيانات الموارد المؤسسية",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-013",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز حازم المزروع Abdulaziz H Al Mazrou",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2023-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1500000.000000",
    ContractValue: "1500000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم تأجيل الطرح للربع الاخير نظراً لاعتماده على مشروع نظام إدارة و تخطيط الموارد المؤسسية ERP القائم حالياً",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "8c233cef-ca9e-ec11-8b02-0050569272df",
    ProjectName: "مشروع تطوير ChatBot",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-014",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عفراء علي محمد السويلم Afra A Alswailem",
    ProjectDescription: null,
    ProjectStartDate: "2022-08-31T00:00:00",
    ProjectFinishDate: "2023-08-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3000000.000000",
    ContractValue: "3000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      " تمت دراسة النطاق الخاص بالمشروع لوجود تغيير في تشريعات استضافة الخدمات و جاري اعداد الكراسة للطرح خلال الربع الثالث",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2250000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "f7905d3b-cb9e-ec11-8b02-0050569272df",
    ProjectName: "مشروع انشاء مركز بيانات في New HQ",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-015",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "فهد إبراهيم المناع fahad i. almnaa",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2024-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "15000000.000000",
    ContractValue: "15000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم طرح الكراسة و حالياً في مرحلة استلام العروض - سيتم فتح المظاريف في 15.08.2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "9000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "79690b8a-cb9e-ec11-8b02-0050569272df",
    ProjectName: "نظام نشر التحديثات الأمنية للبرامج",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-016",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "محمد سعود المطلق Mohammed S. Almotlak",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-31T00:00:00",
    ProjectFinishDate: "2025-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "500000.000000",
    ContractValue: "500000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "مخطط للطرح في Q3 ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "7949b0eb-cb9e-ec11-8b02-0050569272df",
    ProjectName: "مشروع زيادة الطاقة الاستيعابية للتخزين والنسخ الاحتياطي",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-018",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالمجيد سليمان الشمري abdulmajeed a. alshammari",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2025-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "4000000.000000",
    ContractValue: "4000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "مخطط للطرح في Q4 ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "bce22134-cc9e-ec11-8b02-0050569272df",
    ProjectName: "رخص برامج  و ادوات تطوير مكتبيه مختلفة",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-019",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالله محمد عبدالله بن هلال Abdullah M. Binhelal",
    ProjectDescription: null,
    ProjectStartDate: "2023-03-31T00:00:00",
    ProjectFinishDate: "2024-03-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "250000.000000",
    ContractValue: "250000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "مخطط للطرح في Q4 ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "250000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "7a001683-cc9e-ec11-8b02-0050569272df",
    ProjectName: "تطوير بوابة البنية المؤسسية",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-020",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "يوسف حمد الدخيل Yousuf H. AlDakhil",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-31T00:00:00",
    ProjectFinishDate: "2025-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "300000.000000",
    ContractValue: "300000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم تأجيل الطرح الى الربع الاخير نظراً لاعتماده على مشروع تطبيق و تشغيل مكتب البنية المؤسسية ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "300000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "c9c93fe9-cc9e-ec11-8b02-0050569272df",
    ProjectName: "مشروع تطوير DevOps",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-021",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "يوسف حمد الدخيل Yousuf H. AlDakhil",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2024-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "4500000.000000",
    ContractValue: "4500000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "التطبيقات",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم تأجيل طرح المشروع لنهاية الربع الاخير نظراَ لوجود نقص في الكوادر الفنية القادرة على ادارة المشروع في ظل وجود مشروعين قائمة وهي البنية المؤسسية و تطوير قسم اختبار التطبيقات ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "d08ad24e-cd9e-ec11-8b02-0050569272df",
    ProjectName: "أنظمة مراقبة وقياس الالتزام للأمن السيبراني",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-22-022",
    ProjectOwner: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    boardinitiative: "لا",
    ProjectManager: "يزيد محمد القديري Yazeed M. Alqedairi",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2024-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1500000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "طارق سليمان المحمود Tarek S Almahmoud",
    ProjectOfficerContact: " ",
    sector_efada: "تم طرح المشروع وفي مرحلة استلام العروض",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "300000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "83470ece-ce9e-ec11-8b02-0050569272df",
    ProjectName: "حوكمة البيانات المرحلة الثانية",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-22-023",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2023-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "5000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    ProjectOfficerContact: " ",
    sector_efada:
      "تمت موافقة سعادة الرئيس لتنفيذي على الطرح وجاري الاعداد لطرح الكراسة",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "f0f71b23-cf9e-ec11-8b02-0050569272df",
    ProjectName: "تفعيل النظام الاقراضي الجديد لكامل منتجات وخدمات البنك",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-024",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "نعم",
    ProjectManager: "Hassan F. Algarni",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-25T00:00:00",
    ProjectFinishDate: "2023-12-24T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "6000000.000000",
    ContractValue: "6000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "المشروع مؤجل نظراً لتعارضه مع مشروع الـ 10 منتجات المطروح من قبل قطاع الاعمال ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "db0bc877-cf9e-ec11-8b02-0050569272df",
    ProjectName: "توريد رخص إضافية لنظام الموارد المؤسسية ERP",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-025",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "محمد عبدالله السند Mohammed A. Alsanad",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-31T00:00:00",
    ProjectFinishDate: "2024-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "8000000.000000",
    ContractValue: "3260246.790000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "تم دمج المشروع مع مشروع الـ ERP القائم حالياً ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "2b66bac6-cf9e-ec11-8b02-0050569272df",
    ProjectName: "تقديم الخدمات الاستشارية للإشراف على تنفيذ المشاريع الهندسية",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-028",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "أحمد سفر النفيعي Ahmed S Alnefaie",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2024-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "6100000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "تمت موافقة سعادة الرئيس على الطرح وجاري طرح المشروع",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "bf41755b-d09e-ec11-8b02-0050569272df",
    ProjectName: "مشروع تعويضات ومزايا - تطوير الموارد البشرية",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-031",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "نعم",
    ProjectManager: "ندى سعد الفليج Nada s alflaij",
    ProjectDescription: null,
    ProjectStartDate: "2022-03-31T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "تم دمج نطاق عمل المشروع مع مشروع (تطوير نظام ادارة الاداء) ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "1907f8a8-d09e-ec11-8b02-0050569272df",
    ProjectName: "مشروع تقييم الوظائف - تطوير الموارد البشرية",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-032",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "نعم",
    ProjectManager: "ندى سعد الفليج Nada s alflaij",
    ProjectDescription: null,
    ProjectStartDate: "2022-05-22T00:00:00",
    ProjectFinishDate: "2023-05-22T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "100000.000000",
    ContractValue: "99820.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة ميرسر كونسلتنغ ليمتد ",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "المشروع تحت التنفيذ حسب المخطط ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "100000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "ae2b9ef6-d09e-ec11-8b02-0050569272df",
    ProjectName: "مشروع التعاقب الوظيفي - تطوير الموارد البشرية",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-033",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "نعم",
    ProjectManager: "خالد حمد الصائغ Khaled H Alsaigh",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2023-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "400000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم طلب الجهه الفنيه الغاء الطرح حيث ان الاسعار تتجاوز التكلفه التقديريه",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "400000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "73d17345-d19e-ec11-8b02-0050569272df",
    ProjectName: "مشروع تطوير نظام ادارة الاداء - تطوير الموارد البشرية",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-034",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "نعم",
    ProjectManager: "ندى سعد الفليج Nada s alflaij",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-15T00:00:00",
    ProjectFinishDate: "2023-09-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3500000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "تم طرح المشروع بتاريخ 20/07/2022م ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "d16c1e94-d19e-ec11-8b02-0050569272df",
    ProjectName: "تقديم خدمات استشارية قانونية",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-035",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "ندى سعد الفليج Nada s alflaij",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2023-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada:
      "جاري دراسة جدوى طرح المشروع وتقييم الاحتياج من قبل الاداره المالكه ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "5cc5fcdb-d19e-ec11-8b02-0050569272df",
    ProjectName: "قياس انتاجية وربحية الموظفين",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-036",
    ProjectOwner: "فواز عبدالله العمران Fawaz A Alomran",
    boardinitiative: "نعم",
    ProjectManager: "عبدالله فهد الدعفس Abdullah Fahad Al-Dafas",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "500000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "اصدار التوصية",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "ناصر محمد الهدهود Nasser M. AlHadhoud",
    ProjectOfficerContact: " ",
    sector_efada: "المشروع في مرحلة الطرح",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "59a8562a-d29e-ec11-8b02-0050569272df",
    ProjectName: "خدمات البحث والوصول الى الكفاءات المناسبة (LinkedIn)",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-037",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "منصور عبدالعزيز بن دليم Mansour A Bindulaym",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2023-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "800000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "المشروع في مرحلة الطرح",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "800000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "55d63979-d29e-ec11-8b02-0050569272df",
    ProjectName: "تطوير برنامج مستقبل التنمية (الخريجين الجدد)",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-038",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "خالد حمد الصائغ Khaled H Alsaigh",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2023-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "5000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "من المخطط ان يطرح في الربع الثالث",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "5000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "20bcbcc6-d29e-ec11-8b02-0050569272df",
    ProjectName:
      "OHI قياس مؤشرات صحة المنظومة وتفعيل المخرجات و خطط عمل التحول الثقافي المنظمي",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-039",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "نور سليمان السويح Nour S Alswayeh",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2023-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1250000.000000",
    ContractValue: "1502651.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة تاوارز واتسن العربية السعودية",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada:
      "بانتظار توقيع محضر بدء الاعمال وجاري استكمال ميثاق وخطة المشروع والجدول الزمني ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1250000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "cec1220e-d39e-ec11-8b02-0050569272df",
    ProjectName: "مبادرات خاصة بالفروع",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-040",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "نور سليمان السويح Nour S Alswayeh",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "504000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "اصدار التوصية",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "تحت اجراء توقيع محضر الغاء الطرح",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "504000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "76d0b356-d39e-ec11-8b02-0050569272df",
    ProjectName: "افتتاح المبنى الجديد",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-041",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "نور سليمان السويح Nour S Alswayeh",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2022-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "200000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "تم انتقال نطاق عمل المشروع الى قطاع الاستراتيجية والابتكار",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "200000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "4f39c7f2-d39e-ec11-8b02-0050569272df",
    ProjectName:
      "تقديم خدمات استشارية لشهادة الاعتماد للمشتريات والتوريد من CIPS - Advanced Procurement Excellence Programe",
    Department: "إدارة المشتريات والعقود",
    ProjectCode: "SS-22-043",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "lamia N. aldeghaither",
    ProjectDescription: null,
    ProjectStartDate: "2022-11-15T00:00:00",
    ProjectFinishDate: "2024-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "خالد بن زيد الرويس Khalid Z. AlRuwais",
    ProjectOfficerContact: " ",
    sector_efada: "سيطرح في الربع الرابع من 2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "33bfb246-d49e-ec11-8b02-0050569272df",
    ProjectName: "صيانة مركز البيانات",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-044",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "رميح عبدالرحمن صالح الرميح romaih a. alromaih",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2023-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "300000.000000",
    ContractValue: "300000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "اعتماد محضر فحص العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "تم احالته للتأهيل ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "300000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "bf9bac95-d49e-ec11-8b02-0050569272df",
    ProjectName: "صيانة نظام حاسب",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-045",
    ProjectOwner: "يزيد عبدالرحمن سعد المقري yazeed almugarry",
    boardinitiative: "لا",
    ProjectManager: "عبدالإله عبدالعزيز الهزاني Abdulelah A. Alhazzani",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2024-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "4000000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "رميح عبدالرحمن صالح الرميح romaih a. alromaih",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم رفع طلب تغيير للاستفادة من تمديد العقد 10% - تم الاعتماد و",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "a9f8c3dd-d49e-ec11-8b02-0050569272df",
    ProjectName: "تطبيق المتطلبات الأمنية",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-046",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "فهد إبراهيم المناع fahad i. almnaa",
    ProjectDescription: null,
    ProjectStartDate: "2023-03-31T00:00:00",
    ProjectFinishDate: "2023-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "5000000.000000",
    ContractValue: "5000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "مخطط للطرح في Q4 ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "9459452b-d59e-ec11-8b02-0050569272df",
    ProjectName: "مشروع تشغيل ودعم البنية التحتية",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-047",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "فهد إبراهيم المناع fahad i. almnaa",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2024-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "7500000.000000",
    ContractValue: "5720560.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "اعتماد محضر فحص العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "جاري اعداد مسودة العقد ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "6000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "7d1cb278-d59e-ec11-8b02-0050569272df",
    ProjectName: "مشروع تجديد نظام الدعم الفني",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-048",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالله محمد عبدالله بن هلال Abdullah M. Binhelal",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-31T00:00:00",
    ProjectFinishDate: "2023-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1000000.000000",
    ContractValue: "1000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "مخطط للطرح في Q3 ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "9c021771-d69e-ec11-8b02-0050569272df",
    ProjectName:
      "تعزيز الالتزام بالتشريعات والتنظيمات الصادرة من الجهات الرقابية وزيادة نضج أمن المعلومات",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-22-050",
    ProjectOwner: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    boardinitiative: "لا",
    ProjectManager: "طارق سليمان المحمود Tarek S Almahmoud",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2024-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1500000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    ProjectOfficerContact: " ",
    sector_efada: "تم طرح المشروع وفي مرحلة التقييم الفني",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "200000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "2a027ab8-d69e-ec11-8b02-0050569272df",
    ProjectName: "تعزيز الوعي ورفع الرقابة المرتبطة بالأمن السيبراني",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-22-051",
    ProjectOwner: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    boardinitiative: "لا",
    ProjectManager: "يزيد محمد القديري Yazeed M. Alqedairi",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2024-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "500000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "طارق سليمان المحمود Tarek S Almahmoud",
    ProjectOfficerContact: " ",
    sector_efada: "تم طرح المشروع وفي مرحلة التقييم الفني",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "100000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "2fb7a4b6-d79e-ec11-8b02-0050569272df",
    ProjectName: "تطوير الالتزام في قطاع الخدمات المشتركة",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-22-052",
    ProjectOwner: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    boardinitiative: "لا",
    ProjectManager: "نوف سلطان البقمي Nouf S ALbogami",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2024-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "800000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    ProjectOfficerContact: " ",
    sector_efada: "تم طرح المشروع وفي مرحلة استلام العروض",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "300000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "55620604-d89e-ec11-8b02-0050569272df",
    ProjectName: "تطبيق COBIT",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-22-053",
    ProjectOwner: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    boardinitiative: "لا",
    ProjectManager: "علي عبدالله السبر Ali A. Al-Sabr",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2023-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1200000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "استلام العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "نوف سلطان البقمي Nouf S ALbogami",
    ProjectOfficerContact: " ",
    sector_efada: "تم طرح المشروع وفي مرحلة استلام العروض",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "400000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "518b424c-d89e-ec11-8b02-0050569272df",
    ProjectName: "خدمات استشارية لتطبيق استراتيجية التحول الرقمي",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-054",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عفراء علي محمد السويلم Afra A Alswailem",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2023-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3000000.000000",
    ContractValue: "3000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      'محفظة و يندرج تحتها مشروعي :"تطبيق استراتيجية التحول الرقمي" و" تجديد رخص أنظمة مزامنة و نقل البيانات (ETL-CDC)" ',
    pmo_efada:
      "حسب طلب القطاع، يعامل كمحفظة يندرج تحتها مشروعين (SS-22-067) و (SS-22-066)",
    cat_efada: null,
    YearBudget: "1750000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "48dadb9a-d89e-ec11-8b02-0050569272df",
    ProjectName: "اشتراك منصة استشارات",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-055",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "نور سليمان السويح Nour S Alswayeh",
    ProjectDescription: null,
    ProjectStartDate: "2022-03-31T00:00:00",
    ProjectFinishDate: "2022-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "99000.000000",
    ContractValue: "99000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany:
      "جامعة الأميرة نورة بنت عبدالرحمن /الدراسات و الخدمات الاستشارية",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "تم توقيع العقد و بانتظار توقيع محضر بدء الاعمال ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "99000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "af63afe8-d89e-ec11-8b02-0050569272df",
    ProjectName: "استعلامات البيانات المالية",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-056",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "Hassan F. Algarni",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-31T00:00:00",
    ProjectFinishDate: "2023-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "10000000.000000",
    ContractValue: "10000000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "اتفاقية و ليس مشروع - تم توقيع الاتفاقية في الربع الاول ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "10000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "59669837-d99e-ec11-8b02-0050569272df",
    ProjectName: "التأمين على ممتلكات البنك",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-057",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "محمد سعود البليهد Mohammed S. Alblaihed",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2022-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "300000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "300000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "ff9d7e7e-d99e-ec11-8b02-0050569272df",
    ProjectName:
      "مبادرات وفعاليات التواصل الداخلي وتجربة الموظفين (حسب التقويم السنوي)",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-058",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2023-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2000000.000000",
    ContractValue: "1950000.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة خمسة حروف للخدمات التجارية",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "اعتماد محضر فحص العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "في انتظار توقيع العقد ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2000000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "3e51c1cc-d99e-ec11-8b02-0050569272df",
    ProjectName: "حملة تفعيل القيم",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-059",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "نعم",
    ProjectManager: "نور سليمان السويح Nour S Alswayeh",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "150000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: null,
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "150000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "6a0cd013-da9e-ec11-8b02-0050569272df",
    ProjectName:
      "توريد وتركيب غرفة متنقلة بالمبنى الرئيسي لبنك التنمية الاجتماعية",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-060",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "معاذ احمد محمد بامسعود muath a. bamasoud",
    ProjectDescription: null,
    ProjectStartDate: "2022-04-07T00:00:00",
    ProjectFinishDate: "2022-05-05T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "100000.000000",
    ContractValue: "93150.000000",
    RevisedContractValue: null,
    PaidAmount: "93150",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "100000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "1c76a85f-da9e-ec11-8b02-0050569272df",
    ProjectName: "توريد اجهزه كهربائيه للمطابخ الموزعة في الأدوار",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-061",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "معاذ احمد محمد بامسعود muath a. bamasoud",
    ProjectDescription: null,
    ProjectStartDate: "2022-04-27T00:00:00",
    ProjectFinishDate: "2022-05-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "441",
    BudgetItemName: "صيانة وتطوير المباني والاشراف",
    EstimatedBudget: null,
    ApprovedBudget: "76590.000000",
    ContractValue: "76590.000000",
    RevisedContractValue: null,
    PaidAmount: "76590.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "مؤسسة دار الصفاء للتجارة",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "اصدار امر الشراء",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "76590.00",
    SpentYearBudget: "76590.000000",
  },
  {
    ProjectUID: "73a314a7-da9e-ec11-8b02-0050569272df",
    ProjectName: "أجهزة بيع ذاتية Vending Machine",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-062",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالمحسن خالد الغصن Abdulmuhsen K. Alghusn",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-30T00:00:00",
    ProjectFinishDate: "2022-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "120000.000000",
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "نوره احمد علي الشهري Norah A. Alshahri",
    ProjectOfficerContact: " ",
    sector_efada: "مرحلة التحليل الفني ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "120000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "b10f56e8-da9e-ec11-8b02-0050569272df",
    ProjectName: "مشروع تهيئة الموظفين الجدد",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-22-063",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "نور سليمان السويح Nour S Alswayeh",
    ProjectDescription: null,
    ProjectStartDate: "2022-06-30T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "500000.000000",
    ContractValue: "329267.000000",
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة المستوى التالي الدولية",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "اعتماد محضر فحص العروض",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "بانتظار توقيع محضر بدء الاعمال ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "500000.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "5eca63de-53a0-456f-9d3e-0bab39db0486",
    ProjectName: "توريد وتركيب اثاث مبني بنك التنمية الاجتماعية",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-21-011",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "نوره احمد علي الشهري Norah A. Alshahri",
    ProjectDescription:
      "تأثيث مبني الأدارة الجديد\r\n\r\nتوريد وتركيب اثاث مبني بنك التنمية الاجتماعي",
    ProjectStartDate: "2021-07-01T00:00:00",
    ProjectFinishDate: "2022-02-20T00:00:00",
    BIProjectStartDate: "2021-07-01T08:00:00",
    BIProjectFinishDate: "2021-11-01T17:00:00",
    PlannedCompletePercent: "100",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "16741700.000000",
    ApprovedBudget: "16741700.000000",
    ContractValue: "16741700.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "1674170.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "شركة هشام نبيل علي رضا التجارية",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada:
      "بانتظار اعتماد امر التغيير - تم فقد اصل خطاب الترسيه من قبل الشركه المنفذه وعليه تم رفع المطالبه الماليه الى ديوان المحاسبه لأيجازه الصرف",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "37ca1e70-8cc5-47d9-ac76-0c3d0ad157ab",
    ProjectName: "تنفيذ خدمات إعلامية لافتتاح فرع البنك بتبوك (جادة30)",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-014",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "اشواق عمر إبراهيم السليم Ashwag O. Al-Saliem",
    ProjectDescription: "تنفيذ خدمات إعلامية لإفتتاح فرع البنك بالدمام",
    ProjectStartDate: "2021-12-30T00:00:00",
    ProjectFinishDate: "2022-07-31T00:00:00",
    BIProjectStartDate: "2021-08-01T08:00:00",
    BIProjectFinishDate: "2022-07-31T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية",
    EstimatedBudget: "500000.000000",
    ApprovedBudget: "499790.000000",
    ContractValue: "499790.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "499790.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة الطاووس (بافو)",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "خالد راشد الثويني Khaled R Althowaini",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "499790.00",
    SpentYearBudget: "499790.000000",
  },
  {
    ProjectUID: "271fc0a9-dd42-4712-81ea-0d5af7361890",
    ProjectName: "توريد وتركيب أجهزة كهربائية لمطبخ الرئيس التنفيذي بالبرج",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-072",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز حمدان ال نزهان Abdulaziz H Alnzhan",
    ProjectDescription:
      "توريد وتركيب أجهزة كهربائية لمطبخ الرئيس التنفيذي بالبرج",
    ProjectStartDate: "2022-03-27T00:00:00",
    ProjectFinishDate: "2022-04-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "290",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "45252.500000",
    ContractValue: "45252.500000",
    RevisedContractValue: "45252.500000",
    PaidAmount: "45252.50",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "مؤسسة دار الصفاء للتجارة",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "45252.50",
    SpentYearBudget: "45252.500000",
  },
  {
    ProjectUID: "971083e2-4c88-4b1f-b16b-102c912f0516",
    ProjectName: "خدمة نذير للتأمين",
    Department: "إدارة العمليات البنكية",
    ProjectCode: "BU-22-006",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "محمد سعود البليهد Mohammed S. Alblaihed",
    ProjectDescription: "خدمة نذير للتأمين",
    ProjectStartDate: "2022-09-01T00:00:00",
    ProjectFinishDate: "2022-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "100000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: " ",
    ProjectOwner1: "عبدالعزيز عبدالله عثمان العتيق abdulaziz a. alateeq",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "100000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "82363c9f-09b6-4778-90f7-1078132cd323",
    ProjectName: "دراسة فرص تطوير قطاع الأسر المنتجة في جميع مناطق المملكة",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-051",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    ProjectDescription:
      "دراسة فرص تطوير قطاع الأسر المنتجة في جميع مناطق المملكة\r\n\r\n",
    ProjectStartDate: "2022-08-14T00:00:00",
    ProjectFinishDate: "2023-08-14T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "5000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "تم تسليم الكراسة للوزارة في 28 يونيو للطرح ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "0aae1674-948c-43b9-98ac-11bc5a950fc5",
    ProjectName: "رفع مؤشر قياس التحول الإلكتروني (يسر)",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-20-003",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "غادة حمد العجلان Ghadah H Alajlan",
    ProjectDescription: "رفع مؤشر قياس التحول الإلكتروني (يسر) ",
    ProjectStartDate: "2020-01-01T00:00:00",
    ProjectFinishDate: "2020-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "1f237860-9752-44eb-99db-14ee2bad75f4",
    ProjectName: "التأمين الطبي لموظفي البنك",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-21-007",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: null,
    ProjectManager: "ناصر محمد الهدهود Nasser M. AlHadhoud",
    ProjectDescription: "التأمين الطبي لموظفي البنك",
    ProjectStartDate: "2021-04-20T00:00:00",
    ProjectFinishDate: "2022-04-19T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "48646813.000000",
    ContractValue: "49901618.000000",
    RevisedContractValue: "48646813.000000",
    PaidAmount: "48646813.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "التعاونية للتأمين ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: null,
    NotAligned: null,
    AlignedComments: null,
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "98875ebe-ff9a-4572-8eef-154ee988a671",
    ProjectName:
      "تقديم الخدمات الاستشارية لمركزية الحسابات ببنك التنمية الاجتماعية",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-21-009",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "حماد عبدالله صالح المحيسن Hammad A. AlMuhaysin",
    ProjectDescription: "دمج حسابات الفروع مع الأدارة ",
    ProjectStartDate: "2022-06-01T00:00:00",
    ProjectFinishDate: "2022-12-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "3000000.000000",
    ApprovedBudget: "2000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (1)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada: "تمت ترسية المشروع",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "2000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b76b6236-1f27-4d76-8ad3-1c3facd1c0e7",
    ProjectName: "الحملة التسويقية للخدمات المالية وغير المالية للأسر المنتجة",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "BU-22-060",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "دانيا عثمان المنيع Dania O. Almanea",
    ProjectDescription:
      "الحملة التسويقية للخدمات المالية وغير المالية للأسر المنتجة",
    ProjectStartDate: "2022-04-28T00:00:00",
    ProjectFinishDate: "2023-01-13T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "14000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "جاري تحديد المتطلبات مع ادارة الاسر المنتجة ",
    pmo_efada: "من ضمن مشاريع التحول الوطني ",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "4bb60aa5-5656-47da-9d2d-1def75560125",
    ProjectName: "توثيق قصص النجاح",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-021",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "يارا خالد الشهري Yara K. Alshehri",
    ProjectDescription: "توثيق قصص النجاح ",
    ProjectStartDate: "2022-03-03T00:00:00",
    ProjectFinishDate: "2023-03-03T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية (خدمات إبداعية إعلامية )",
    EstimatedBudget: "500000.000000",
    ApprovedBudget: "500000.000000",
    ContractValue: "499100.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "499100.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: "دانيا عثمان المنيع Dania O. Almanea",
    sector_efada: "جاري صرف والرفع لإدارة المالية ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "499100.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "af9f6a19-83a4-4247-99cf-204635287888",
    ProjectName: "فرع الرياض",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-027",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "نعم",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "جادة الرياض ",
    ProjectStartDate: "2021-11-03T00:00:00",
    ProjectFinishDate: "2022-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "خالد عبداللطيف ابراهيم الخميس Khaled A. AlKhames",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b367caac-211e-42fe-b1e6-2151d8ab0013",
    ProjectName: "مشروع تنفيذ حملة إعلامية لمنتج تمويل نقاط البيع",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-007",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "يارا خالد الشهري Yara K. Alshehri",
    ProjectDescription: "مشروع تنفيذ حملة إعلامية لمنتج تمويل المنشآت",
    ProjectStartDate: "2021-12-30T00:00:00",
    ProjectFinishDate: "2022-12-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "238",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية ",
    EstimatedBudget: "500000.000000",
    ApprovedBudget: "500000.000000",
    ContractValue: "500000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "500000.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "مؤسسة طاووس الإبداع للدعاية والإعلان ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "خالد راشد الثويني Khaled R Althowaini",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      " جاري رفع الفواتير النهائية ومحظر إنجاز ونموذج إغلاق المشروع ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "500000.00",
    SpentYearBudget: "500000.000000",
  },
  {
    ProjectUID: "2f67c880-745f-4303-b83d-22741c204742",
    ProjectName: "تحول فروع البنك (جادة 30) المرحلة الثالثة",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-064",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: "تحول فروع البنك (جادة 30) المرحلة الثالثة",
    ProjectStartDate: "2022-10-01T00:00:00",
    ProjectFinishDate: "2023-12-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "8d5cfe72-4de5-43af-bce4-22dabc87ee01",
    ProjectName: "أدوات تسويقية لمنتجات وخدمات البنك المالية والغير مالية",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-028",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectDescription:
      "مشروع ابتكار وصناعة أدوات تسويقه لمنتجات وخدمات البنك المالية والغير مالية ",
    ProjectStartDate: "2022-08-01T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "16175000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "فهد عبدالرحمن محمد الرواف fahad a. alrawaf",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "تم الانتهاء من اعداد الكراسة ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4875000",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "62dad524-e9ed-4c6a-925b-237d793c5f84",
    ProjectName:
      "اعمال تطوير وتشغيل منصة MS Dynamics 365 لرفع كفاءة الخدمات البنكية",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-033",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "يوسف حمد الدخيل Yousuf H. AlDakhil",
    ProjectDescription:
      "اعمال تطوير وتشغيل منصة MS Dynamics 365 لرفع كفاءة الخدمات البنكية",
    ProjectStartDate: "2022-04-28T00:00:00",
    ProjectFinishDate: "2023-04-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "8500000.000000",
    ContractValue: "8500000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "اصدار التوصية",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم فتح العروض الفنية للمرحلة الثانية بتاريخ 01.06.2022 و تمت إحالة العروض للجهة الفنية 05.06.2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "7000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "8d0f5d29-37bb-479b-87be-238dad714e1e",
    ProjectName: "الربط بين الأنظمة المالية المستخدمة",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-20-005",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "Hassan F. Algarni",
    ProjectDescription: "الربط بين الأنظمة المالية المستخدمة",
    ProjectStartDate: "2020-04-02T00:00:00",
    ProjectFinishDate: "2020-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "في حاجة لاستكمال البيانات الأساسية للمشروع",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b39d1331-4795-4805-b5b7-25b4fa66169f",
    ProjectName:
      "مركزة معالجة الأمانات نقل مهام عمليات التمويل الاجتماعي إلى العمليات البنكية",
    Department: "إدارة العمليات البنكية",
    ProjectCode: "SS-21-026",
    ProjectOwner: "عبدالعزيز عبدالله عثمان العتيق abdulaziz a. alateeq",
    boardinitiative: "لا",
    ProjectManager: "محمد سعود البليهد Mohammed S. Alblaihed",
    ProjectDescription:
      "مركزة معالجة الأمانات\r\nنقل مهام عمليات التمويل الاجتماعي إلى العمليات البنكية",
    ProjectStartDate: "2021-12-09T00:00:00",
    ProjectFinishDate: "2021-12-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "تركي صالح محمد اليوسف Turki Al Yousef",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "في حاجة لاستكمال البيانات الأساسية للمشروع",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "de03f0f4-ecf2-4e5d-994f-25bf76b70552",
    ProjectName: "تأسيس وتشغيل حاضنات الانتاج في الإقليم الأوسط",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-057",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    ProjectDescription: "تأسيس وتشغيل حاضنات الانتاج في الإقليم الأوسط\r\n\r\n",
    ProjectStartDate: "2022-10-16T00:00:00",
    ProjectFinishDate: "2023-10-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "13010640.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "مرتبطة بطرح مشروع تأسيس حاضنات الإنتاج في الإقليم الشمالي - سيتم تجويد نطاق العمل بناء على العروض الفنية المقدمة",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "79ffeeb4-fb3d-4259-95a0-26124c4945f2",
    ProjectName: "تطبيق زيارة المشاريع - الربط مع الدفعات",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-003",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "ABDULAZIZ SAUD ALHARBI",
    ProjectDescription: "تطبيق زيارة المشاريع/ الربط مع الدفعات",
    ProjectStartDate: "2021-01-03T00:00:00",
    ProjectFinishDate: "2021-05-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "في حاجة لاستكمال البيانات الأساسية للمشروع",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "9af73c7e-dbcc-4c80-a3bc-289bd52d340e",
    ProjectName: "تطوير بوابة الجهات الحكومية لخدمة النموذج الجديد",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-004",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "Hassan F. Algarni",
    ProjectDescription: "تطوير بوابة الجهات الحكومية لخدمة النموذج الجديد",
    ProjectStartDate: "2021-02-01T00:00:00",
    ProjectFinishDate: "2021-10-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "76e29b49-bcea-4cf1-9e1b-2a716f18eb41",
    ProjectName: "تطوير خدمة موعد المرحلة الثانية",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-122",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "تطوير خدمة موعد المرحلة الثانية\t",
    ProjectStartDate: "2023-03-01T00:00:00",
    ProjectFinishDate: "2023-04-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: null,
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: null,
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "68eefdee-ea2e-40fa-9746-2d4832b22411",
    ProjectName: "ابتكار وصناعه الأدوات التسويقية لمنتجات تمويل الافراد",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "BU-22-016",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectDescription:
      "ابتكار وصناعه الأدوات التسويقية لمنتجات تمويل الافراد ",
    ProjectStartDate: "2022-07-01T00:00:00",
    ProjectFinishDate: "2023-07-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم دمج المشروع تحت مشروع ابتكار وصناعة أدوات تسويقه لمنتجات وخدمات البنك المالية والغير ماليه - الرمز ST-22-028",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "f8c3def6-9db3-4703-b77f-2f3050932b9e",
    ProjectName: "تقديم خدمات استشارية للدراسات الاكتوراية",
    Department: "إدارة التقارير والميزانية",
    ProjectCode: "FI-22-003",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "تركي خالد الجبرين TURKI K. ALJEBREEN",
    ProjectDescription:
      "دراسة اكتواريه حسب متطلبات المعايير الدولية لمخصص نهاية الخدمة واجازات الموظفين",
    ProjectStartDate: "2022-12-15T00:00:00",
    ProjectFinishDate: "2023-12-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1500000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "فهد تركي محمد السديري fahad alsudairy",
    ProjectOwner1: "عادل عبدالله الدحيم Adel A. Alduhaim",
    ProjectOfficerContact: " ",
    sector_efada: "سوف يتم طرح المشروع في الربع الرابع لعام 2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1500000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "cea6571b-7d45-4508-9cda-325c806352f6",
    ProjectName: "رفع تقييم البنك في تطبيق (وطني)",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-001",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "الهنوف فهد الموكاء AlHanof F. AlMouka",
    ProjectDescription: "رفع تقييم البنك في تطبيق (وطني)",
    ProjectStartDate: "2021-01-01T00:00:00",
    ProjectFinishDate: "2021-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d8f954b8-912f-411d-b844-33016ba8d879",
    ProjectName: "بوابة البنك الموحدة",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-22-065",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "Hassan F. Algarni",
    ProjectDescription: "\t\r\nبوابة البنك الموحدة",
    ProjectStartDate: "2022-08-01T00:00:00",
    ProjectFinishDate: "2023-07-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "المشروع غير واضح ولم يصل أي متطلبات له ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "09543f86-1607-4425-b538-374e70e0d1c0",
    ProjectName: "مبادرة دعم التعليم على منتج افق",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-009",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: null,
    ProjectManager: "ABDULAZIZ SAUD ALHARBI",
    ProjectDescription: "مبادرة دعم التعليم على منتج افق",
    ProjectStartDate: "2021-06-01T00:00:00",
    ProjectFinishDate: "2021-06-24T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: null,
    NotAligned: null,
    AlignedComments: null,
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "f06f3dd8-6374-41cf-9693-3ad714701cc1",
    ProjectName: "تحلية المياه (برادات)",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-075",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "ناصر عبدالعزيز القديري Nasser A. AlQudairi",
    ProjectDescription: "تحلية المياه (برادات) ",
    ProjectStartDate: "2022-10-15T00:00:00",
    ProjectFinishDate: "2022-12-29T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "25000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "3c82bbd6-b5ce-41c5-aeb1-3bb5993cbd09",
    ProjectName: "تجهيز وتأثيث مباني الفروع",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-028",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "تجهيز وتأثيث مباني الفروع ",
    ProjectStartDate: "2022-10-31T00:00:00",
    ProjectFinishDate: "2023-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3700000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada:
      "تم تقسيم المشروع الى مشروعين : مشروع تأهيل فرع البنك في جازان بالترميز BU-22-133 ,lav,u تأثيث فروع البنك (جدة، مكة المكرمة، المدينة المنورة، جازان، حائل، الجوف) بالترميز BU-22-134",
    cat_efada: null,
    YearBudget: "3700000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "108f1ad0-e93d-41d6-9331-3c9d97f425dc",
    ProjectName: "القرض الآني",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-20-009",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالسلام عبدالرحمن داحس الجلاجل Abdulsalam A. Al Jalajil",
    ProjectDescription: "القرض الآني",
    ProjectStartDate: "2020-12-31T00:00:00",
    ProjectFinishDate: "2021-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "500000.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (1)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: "Khalid Abdulaziz Alothman",
    sector_efada: "المشروع مكتمل- تم الاطلاق ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "3621ec73-d0d7-4eaa-80e5-402a5e067995",
    ProjectName: "تقديم استشارات لإدارة المخاطر",
    Department: "إدارة تقييم ومعالجة المخاطر",
    ProjectCode: "RI-22-001",
    ProjectOwner:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    boardinitiative: "لا",
    ProjectManager: "راشد علي احمد الراشد Rashed A. AlRashed",
    ProjectDescription:
      "تقديم استشارات وخدمات استشارية وإشرافيه على تنفيذ فعاليات ومبادرات تطوير عمل إدارة المخاطر ",
    ProjectStartDate: "2022-06-01T00:00:00",
    ProjectFinishDate: "2023-06-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "8000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "إدارة المخاطر",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "إدارة المخاطر",
    ProgramManager: "فهد تركي محمد السديري fahad alsudairy",
    ProjectOwner1:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    ProjectOfficerContact: " ",
    sector_efada: "تم تأجيل طرح المشروع الى 01/08/2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "5000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "1addafe8-9b85-4d27-9499-44becf5b3f75",
    ProjectName:
      "التصنيف الإئتماني للاسر المنتجة ووسطاء التمويل (المرحلة الأولى)",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-21-048",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectDescription:
      "التصنيف الإئتماني للاسر المنتجة ووسطاء التمويل (المرحلة الأولى)",
    ProjectStartDate: "2021-11-30T00:00:00",
    ProjectFinishDate: "2021-11-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: " ",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "هل يعتبر هذا المشروع المرحلة الأولى او الثانية ",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "baf3f62e-cb63-453a-bb95-4661d2468e28",
    ProjectName:
      "تقديم خدمات النظافة ومكافحة الحشرات في فروع بنك التنمية الاجتماعية",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-18-001",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "ماهر يحيى فتيني احمد Maher Y. Ahmed",
    ProjectDescription:
      "تقديم خدمات النظافة ومكافحة الحشرات في فروع بنك التنمية الاجتماعية",
    ProjectStartDate: "2018-04-01T00:00:00",
    ProjectFinishDate: "2021-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "10198440.000000",
    ContractValue: "10198440.000000",
    RevisedContractValue: "11090803.000000",
    PaidAmount: "11090803.50",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة سراكو ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "تم تمديد المشروع 10% ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "7180c91f-ab08-4229-b35e-4c09eef1353a",
    ProjectName:
      "بناء القدرات الرقمية للتمكين والتنمية (تدريب - استشارات - إرشاد)",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-061",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "رشا عبدالعزيز محمد برخيل Rasha A. Albarkheel",
    ProjectDescription:
      "بناء القدرات الرقمية للتمكين والتنمية (تدريب - استشارات - إرشاد)",
    ProjectStartDate: "2021-12-01T00:00:00",
    ProjectFinishDate: "2022-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "لم يتم تسليمنا المتطلبات للتنفيذ",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "مكرر من مشروع تطوير بوابة الكترونية للتدريب وبناء القدرات (تم الاتفاق مع إدارة تقنية المعلومات), سيتم رفع نموذج طلب الغاء",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "c2bdad9c-9c0a-457a-a94c-4df4821f1241",
    ProjectName:
      "توريد الأجهزة الكهربائية وتقنية المعلومات لعدد 6 مواقع جادة 30 المرحلة الثانية",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-020",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      "توريد الأجهزة الكهربائية وتقنية المعلومات لعدد 6 مواقع جادة 30 المرحلة الثانية",
    ProjectStartDate: "2022-06-15T00:00:00",
    ProjectFinishDate: "2022-11-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "4900000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada:
      " المشروع متوقف بسبب ارتباطه بمخرجات مشروع التصاميم الهندسية وجاهزية المباني والمتوقع لبدء التنفيذ في 7 مارس 2023",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "4900000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "acd3afc1-bd0f-4c6f-b136-4e6c4d1db7eb",
    ProjectName: "مشروع حملة إعلانية ( اليوم العالمي للادخار )",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-018",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "فيصل فهد عبدالله الخليفة Faisal F. Alkhalifa",
    ProjectDescription: "مشروع حملة إعلامية لتوعية بالادخار",
    ProjectStartDate: "2021-12-30T00:00:00",
    ProjectFinishDate: "2022-06-30T00:00:00",
    BIProjectStartDate: "2021-10-31T08:00:00",
    BIProjectFinishDate: "2021-11-30T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "239",
    BudgetItemName: "تصميم برامج التوفير والادخار",
    EstimatedBudget: "500000.000000",
    ApprovedBudget: "499100.000000",
    ContractValue: "499100.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "499100.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة أكوان لدعاية والإعلان ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "خالد راشد الثويني Khaled R Althowaini",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "جاري رفع الفاتورة النهائية ومحظر إنجاز ونموذج إغلاق المشروع ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "499100.00",
    SpentYearBudget: "499100.000000",
  },
  {
    ProjectUID: "1c94e84a-f15b-4d42-b420-52a68d56b46b",
    ProjectName: "ابتكار وصناعة أدوات تسويقه لدعم وتمكين الأسر المنتجة",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-22-029",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectDescription: "ابتكار وصناعة أدوات تسويقه لدعم وتمكين الأسر المنتجة",
    ProjectStartDate: "2022-11-01T00:00:00",
    ProjectFinishDate: "2023-04-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "5300000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "فهد عبدالرحمن محمد الرواف fahad a. alrawaf",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "مشاريع منقولة من قطاع الاعمال وجاري تحديد نطاق العمل ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "7f8a6315-d214-415f-b136-56f06aad6f9f",
    ProjectName:
      "التأمين على الحياة والتأمين على المركبات والتأمين على المنشآت للمحفظة الاقراضية للبنك",
    Department: "إدارة العمليات البنكية",
    ProjectCode: "BU-22-045",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "محمد سعود البليهد Mohammed S. Alblaihed",
    ProjectDescription:
      "التأمين على الحياة والتأمين على المركبات والتأمين على المنشآت للمحفظة الاقراضية للبنك ",
    ProjectStartDate: "2022-10-20T00:00:00",
    ProjectFinishDate: "2023-10-19T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "133000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبدالعزيز عبدالله عثمان العتيق abdulaziz a. alateeq",
    ProjectOfficerContact: " ",
    sector_efada: "جاري اعداد الكراسة وعكس ملاحظات الجهات ذات العلاقة",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "133000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "c52487f3-9c5b-4c65-b95c-5b3afbaaaf32",
    ProjectName: "تقرير مراكز التكلفة",
    Department: "إدارة التقارير والميزانية",
    ProjectCode: "FI-22-008",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "عبدالله محمد عبدالله العقيل abdullah m. alaqeel",
    ProjectDescription: "تقرير مراكز التكلفة",
    ProjectStartDate: "2022-06-06T00:00:00",
    ProjectFinishDate: "2022-06-23T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متوقع التأخير/ملاحظة مهمة",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "تركي خالد الجبرين TURKI K. ALJEBREEN",
    ProjectOfficerContact: " ",
    sector_efada: "جاري العمل على تطوير وثيقة الإجراءات والمتطلبات (BRD) ",
    pmo_efada: "لم يتم تزويدنا بتواريخ المشروع حتى الان",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "c67c3e8b-c053-4d58-a78e-5ba0b2bcba44",
    ProjectName:
      "تجديد رخص نقل ومزامنة البيانات CDC الخاص بالخدمات الاستشارية لتشغيل إدارة البيانات",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-22-066",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز حازم المزروع Abdulaziz H Al Mazrou",
    ProjectDescription:
      "تجديد رخص نقل ومزامنة البيانات CDC الخاص بالخدمات الاستشارية لتشغيل إدارة البيانات",
    ProjectStartDate: "2022-03-22T00:00:00",
    ProjectFinishDate: "2022-03-23T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "500000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada:
      "في مرحلة التقييم الفني -سيتم اعادته للجهة الفنية لوجود ملاحظات على التحليل الفنية ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b7308c2a-d4d0-45d4-98b6-5c6022c31205",
    ProjectName: "تمويل الاصول وراس المال العامل من خلال كشف حساب العميل",
    Department: "مكتب إدارة مشاريع الأعمال",
    ProjectCode: "BU-21-050",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectDescription:
      "تمويل الاصول وراس المال العامل من خلال كشف حساب العميل",
    ProjectStartDate: "2021-11-30T00:00:00",
    ProjectFinishDate: "2021-11-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: " ",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "لا يوجد بيانات للمشروع",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "e86ee505-8d8d-461d-a758-5d2296c2b4a0",
    ProjectName: "تأسيس وتشغيل حاضنات الانتاج في الإقليم الشمالي",
    Department: "إدارة تطوير البرامج والمنتجات",
    ProjectCode: "BU-22-055",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    ProjectDescription:
      "تأسيس وتشغيل حاضنات الانتاج في الإقليم الشمالي\r\n\r\n",
    ProjectStartDate: "2022-10-02T00:00:00",
    ProjectFinishDate: "2023-10-02T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "9780980.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة الطرح - معالجة ملاحظات إدارة المشتريات",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "02843c32-7ef1-4043-a582-5f97d0d4545e",
    ProjectName: "زود بلس",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-044",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "اسامه عبدالمجيد عبدالله الفلاح Osama A Alfalah",
    ProjectDescription: "زود بلس",
    ProjectStartDate: "2022-04-30T00:00:00",
    ProjectFinishDate: "2022-06-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: " ",
    sector_efada: "المشروع كان فكرة فقط وليس مشروع ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "3328b401-3584-450e-99f2-6390b8043bab",
    ProjectName: "متابعة وتقييم أداء عمليات محافظ الجهات الشريكة",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-22-062",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالله سعد عبدالله الغامدي Abdullah S. Alghamdi",
    ProjectDescription: "متابعة وتقييم أداء عمليات محافظ الجهات الشريكة",
    ProjectStartDate: "2022-08-28T00:00:00",
    ProjectFinishDate: "2023-08-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "2500000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة تطوير نطاق العمل",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6f681da4-de1f-47ee-8b30-681bb59fa031",
    ProjectName: "تطوير الحوكمة والالتزام",
    Department: "إدارة تقييم ومعالجة المخاطر",
    ProjectCode: "RI-22-002",
    ProjectOwner:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    boardinitiative: "لا",
    ProjectManager: "فرسه احمد حسن الفرسه Firsah A AlFirsah",
    ProjectDescription:
      '"إنشاء وتطوير إدارة الحوكمة و إدارة الالتزام وإدارة مكافحة الاحتيال"\r\n',
    ProjectStartDate: "2022-07-01T00:00:00",
    ProjectFinishDate: "2023-07-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "5000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "إدارة المخاطر",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "إدارة المخاطر",
    ProgramManager: "فهد تركي محمد السديري fahad alsudairy",
    ProjectOwner1:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    ProjectOfficerContact: " ",
    sector_efada: "تم الانتهاء من الكراسة وجاري الطرح ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2500000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "51be8f0b-9643-4bd1-956c-6a9737b81768",
    ProjectName: "تحسين حوكمة وكفاءة عمليات تمويل الأسر المنتجة",
    Department: "إدارة تقييم ومعالجة المخاطر",
    ProjectCode: "BU-22-050",
    ProjectOwner:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    boardinitiative: "لا",
    ProjectManager:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    ProjectDescription: "تحسين حوكمة وكفاءة عمليات تمويل الأسر المنتجة\r\n\r\n",
    ProjectStartDate: "2022-12-10T00:00:00",
    ProjectFinishDate: "2023-12-10T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "4000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "إدارة المخاطر",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "إدارة المخاطر",
    ProgramManager: "محمد مسفر محمد الأحمري mohammed m. alahmari",
    ProjectOwner1:
      "عبدالرحمن عبدالعزيز عبدالرحمن العريفي Abdulrahman A. Alarifi",
    ProjectOfficerContact: " ",
    sector_efada: "لمراجعة الكراسة عند قطاع الاعمال ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "40fbd4a7-9558-46a1-98a4-6b160e9bb63c",
    ProjectName: "اطلاق منتج سيولة",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-21-004",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription: "اطلاق منتج سيولة",
    ProjectStartDate: "2021-06-01T00:00:00",
    ProjectFinishDate: "2021-09-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "وليد سليمان النزهه Waleed S. Alnozha",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    sector_efada:
      "الأعمال:تم الاطلاق على البيئة الفعلية ويوجد 7964 طلب منها طلبين تم صرفها",
    pmo_efada:
      "المنتج ليس مؤتمت. مخاطر متوقعة بأن المنتج لن يساهم في تحقيق مؤشراته 2021م",
    cat_efada: "المنتجات",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "a8300fa0-33fa-4597-80e4-6c2e39aa08a7",
    ProjectName: "تعديلات على بوابة إدارة الشراكات الاستراتيجية",
    Department: "إدارة الابتكار والشراكات",
    ProjectCode: "ST-22-030",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "Abdulaziz Turki Al-Mutairi عبدالعزيز تركي المطيري",
    ProjectDescription: "تعديلات على بوابة إدارة الشراكات الاستراتيجية",
    ProjectStartDate: "2022-09-01T00:00:00",
    ProjectFinishDate: "2022-09-02T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "فهد عبدالرحمن محمد الرواف fahad a. alrawaf",
    ProjectOwner1: "الدانة خليفه العجاجي Aldanah K Alajaji",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "f9b238a4-cc54-4aa3-a6fe-6cc7d726154d",
    ProjectName: "اقفال كامل التراس",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-074",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "ناصر عبدالعزيز القديري Nasser A. AlQudairi",
    ProjectDescription: "اقفال كامل التراس ",
    ProjectStartDate: "2022-11-01T00:00:00",
    ProjectFinishDate: "2023-07-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2800000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "e84cd44a-970b-4e7c-ac20-72082aa13cef",
    ProjectName: "أتمتة الصرف للأمانات المركزية",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-20-007",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "Abdulrahman Abdullah Alshmlan",
    ProjectDescription: "أتمتة الصرف للأمانات المركزية",
    ProjectStartDate: "2020-05-12T00:00:00",
    ProjectFinishDate: "2020-10-21T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تحقيق الاستدامة المالية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "9402ed10-5961-49bd-8879-73109983a369",
    ProjectName: "اطلاق منتج رواد الأعمال",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-21-005",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription: "اطلاق منتج رواد الأعمال",
    ProjectStartDate: "2021-06-01T00:00:00",
    ProjectFinishDate: "2021-09-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    sector_efada: "الأعمال:تم الاطلاق على البيئة الفعلية , يوجد عدد 855 طلب ",
    pmo_efada: "",
    cat_efada: "المنتجات",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "f8069762-bde1-40a0-8612-74c5a2c6bc5a",
    ProjectName: "أتمتة خدمات الفروع لعملاء المنشات",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-123",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription: "أتمتة خدمات الفروع لعملاء المنشات\t\r\n",
    ProjectStartDate: "2022-08-01T00:00:00",
    ProjectFinishDate: "2022-11-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada:
      " النطاق مغطى بمشروع (تطوير الية التقديم و الية العمل الداخلية لادارة المشاريع الناشئة (المرحلة الثانية) وينتهي تطويره مارس 2024 ، علماً أن التاريخ المقدم من التقنية من 4-7-2023 الي 5-11-2023 ، وهو غير متوائم",
    pmo_efada: "لا يوجد موائمة TBD",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "354c1711-1b3d-410a-8caa-776fe13c0eaf",
    ProjectName:
      "الخدمات الاستشارية و الفنية لإكمال المقر الرئيسي لبنك التنمية الاجتماعية (المرحله الاولى)",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-20-006",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "نوره احمد علي الشهري Norah A. Alshahri",
    ProjectDescription:
      "الخدمات الاستشارية و الفنية لإكمال المقر الرئيسي لبنك التنمية الاجتماعية (المرحله الاولى)",
    ProjectStartDate: "2020-04-20T00:00:00",
    ProjectFinishDate: "2021-04-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "2123291.940000",
    ContractValue: "1930265.000000",
    RevisedContractValue: "2123292.000000",
    PaidAmount: "2123292.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "مكتب الفارس ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "في حاجة لتحديد المبلغ المنصرف ",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "4eec87e6-9c28-48c3-ad43-7eebd2621d99",
    ProjectName: "العقد الإلكتروني (علم-ابشر)",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-002",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "Khalid Abdulaziz Alothman",
    ProjectDescription: "العقد الإلكتروني (علم/ابشر)",
    ProjectStartDate: "2021-01-01T00:00:00",
    ProjectFinishDate: "2021-09-07T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "1050000.000000",
    ApprovedBudget: "1050000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "تم الاطلاق",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "f1c2604d-23fe-4c91-8333-870f88983e45",
    ProjectName: "دراسة وكفاية راس المال",
    Department: "إدارة التقارير والميزانية",
    ProjectCode: "FI-22-001",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "تركي خالد الجبرين TURKI K. ALJEBREEN",
    ProjectDescription:
      "عمل دراسة لفعالية راس المال بعد التحول وللتأكد من كفايته للاستثمارات والقروض",
    ProjectStartDate: "2022-08-15T00:00:00",
    ProjectFinishDate: "2022-12-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "عادل عبدالله الدحيم Adel A. Alduhaim",
    ProjectOfficerContact: " ",
    sector_efada: "جاري العمل على كراسة الشروط والمواصفات ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "3000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "8d15d953-226e-4298-8f20-88ad568fedf5",
    ProjectName: "تأسيس وتشغيل 5 مطابخ مجتمعية من خلال الجمعيات",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-22-029",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "أسعد زهير الزغيبي Asaad Z. Alzughaibi",
    ProjectDescription: "تأسيس وتشغيل 5 مطابخ مجتمعية من خلال الجمعيات",
    ProjectStartDate: "2022-09-01T00:00:00",
    ProjectFinishDate: "2023-02-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "23500000.000000",
    ContractValue: "23500000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "23500000.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "6c599207-51b4-491c-8e5f-8b8d018772f3",
    ProjectName: "دمج الفروع",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-012",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: null,
    ProjectManager: "Hassan F. Algarni",
    ProjectDescription: "دمج الفروع",
    ProjectStartDate: "2021-08-07T00:00:00",
    ProjectFinishDate: "2021-02-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: null,
    NotAligned: null,
    AlignedComments: null,
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "f311cb52-52b7-43ba-9a07-8da6a6472535",
    ProjectName: "تطوير منصة الحوافز للعمل الحر",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-20-013",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: null,
    ProjectManager: "عبدالله احمد العودان Abdullah A Alodan",
    ProjectDescription: "تطوير منصة الحوافز للعمل الحر",
    ProjectStartDate: "2020-11-01T00:00:00",
    ProjectFinishDate: "2021-08-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "المنصات",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: null,
    NotAligned: null,
    AlignedComments: null,
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "وليد سليمان النزهه Waleed S. Alnozha",
    ProjectOwner1: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectOfficerContact: "تركي عبدالمحسن المنيف Turki A Almunaif",
    sector_efada: "الأعمال : صرف الحافز يكون بعد نهاية سنة بعد الاشتراك.",
    pmo_efada: "",
    cat_efada: "المنصات",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "79d49dbe-aad5-4fec-b707-8dc6a56f5bba",
    ProjectName: "توريد وتركيب محطات تحلية مياه لمطابخ البرج",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-073",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "محمد ابراهيم الهويمل Mohamed i. alhuwaimel",
    ProjectDescription: "توريد وتركيب محطات تحلية مياه لمطابخ البرج",
    ProjectStartDate: "2022-05-10T00:00:00",
    ProjectFinishDate: "2022-05-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "15000.000000",
    ContractValue: "12255.090000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "سمنان",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "98075cce-ced2-42b6-a47f-8fbb905fd31e",
    ProjectName: "تطوير محرك Chatbot",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-20-001",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عفراء علي محمد السويلم Afra A Alswailem",
    ProjectDescription: "تطوير محرك Chatbot",
    ProjectStartDate: "2020-01-01T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "3000000.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "تم اغلاق المشروع ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "3688487c-a812-4526-999c-9040f0e0d97e",
    ProjectName: "تأسيس مكتب إدارة التحول لقسم المنشآت",
    Department: "إدارة تمويل المنشأت",
    ProjectCode: "BU-22-011",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "Ahmed S. Aldubais",
    ProjectDescription: "تأسيس مكتب إدارة التحول لقسم المنشآت ",
    ProjectStartDate: "2022-11-14T00:00:00",
    ProjectFinishDate: "2023-11-14T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "4000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada: "تخفيض قيمة المشروع وتأجيل طرحه إلى نهاية العام",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "e3e105e3-a29c-4b26-a54d-9347b2621574",
    ProjectName: "المرحلة الثانية من الدعم المحاسبي",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-22-002",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "فهد عائش العتيبي Fahad A. Alotaibi",
    ProjectDescription:
      "تهدف إلى تقديم المساعدة والدعم في المهام والتقارير المالية والمرتبطة بالإدارة المالية وفقا الاطار المحاسبي المعتمد من الإدارة العليا للبنك",
    ProjectStartDate: "2022-12-15T00:00:00",
    ProjectFinishDate: "2023-12-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "فهد تركي محمد السديري fahad alsudairy",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada: "سوف يتم طرح المشروع في الربع الرابع لعام 2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "e84380cb-d982-4d21-8906-93a92eb43a7c",
    ProjectName:
      "إعادة هيكلة الصلاحيات والحسابات المتعلقة بإدارة صرف وتحصيل القروض الاجتماعية",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-22-011",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "حماد عبدالله صالح المحيسن Hammad A. AlMuhaysin",
    ProjectDescription:
      "إعادة هيكلة الصلاحيات والحسابات المتعلقة بإدارة صرف وتحصيل القروض الاجتماعية ",
    ProjectStartDate: "2022-06-06T00:00:00",
    ProjectFinishDate: "2022-06-24T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada:
      "جاري العمل على الغاء المشروع لتضمن نطاقه في المشروع التعاقدي (تقديم الخدمات الاستشارية لمركزية الحسابات ببنك التنمية الاجتماعية)",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ca69de63-4d99-ec11-8b00-98566de81707",
    ProjectName: "تطوير منصات رقمية للجهات الشريكة والجهات الخارجية",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-070",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد فايز الدوسري Khalid F Aldosari",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-05-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عبدالعزيز حسن خليل الاحمدي Abdulaziz H. AlAhmadi",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "9ca4cad8-4d99-ec11-8b00-98566de81707",
    ProjectName:
      "إتاحة خاصية التحقق من بيانات العميل المدخلة في النظام عبر الر بط الإلكتروني الترابط مع نذير ( vendor name ELM)",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-071",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription: null,
    ProjectStartDate: "2023-04-01T00:00:00",
    ProjectFinishDate: "2023-05-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "c6b19a17-4e99-ec11-8b00-98566de81707",
    ProjectName: "تطبيق نظام الذكاء االصطناعي",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-072",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription: null,
    ProjectStartDate: "2023-06-01T00:00:00",
    ProjectFinishDate: "2023-12-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عبدالعزيز حازم المزروع Abdulaziz H Al Mazrou",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "f5d06384-4e99-ec11-8b00-98566de81707",
    ProjectName: "تطبيق نظام ذكاء الأعمال والتحليلات المتقدمة",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-073",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription: null,
    ProjectStartDate: "2023-06-01T00:00:00",
    ProjectFinishDate: "2023-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عبدالعزيز حازم المزروع Abdulaziz H Al Mazrou",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "495d9c96-5099-ec11-8b00-98566de81707",
    ProjectName: "اشتراك موظفي بنك التنمية الاجتماعية في برنامج زود الادخاري",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-077",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هيفاء عبدالله عبدالرحمن السيف Haifa Al-Saif",
    ProjectDescription: null,
    ProjectStartDate: "2023-08-01T00:00:00",
    ProjectFinishDate: "2024-01-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (3)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: " لم يتم استلام المتطلبات ",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: "ابراهيم علي حسين حبتري ibrahim a. habtari",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "a14d3f55-5199-ec11-8b00-98566de81707",
    ProjectName: "الحزمة الخامسة من تطبيق الجوال (كنف والزواج)",
    Department: "إدارة تمويل الأفراد",
    ProjectCode: "BU-22-079",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "Khalid S. Alsoke",
    ProjectDescription: null,
    ProjectStartDate: "2023-06-01T00:00:00",
    ProjectFinishDate: "2023-10-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "ناصر عبدالرحمن ناصر الهداب Nasser A. Alhaddab",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "5b9ce079-5299-ec11-8b00-98566de81707",
    ProjectName: "تحسينات دورية (ربع سنوية) على تطبيق الجوال",
    Department: "إدارة تمويل الأفراد",
    ProjectCode: "BU-22-080",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectDescription: null,
    ProjectStartDate: "2023-01-01T00:00:00",
    ProjectFinishDate: "2024-01-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "ناصر عبدالرحمن ناصر الهداب Nasser A. Alhaddab",
    sector_efada:
      "تسليم متطلبات التحسينات يكون قبل بدايه الربع السنوي بشهر، والتنفيذ يكون قبل نهاية الربع بحد أقصى",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "b43ceab6-5299-ec11-8b00-98566de81707",
    ProjectName: "اطلاق منتج كنف ( ذوي الإعاقة)",
    Department: "إدارة تمويل الأفراد",
    ProjectCode: "BU-22-081",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "فهد محمد فارع الجهني Fahad M Aljohani",
    ProjectDescription: null,
    ProjectStartDate: "2022-07-01T00:00:00",
    ProjectFinishDate: "2022-08-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "تاريخ الإنتهاء الربع الثالث 30 سبتمبر حسب المرسل سابقًا لمكتب إدارة المشاريع قطاع الأعمال",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "فيصل شباب الغامدي Faisal S. Alghamdi",
    sector_efada: "في مرحلة التنفيذ ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "3b54f11c-5399-ec11-8b00-98566de81707",
    ProjectName: "اطلاق منتج كنف ( لم يرزق بذرية)",
    Department: "إدارة تمويل الأفراد",
    ProjectCode: "BU-22-082",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "فهد محمد فارع الجهني Fahad M Aljohani",
    ProjectDescription: null,
    ProjectStartDate: "2022-07-18T00:00:00",
    ProjectFinishDate: "2022-09-05T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments:
      "تاريخ الإنتهاء الربع الرابع 30ديسمبر حسب الإتفاق مع مكتب إدارة المشاريع قطاع الأعمال",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "فيصل شباب الغامدي Faisal S. Alghamdi",
    sector_efada: "تم تسليم وثيقة متطلبات الى شريك الاعمال 9/2/2022",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "e3c69385-5399-ec11-8b00-98566de81707",
    ProjectName: "إطلاق منتج كنف ( زوجة السجين)",
    Department: "إدارة تمويل الأفراد",
    ProjectCode: "BU-22-083",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "فهد محمد فارع الجهني Fahad M Aljohani",
    ProjectDescription: null,
    ProjectStartDate: "2023-01-01T00:00:00",
    ProjectFinishDate: "2023-02-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "فيصل شباب الغامدي Faisal S. Alghamdi",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "a310eeec-5499-ec11-8b00-98566de81707",
    ProjectName:
      "تطوير الية التقديم و الية العمل الداخلية لإدارة المشاريع الناشئة (المرحلة الثانية)",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-089",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription: null,
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-04-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متوقع التأخير/ملاحظة مهمة",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا",
    NotAligned: "التواريخ",
    AlignedComments:
      "تاريخ تقنية المعلومات البداية 1 يوليو 2023 والانتهاء 1 فبراير 2024",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "ABDULAZIZ SAUD ALHARBI",
    sector_efada: "الاثر في حال عدم الموائمة : برنامج تحسين رحلة العميل ",
    pmo_efada: "غير متوائم",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "6791051e-5599-ec11-8b00-98566de81707",
    ProjectName: "المكتسبات السريعة من خارطة الطريق",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-090",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription: null,
    ProjectStartDate: "2022-03-01T00:00:00",
    ProjectFinishDate: "2022-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا",
    NotAligned: "التواريخ",
    AlignedComments:
      "تم الانتهاء من (ترميز المحفظة التمويلية - رسوم التمويل الإضافي) خلال إجازة عيد الأضحى وهي في مرحلة اختبار الجودة و لم يتم تسليم المتطلبات (التتبع عبر النظام من خلال ال audit Trail - تعديل على آلية تحديث حالة العميل التحصيلية..) حسب التزامنا بتنفيذها خلال اجازة عيد الأضحى ",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada:
      "غير متوائم مع إدارة التقنية ، جاري اختبار قبول المستخدم للخدمتين التي تم تنفيذها ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "531ef243-5599-ec11-8b00-98566de81707",
    ProjectName: "اتمتة التحصيل مع مكاتب خارجية",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-091",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription: null,
    ProjectStartDate: "2023-04-01T00:00:00",
    ProjectFinishDate: "2023-08-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عبدالعزيز حسن خليل الاحمدي Abdulaziz H. AlAhmadi",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "e7a35d79-5599-ec11-8b00-98566de81707",
    ProjectName: "تحسين رحلة العميل لكافة منتجات- المنشآت",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-092",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription: null,
    ProjectStartDate: "2022-09-01T00:00:00",
    ProjectFinishDate: "2022-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "ABDULAZIZ SAUD ALHARBI",
    sector_efada:
      "تم تجميع المتطلبات الاعمال من أصحاب المصلحة والبدء في كتابة الوثيقة ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "b27fa39a-6499-ec11-8b00-98566de81707",
    ProjectName: "منتج دعم الألعاب الالكترونية",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-094",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription: null,
    ProjectStartDate: "2023-09-01T00:00:00",
    ProjectFinishDate: "2024-01-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عبدالعزيز حسن خليل الاحمدي Abdulaziz H. AlAhmadi",
    sector_efada: "مرحلة جمع متطلبات الاعمال ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "902304ea-6499-ec11-8b00-98566de81707",
    ProjectName: "إدارة علاقات العملاء Customer Relationship Management",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "BU-22-095",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription: null,
    ProjectStartDate: "2022-08-01T00:00:00",
    ProjectFinishDate: "2023-04-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "TBD",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: " ",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada:
      "لا يزال في مرحلة تطوير النطاق و تحديد الارتباطات الفنية مع منتجات البنك ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "08a73033-6599-ec11-8b00-98566de81707",
    ProjectName: "رقمنة وأتمتة المنتجات الجديدة سيولة ورواد الأعمال",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-096",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سلطان محمد سليمان الحوشان SULTAN M. ALHOSHAN",
    ProjectDescription: null,
    ProjectStartDate: "2023-03-01T00:00:00",
    ProjectFinishDate: "2023-05-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "عبدالعزيز حسن خليل الاحمدي Abdulaziz H. AlAhmadi",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "353d59a0-f099-ec11-8b00-98566de81707",
    ProjectName:
      "تعزيز وتفعيل رحلة العميل من خلال القنوات الالكترونية online and mobile banking)",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-097",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "منيره مساعد الجبير Monirah M. Aljobair",
    ProjectDescription: null,
    ProjectStartDate: "2022-07-01T00:00:00",
    ProjectFinishDate: "2022-10-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: null,
    RevisedContractValue: null,
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا",
    NotAligned: "التواريخ",
    AlignedComments:
      "تاريخ تقنية المعلومات البداية 1 يناير 2023 والانتهاء 1 يونيو 2024",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "ABDULAZIZ SAUD ALHARBI",
    sector_efada:
      "الاثر في حال عدم الموائمة : برنامج تحسين رحلة العميل (السماح للمنشآت متناهية الصغر (Start-up) من التقديم بطلب جديد / تجديد / طلبات مابعد الموافقة. )",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: null,
  },
  {
    ProjectUID: "4562b7e7-4f33-4382-909e-99365404dd49",
    ProjectName: "اطـلاق تطبيـق التحليـل المالـي لحسـاب المصروفات و المدخرات",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-21-029",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectDescription:
      "اطـلاق تطبيـق التحليـل المالـي لحسـاب المصروفات و المدخرات",
    ProjectStartDate: "2021-11-03T00:00:00",
    ProjectFinishDate: "2022-02-27T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "التطبيقات",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "نهى ناصر بن جريد Noha N. Binjuraid",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: " ",
    sector_efada:
      "مكرر لمشروع تطبيق التحليل المالي (tier 1) وجاري استكمال نموذج الاغلاق",
    pmo_efada: "",
    cat_efada: "التطبيقات",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "aa438ece-e379-453a-8420-9a92620a34a2",
    ProjectName: "حزمة التكامل للإقراض والتحصيل مع الجهات من خلال يسر GSB",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-21-015",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالسلام عبدالرحمن داحس الجلاجل Abdulsalam A. Al Jalajil",
    ProjectDescription:
      "حزمة التكامل للإقراض والتحصيل مع الجهات من خلال يسر GSB",
    ProjectStartDate: "2021-10-03T00:00:00",
    ProjectFinishDate: "2022-09-29T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: "عمر عباس Omar Abbas",
    sector_efada:
      "جاري دراسة قرار تأجيل المشروع نظراً لاعتماده على انتهاء نموذج التحصيل الجديد ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "32672546-5872-46e2-8e8e-9f1d745137da",
    ProjectName:
      "تقديم الخدمات الاستشارية لتطوير عمليات المشتريات والعقود المرحلة 2",
    Department: "إدارة المشتريات والعقود",
    ProjectCode: "SS-22-069",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "فهد حمود السهلي Fahad H. Al-Sahli",
    ProjectDescription:
      "تقديم الخدمات الاستشارية لتطوير عمليات المشتريات والعقود المرحلة 2 ",
    ProjectStartDate: "2022-06-02T00:00:00",
    ProjectFinishDate: "2023-06-02T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: null,
    ApprovedBudget: null,
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: null,
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تحقيق الاستدامة المالية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "خالد بن زيد الرويس Khalid Z. AlRuwais",
    ProjectOfficerContact: " ",
    sector_efada:
      "المشروع حاليا في مرحلة اعداد العقد وسيتم تحديث بياناته بعد توقيع العقد ومحضر استلام الموقع حسب المنهجية",
    pmo_efada: null,
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "90ce491e-dfc5-4631-a5d2-9f8575cc8ff7",
    ProjectName: "تأسيس وتشغيل حاضنات الانتاج في الإقليم الشرقي",
    Department: "إدارة تطوير البرامج والمنتجات",
    ProjectCode: "BU-22-056",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    ProjectDescription: "تأسيس وتشغيل حاضنات الانتاج في الإقليم الشرقي\r\n\r\n",
    ProjectStartDate: "2022-10-16T00:00:00",
    ProjectFinishDate: "2023-10-16T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "9769940.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "مرتبطة بطرح مشروع تأسيس حاضنات الإنتاج في الإقليم الشمالي - سيتم تجويد نطاق العمل بناء على العروض الفنية المقدمة",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "a6780654-47af-425f-8161-a02ac70a50c3",
    ProjectName: "الإقراض المباشر للأسر المنتجة – تعديل نفاذ",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-21-024",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "هدى عثمان احمد الزهراني huda o. alzahrani",
    ProjectDescription: "الإقراض المباشر للأسر المنتجة – تعديل نفاذ",
    ProjectStartDate: "2021-09-15T00:00:00",
    ProjectFinishDate: "2021-11-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "وليد سليمان النزهه Waleed S. Alnozha",
    ProjectOwner1: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectOfficerContact: "تركي عبدالمحسن المنيف Turki A Almunaif",
    sector_efada:
      "تم الاطلاق بنجاح , عدد الطلبات يفوق 17 الف , وتم تمويل 1822 طلب بقيمة 82 مليون (الرسوم المحصلة 5.4 مليون)",
    pmo_efada: "",
    cat_efada: "الأنظمة و التطوير",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "08d6e11e-9831-4c65-9f01-a14ffedf4804",
    ProjectName:
      "صناعة أدوات تسويقية لتعزيز الوعي المالي وترويج منتجات وخدمات الادخار",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "BU-22-001",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "فيصل فهد عبدالله الخليفة Faisal F. Alkhalifa",
    ProjectDescription: "تسويق البرامج والمنتجات الادخارية",
    ProjectStartDate: "2022-07-01T00:00:00",
    ProjectFinishDate: "2023-07-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "3500000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "في مرحلة التقييم الفني",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1800000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "744dba59-78da-4795-bb2f-a64a5a65cc96",
    ProjectName: "اقفال المشاريع المكتملة و الغير مغلقة",
    Department: "إدارة المشتريات والعقود",
    ProjectCode: "SS-21-006",
    ProjectOwner: "fahad M. alghamdi",
    boardinitiative: null,
    ProjectManager: "fahad M. alghamdi",
    ProjectDescription: "اقفال المشاريع المكتملة و الغير مغلقة",
    ProjectStartDate: "2021-04-11T00:00:00",
    ProjectFinishDate: "2021-10-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (3)",
    ProjectCategory: null,
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: null,
    NotAligned: null,
    AlignedComments: null,
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: " ",
    ProjectOwner1: "fahad M. alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "830de3c2-3b5a-4a6f-9182-a722d089a461",
    ProjectName: "تسويق المنتجات التمويلية الموجهة للأسر المنتجة",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "BU-22-038",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectDescription: "تسويق المنتجات التمويلية الموجهة للأسر المنتجة ",
    ProjectStartDate: "2022-10-01T00:00:00",
    ProjectFinishDate: "2023-10-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم دمج المشروع تحت مشروع ابتكار وصناعة أدوات تسويقه لدعم وتمكين الأسر المنتجة - الرمز ST-22-029",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "c7f180db-d9fe-43aa-a2a9-aa9711668343",
    ProjectName: "تأسيس وتشغيل منافذ البيع الدائمة",
    Department: "إدارة تطوير البرامج والمنتجات",
    ProjectCode: "BU-22-053",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    ProjectDescription: "تأسيس وتشغيل منافذ البيع الدائمة\r\n\r\n",
    ProjectStartDate: "2022-10-02T00:00:00",
    ProjectFinishDate: "2023-10-02T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "18000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "مرتبط بمشروع تأسيس الحاضنات للإقليم الشمالي",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ebed4df2-716f-4a67-a2cd-b36e1a02d2de",
    ProjectName: "مشروع تنفيذ عمل مرئي لليوم الوطني",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "ST-21-008",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "حنان عبدالرحمن الدليمي Hanan A. Al Delaimi",
    ProjectDescription: "مشروع تنفيذ عمل مرئي لليوم الوطني",
    ProjectStartDate: "2021-12-30T00:00:00",
    ProjectFinishDate: "2022-02-21T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "2320",
    BudgetItemName: "مستحقات مصاريف عمومية وإدارية ",
    EstimatedBudget: "500000.000000",
    ApprovedBudget: "499905.000000",
    ContractValue: "499905.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "499905.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "شركة الإنتاج المتكامل ",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: "خالد راشد الثويني Khaled R Althowaini",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "نموذج إغلاق المشروع ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "499905.00",
    SpentYearBudget: "499905.000000",
  },
  {
    ProjectUID: "d2731ec7-6986-460f-a464-b66ccf371537",
    ProjectName:
      "تأهيل وتأثيث وتوفير أجهزة تقنية لعدد 4 فروع لمشروع جادة 30 المرحلة الثانية (جازان -المدينة)",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-016",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription:
      "تأهيل وتأثيث وتوفير أجهزة تقنية لعدد 4 فروع لمشروع جادة 30 المرحلة الثانية (جازان+المدينة)",
    ProjectStartDate: "2021-08-10T00:00:00",
    ProjectFinishDate: "2022-08-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "8250000.000000",
    ApprovedBudget: "8250000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: "تم رفع طلب إلغاء لوجود مشروع بديل على النظام برقم 22-018-BU",
    pmo_efada: "",
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "e0e3214d-53f1-4a6f-bac4-bf06ef30453c",
    ProjectName:
      "مشروع توريد وتركيب كاونتر لمطبخ الرئيس وتوريد اكسسوارات صانعة",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-078",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "ناصر عبدالعزيز القديري Nasser A. AlQudairi",
    ProjectDescription:
      "مشروع توريد وتركيب كاونتر لمطبخ الرئيس وتوريد اكسسوارات صانعة",
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-04-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "35000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "db25b574-5290-4bb9-8e2b-bff1309c4082",
    ProjectName: "نشر ثقافة الأسر المنتجة والتحول من الاستهلاك الى الإنتاج",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "BU-22-033",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectDescription:
      "نشر ثقافة الأسر المنتجة والتحول من الاستهلاك الى الإنتاج",
    ProjectStartDate: "2022-10-01T00:00:00",
    ProjectFinishDate: "2023-10-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "1320000.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم دمج المشروع تحت مشروع ابتكار وصناعة أدوات تسويقه لدعم وتمكين الأسر المنتجة - الرمز ST-22-029",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b006f1d5-b359-4fc0-8086-c38b424ea220",
    ProjectName:
      "حصر وتحديد الصلاحيات للموظفين على الأنظمة مقابل الأوصاف الوظيفية",
    Department: "إدارة حوكمة الخدمات والبيانات والامن السيبراني",
    ProjectCode: "SS-22-070",
    ProjectOwner: "عبدالرحمن عثمان بن فهيد Abdulrahman O Bin Fehaid",
    boardinitiative: "لا",
    ProjectManager: "ابتسام عبدالعزيز الحزامي Ebtesam A Alhuzami",
    ProjectDescription:
      "حصر وتحديد الصلاحيات للموظفين على الأنظمة مقابل الأوصاف الوظيفية",
    ProjectStartDate: "2022-03-06T00:00:00",
    ProjectFinishDate: "2022-09-06T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "814200.000000",
    ContractValue: "814200.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "نوف سلطان البقمي Nouf S ALbogami",
    ProjectOfficerContact: " ",
    sector_efada: "الشروع في مرحلة التنفيذ ويسير حسب المخطط",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ecb261c3-dfe2-4bca-b337-c3f9d752e330",
    ProjectName: "جادة المجمعة",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-21-030",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: "جادة المجمعة ",
    ProjectStartDate: "2023-04-01T00:00:00",
    ProjectFinishDate: "2023-07-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: null,
    BudgetItemName: null,
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: null,
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "خالد عبداللطيف ابراهيم الخميس Khaled A. AlKhames",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: "وليد سليمان النزهه Waleed S. Alnozha",
    sector_efada: null,
    pmo_efada: null,
    cat_efada: "شبكة الفروع والمباني و التوريد",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "03fd7c22-63b2-4975-a417-c5838fe8cd20",
    ProjectName: "اتمته الاستثمارات",
    Department: "إدارة التقارير والميزانية",
    ProjectCode: "FI-22-0014",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "مها خالد العثمان Maha K. Al-Othman",
    ProjectDescription: "اتمته الاستثمارات",
    ProjectStartDate: "2022-06-06T00:00:00",
    ProjectFinishDate: "2022-06-24T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "متوقع التأخير/ملاحظة مهمة",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "تركي خالد الجبرين TURKI K. ALJEBREEN",
    ProjectOfficerContact: " ",
    sector_efada: "جاري العمل على الانتهاء من تصميم شاشات النظام ",
    pmo_efada: "لم يتم تزويدنا بتواريخ المشروع حتى الان",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "67bf9173-95b8-45d5-b9b3-c7593c4eeddb",
    ProjectName:
      "البوابة الرقمية للامتياز التجاري - (جزء من مشروع تأسيس برنامج الامتياز التجاري)",
    Department: "إدارة التمكين والتنمية",
    ProjectCode: "BU-21-060",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "سيف عبدالله ابراهيم الفرهود SAIF A. ALFARHOOD",
    ProjectDescription:
      "البوابة الرقمية للامتياز التجاري - (جزء من مشروع تأسيس برنامج الامتياز التجاري)",
    ProjectStartDate: "2021-12-23T00:00:00",
    ProjectFinishDate: "2022-06-20T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1000000.000000",
    ContractValue: null,
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: null,
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "لم يتم تسليمنا المتطلبات",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "اعتماد الهوية الخاصة للبرنامج ، التصميم المبدئي للبوابة الالكتراونية -التقييم والتأهيل ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ccb33034-a37f-422f-8c03-c7febd40ad23",
    ProjectName:
      "توريد وتركيب درابزين حماية للمواقف وغرف الخدمه (المبنى الرئيسي)",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-079",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "أحمد سفر النفيعي Ahmed S Alnefaie",
    ProjectDescription:
      "توريد وتركيب درابزين حماية للمواقف وغرف الخدمه (المبنى الرئيسي)",
    ProjectStartDate: "2022-07-18T00:00:00",
    ProjectFinishDate: "2022-08-18T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "99999.000000",
    ContractValue: "99999.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "99999.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "9ac3533b-cac4-4e36-bd79-c93098fd4c04",
    ProjectName: "تطوير الإجراءات الداخلية Workflow للعقود والمشتريات",
    Department: "إدارة المشتريات والعقود",
    ProjectCode: "SS-21-028",
    ProjectOwner: "fahad M. alghamdi",
    boardinitiative: "لا",
    ProjectManager: "fahad M. alghamdi",
    ProjectDescription: "تطوير الإجراءات الداخلية Workflow للعقود والمشتريات",
    ProjectStartDate: "2021-12-09T00:00:00",
    ProjectFinishDate: "2021-12-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: " ",
    ProjectOwner1: "fahad M. alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "في حاجة لاستكمال البيانات الأساسية للمشروع",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "c7bb3be5-9078-4164-b23b-c93112153d81",
    ProjectName: "تسويق برامج العمل الحر مع الشركاء",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "BU-22-014",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectDescription: "تسويق برامج العمل الحر مع الشركاء",
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-12-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم دمج المشروع تحت مشروع ابتكار وصناعة أدوات تسويقه لمنتجات وخدمات البنك المالية والغير ماليه - الرمز ST-22-028",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "bb5a5add-4fe1-427b-8c5e-caeb4af74259",
    ProjectName: "منتج زود الطفل الادخاري",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-20-006",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "اسامه عبدالمجيد عبدالله الفلاح Osama A Alfalah",
    ProjectDescription: "منتج زود الطفل الادخاري",
    ProjectStartDate: "2020-07-01T00:00:00",
    ProjectFinishDate: "2021-04-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: "Khalid S. Alsoke",
    sector_efada: "المنتج في مرحلة التشغيل",
    pmo_efada: "وجود تحدي في تحقيق المستهدف",
    cat_efada: "المنتجات",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "1de193f9-4964-4ac8-814f-cbff91d5f6c6",
    ProjectName: "تمويل أول عميل من خلال منصة بحر منتج نفاذ (White labelling)",
    Department: "إدارة تمويل العمل الحر",
    ProjectCode: "BU-21-006",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: null,
    ProjectManager: "عبدالله احمد العودان Abdullah A Alodan",
    ProjectDescription:
      "تمويل أول عميل من خلال منصة بحر منتج نفاذ (White labelling)",
    ProjectStartDate: "2021-06-01T00:00:00",
    ProjectFinishDate: "2021-07-18T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: null,
    NotAligned: null,
    AlignedComments: null,
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "وليد سليمان النزهه Waleed S. Alnozha",
    ProjectOwner1: "عبدالاله عبدالله السليمان Abdulelah A Alsulaiman",
    ProjectOfficerContact: "تركي عبدالمحسن المنيف Turki A Almunaif",
    sector_efada:
      "يوجد 300 طلب مقبول (الأسبوع الماضي). يوجد 316 طلب من خلال المنصة( هذا الأسبوع). تمويل 5 طلبات بقيمة 260الف",
    pmo_efada: "",
    cat_efada: "التكامل التقني",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "348726d7-39cd-4457-9c5d-cf2eaed7c142",
    ProjectName: "أتمته التمويل الغير مباشر من هيئة منشئات",
    Department: "إدارة المحاسبة",
    ProjectCode: "FI-22-009",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "حماد عبدالله صالح المحيسن Hammad A. AlMuhaysin",
    ProjectDescription: "أتمته التمويل الغير مباشر من هيئة منشئات ",
    ProjectStartDate: "2022-06-06T00:00:00",
    ProjectFinishDate: "2022-06-24T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متوقع التأخير/ملاحظة مهمة",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "محمد ابراهيم العرفج Mohammed I Alarfaj",
    ProjectOfficerContact: " ",
    sector_efada:
      "بانتظار الحصول على نسخة من وثيقة الإجراءات والمتطلبات (BRD) من قطاع الاعمال حسب افادة مدير المشروع ",
    pmo_efada: "لم يتم تزويدنا بتواريخ المشروع حتى الان",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d44d103c-ceef-4bad-8d81-cf336d98afd8",
    ProjectName: "عقد تسكين موظفين بنك التنمية الاجتماعية",
    Department: "إدارة رأس المال البشري",
    ProjectCode: "SS-21-018",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "ندى سعد الفليج Nada s alflaij",
    ProjectDescription: "عقد تسكين موظفين بنك التنمية الاجتماعية",
    ProjectStartDate: "2021-11-04T00:00:00",
    ProjectFinishDate: "2021-11-10T00:00:00",
    BIProjectStartDate: "2021-11-04T08:00:00",
    BIProjectFinishDate: "2021-11-10T17:00:00",
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "الخدمات الاستشاريه",
    EstimatedBudget: "2000000.000000",
    ApprovedBudget: "1601720.000000",
    ContractValue: "1601720.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "1601720.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "جامعة الامير سطام بن عبدالعزيز",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "فواز عبدالله العمران Fawaz A Alomran",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "119cd148-c67f-417a-ace9-d717ddfd23eb",
    ProjectName:
      "التكامل مع سمة تطبيق التكامل مع محتويات تقرير سمة على مستوى الحقول الخاصة بذلك في النظام الحالي",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-22-119",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription:
      "التكامل مع سمة: تطبيق التكامل مع محتويات تقرير سمة على مستوى الحقول الخاصة بذلك في النظام الحالي",
    ProjectStartDate: "2022-06-01T00:00:00",
    ProjectFinishDate: "2022-08-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "متأخر",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "نعم",
    NotAligned: "التواريخ",
    AlignedComments: "بحاجة إلى إعادة جدولة المشروع",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada:
      "بانتظار الإدارة المالكة للإتفاقية (إدارة العمليات البنكية) للاجتماع مع سمعة لتوقيع العقد ) وإعادة جدولة المشروع",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "0c2e39fb-0a47-431a-b1ea-e07aceb24df4",
    ProjectName: "تطوير أداء وسطاء التمويل",
    Department: "إدارة تمويل الأسر المنتجة",
    ProjectCode: "BU-22-052",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "لولوه ابراهيم صالح الدفاع Luluh I. Aldaffaa",
    ProjectDescription: "إدارة العمليات التشغيلية لوسطاء التمويل\r\n\r\n",
    ProjectStartDate: "2022-10-30T00:00:00",
    ProjectFinishDate: "2023-10-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "7500000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program:
      "برنامج تطوير اقراض العمل الحر والاسر المنتجة ورفع كفاءة الخدمات غير المالية",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "مساعد حمد ناصر الطعيمي Mousad H. Altoaimi",
    ProjectOfficerContact: "لولوه ابراهيم صالح الدفاع Luluh I. Aldaffaa",
    sector_efada: "تعديل نطاق العمل ، تعديل ملاحظات المستشار ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "060e96e7-0e6d-4f69-91cd-e273fa44de9d",
    ProjectName: "تطوير لوحة المؤشرات الخاصة بالعقود Dashboard",
    Department: "إدارة المشتريات والعقود",
    ProjectCode: "SS-21-008",
    ProjectOwner: "fahad M. alghamdi",
    boardinitiative: "لا",
    ProjectManager: "fahad M. alghamdi",
    ProjectDescription: "تطوير لوحة المؤشرات الخاصة بالعقود Dashboard",
    ProjectStartDate: "2021-05-02T00:00:00",
    ProjectFinishDate: "2021-07-08T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "رفع الانتاجية الاقتصادية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: " ",
    ProjectOwner1: "fahad M. alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "في حاجة لاستكمال البيانات الأساسية للمشروع",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "d75f2841-9e20-49d8-b9b5-e31585cd90ba",
    ProjectName:
      "تقرير الحوكمة البيئية والمجتمعية ُECG لبنك التنمية الأجتماعيه",
    Department: "إدارة قياس الأثر",
    ProjectCode: "ST-21-024",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "سمير سراج عثمان فلاته sameer s. fallatah",
    ProjectDescription:
      "تقرير الحوكمة البيئية والمجتمعية ُECG لبنك التنمية الأجتماعيه",
    ProjectStartDate: "2021-12-21T00:00:00",
    ProjectFinishDate: "2021-12-21T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "2311",
    BudgetItemName: "نفقات الأبحاث والدراسات ",
    EstimatedBudget: "414000.000000",
    ApprovedBudget: "414000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "عبدالمجيد عبدالرحمن بن رشيد Abdulmajeed A. Binrushaid",
    ProjectOfficerContact: " ",
    sector_efada: "جاري العمل على الغاء المشروع ",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "0ac8fb1c-3065-4f97-9265-e3b4a8e7947c",
    ProjectName:
      "سياسة تصنيف وقياس القروض حسب معيار 9 IFRS وسياسة خاصة بإهلاك القروض",
    Department: "إدارة التقارير والميزانية",
    ProjectCode: "FI-21-008",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "تركي خالد الجبرين TURKI K. ALJEBREEN",
    ProjectDescription:
      "سياسة تصنيف وقياس القروض حسب معيار 9 IFRS وسياسة خاصة بإهلاك القروض",
    ProjectStartDate: "2021-12-26T00:00:00",
    ProjectFinishDate: "2022-04-26T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "1800000.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "الأنظمة والتطوير",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "العقد",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: " ",
    ProjectOwner1: "عادل عبدالله الدحيم Adel A. Alduhaim",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم انتقال مشروع الخسائر الائتمانية المتوقعة الى قطاع المالية وعليه سيتم الحاق هذا المشروع به ",
    pmo_efada: "جاري المتابعة مع قطاع المالية ",
    cat_efada: "الأنظمة و التطوير",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "3079f6ba-ac0a-4750-849d-e3e50516395e",
    ProjectName: "توثيق سياسات وإجراءات البنك (50)",
    Department: "إدارة تميز العمليات",
    ProjectCode: "SS-21-027",
    ProjectOwner: "fahad M. alghamdi",
    boardinitiative: "لا",
    ProjectManager: "fahad M. alghamdi",
    ProjectDescription: "توثيق سياسات وإجراءات البنك (50)",
    ProjectStartDate: "2021-12-09T00:00:00",
    ProjectFinishDate: "2021-12-09T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: " ",
    ProjectOwner1: "fahad M. alghamdi",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "في حاجة لاستكمال البيانات الأساسية للمشروع",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "60beecda-4afa-42f8-8c0c-e55caa4634ad",
    ProjectName:
      "توريد وتركيب مواضئ الأقدام في دورات المياه العامة بالمقر الرئيسي للبنك",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-077",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "عبدالمحسن خالد الغصن Abdulmuhsen K. Alghusn",
    ProjectDescription:
      "توريد وتركيب مواضئ الأقدام في دورات المياه العامة بالمقر الرئيسي للبنك ",
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-04-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "315000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "بطيان عبدالله بطيان البطيان Btayan Abdullah B. Albtayan",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "7690559a-c17d-4782-a46d-e7190e5c0a60",
    ProjectName: "أتمتة توثيق المستندات من خلال تحسين نظام إدارة الوثائق",
    Department: "إدارة تمويل المنشأت",
    ProjectCode: "BU-22-124",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription:
      "أتمتة توثيق المستندات من خلال تحسين نظام إدارة الوثائق\t\r\n",
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2023-03-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "TBD",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ahmed S. Aldubais",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: " ",
    sector_efada: "يدار المشروع من قبل قطاع الخدمات",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "525c92e3-2972-443a-895c-e932af8175d0",
    ProjectName: "اعادة ترتيب الفلوربوكس بمبنى البنك في حي الغدير",
    Department: "إدارة الخدمات المساندة",
    ProjectCode: "SS-22-071",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "معاذ احمد محمد بامسعود muath a. bamasoud",
    ProjectDescription: "اعادة ترتيب الفلوربوكس بمبنى البنك في حي الغدير",
    ProjectStartDate: "2022-03-20T00:00:00",
    ProjectFinishDate: "2022-03-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "641",
    BudgetItemName: "صيانة وتطوير المباني والاشراف",
    EstimatedBudget: null,
    ApprovedBudget: "20424.000000",
    ContractValue: "20424.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "20424.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "مؤسسة سماء الروابط للمقاولات",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: null,
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "Rawan M. Alsoghayer",
    ProjectOwner1: "ناصر عبدالعزيز القديري Nasser A. AlQudairi",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "20424.00",
    SpentYearBudget: "20424.000000",
  },
  {
    ProjectUID: "b11a1a04-a646-4b95-8e44-ebcbe8f2754e",
    ProjectName: "تأسيس وتشغيل حاضنات الانتاج في الإقليم الغربي و الجنوبي",
    Department: "إدارة تطوير البرامج والمنتجات",
    ProjectCode: "BU-22-058",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    ProjectDescription:
      "تأسيس وتشغيل حاضنات الانتاج في الإقليم الغربي و الجنوبي\r\n\r\n",
    ProjectStartDate: "2022-10-16T00:00:00",
    ProjectFinishDate: "2023-10-16T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "9780980.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "مرتبطة بطرح مشروع تأسيس حاضنات الإنتاج في الإقليم الشمالي - سيتم تجويد نطاق العمل بناء على العروض الفنية المقدمة",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "74c0763b-b3e0-4ebc-8739-ec529926c66b",
    ProjectName: "برنامج انفاذ منتجات الأسر المنتجة للأسواق",
    Department: "إدارة تطوير البرامج والمنتجات",
    ProjectCode: "BU-22-049",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "شيرين صالح العبدالرحمن ShereenS alabdulrahman",
    ProjectDescription: "برنامج انفاذ منتجات الأسر المنتجة للأسواق\r\n\r\n",
    ProjectStartDate: "2022-08-07T00:00:00",
    ProjectFinishDate: "2023-08-07T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "8357739.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متوقع التأخير/ملاحظة مهمة",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada: "جاري الطرح - إدارة المشتريات في الوزارة",
    pmo_efada: "من مشاريع التحول الوطني",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "ed5a235c-03ca-41ea-b135-ef1f13bfe467",
    ProjectName: "تحول فروع البنك (جادة 30) المرحلة الرابعة",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-23-001",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: null,
    ProjectManager: "خالد عبدالله محمد علي Khaled A. Ali",
    ProjectDescription: "تحول فروع البنك (جادة 30) المرحلة الرابعة",
    ProjectStartDate: "2023-03-01T00:00:00",
    ProjectFinishDate: "2023-03-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: null,
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: null,
    NotAligned: null,
    AlignedComments: null,
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: " ",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "a16cf312-2060-4110-a465-f14f88b5d736",
    ProjectName: "التدريب الحرفي والمهني",
    Department: "إدارة تطوير البرامج والمنتجات",
    ProjectCode: "BU-22-054",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "رشا عبدالعزيز محمد برخيل Rasha A. Albarkheel",
    ProjectDescription: "التدريب الحرفي والمهني \r\n\r\n",
    ProjectStartDate: "2022-06-26T00:00:00",
    ProjectFinishDate: "2023-06-26T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "20000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "متأخر",
    ContractStatus: "التقييم الفني",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "تركي عبدالمحسن المنيف Turki A Almunaif",
    ProjectOwner1: "ناصر رخيص العنزي Nasser R Alanzi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم تقييم العروض الفنية وارسالها الى مكتب الرؤية لاستكمال اجراءات الترسية",
    pmo_efada: "من مشاريع التحول الوطني",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "a5b9537a-e1ba-4eff-91f5-f17612f552a5",
    ProjectName: "محرك التصنيف الائتماني",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-19-002",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "ABDULAZIZ SAUD ALHARBI",
    ProjectDescription: "محرك التصنيف الائتماني",
    ProjectStartDate: "2019-03-30T00:00:00",
    ProjectFinishDate: "2020-10-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "aabbdbc4-3ba0-482c-850f-f2aa6558b6b4",
    ProjectName: "التعاون مع وزارة الدفاع",
    Department: "إدارة الإدخار",
    ProjectCode: "BU-22-046",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "فارس حمد محمد بن جميعة Faris H. Bin Jumayah",
    ProjectDescription: "التعاون مع وزارة الدفاع ",
    ProjectStartDate: "2022-11-01T00:00:00",
    ProjectFinishDate: "2023-05-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1300000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Khalid S. Alsoke",
    ProjectOwner1: "فيصل بركات عبدالله باوزير faisal b. Bawazeer",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1300000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "e6040c2f-9108-46d3-bf17-f426a8de7588",
    ProjectName: "حوكمة البيانات وتأسيس مكتب ذكاء الاعمال المالي",
    Department: "إدارة التقارير والميزانية",
    ProjectCode: "FI-22-006",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "عادل عبدالله الدحيم Adel A. Alduhaim",
    ProjectDescription:
      "1- إنشاء مكتبة للبيانات الموجودة في جميع الأنظمة بالبنك.\r\n2- إنشاء دليل حوكمة للبيانات.",
    ProjectStartDate: "2022-08-15T00:00:00",
    ProjectFinishDate: "2023-08-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "2500000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "التخطيط",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "سلطان عبدالعزيز عبدالله الحنيشل sultan a. alhunishel",
    ProjectOwner1: "عادل عبدالله الدحيم Adel A. Alduhaim",
    ProjectOfficerContact: " ",
    sector_efada: "جاري العمل على كراسة الشروط والمواصفات ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "2500000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "da6a17ce-f3eb-4a88-8c92-f538ebe6fe80",
    ProjectName: "تشغيل وصيانة مركز الاتصال الموحد",
    Department: "إدارة تميز العمليات",
    ProjectCode: "SS-20-010",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "خالد صالح الشرهان Khaled S Alsharhan",
    ProjectDescription: "تشغيل وصيانة مركز الاتصال الموحد",
    ProjectStartDate: "2020-12-28T00:00:00",
    ProjectFinishDate: "2023-12-28T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "PR20/024",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "15906071.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "6714824.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "التكامل التقني",
    AwardedCompany: "شركة العرض المتقن للخدمات التجارية",
    ProjectPhase: "التنفيذ",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج التحول الرقمي والمؤسسي",
    ProjectProgress: "0",
    BudgetCategory: "تشغيلية",
    BankProjectTypes: "تشغيلي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "fahad M. alghamdi",
    ProjectOwner1: "عبداللطيف محمد عرفه ABDULATEEF M ARAFA",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "6318129.00",
    SpentYearBudget: "2178897.000000",
  },
  {
    ProjectUID: "a46d281e-e4e5-46f9-bf52-f5bec7ff7c4b",
    ProjectName: "تأهيل منطقة خدمة العملاء في بريده",
    Department: "إدارة الفروع والقنوات",
    ProjectCode: "BU-22-135",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عبدالعزيز رافع عثمان الشهري abdulaziz r. alshehri",
    ProjectDescription: "تأهيل منطقة خدمة العملاء في بريده",
    ProjectStartDate: "2022-07-31T00:00:00",
    ProjectFinishDate: "2022-08-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "157000.000000",
    ContractValue: "21578.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (3)",
    ProjectCategory: "شبكة الفروع والمباني والتوريد",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "العقد",
    ProjectSector: "قطاع الاعمال",
    Program: null,
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "بناء القدرات الداخلية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "علي هادي علي مسملي Ali H. Msmali",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "b8e5489c-b135-42e8-92ab-f6b638bc64d3",
    ProjectName: "برنامج تطوير وأتمتة الإجراءات بحسب ISO 20000",
    Department: "إدارة تقنية المعلومات",
    ProjectCode: "SS-19-001",
    ProjectOwner: "ابراهيم عبدالله إبراهيم العمر Ibrahim A Alomar",
    boardinitiative: "لا",
    ProjectManager: "Hassan F. Algarni",
    ProjectDescription: "برنامج تطوير وأتمتة الإجراءات بحسب ISO 20000 ",
    ProjectStartDate: "2019-01-01T00:00:00",
    ProjectFinishDate: "2019-12-31T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الخدمات المشتركة",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تعزيز الاستقلال المالي",
    PortfoilioName: "قطاع الخدمات المشتركة",
    ProgramManager: "نوره محمد أبونيان Noura M. Abunayyan",
    ProjectOwner1: "يزيد عبدالعزيز بن حمود Yazeed Bin Homoud",
    ProjectOfficerContact: " ",
    sector_efada: "",
    pmo_efada: "في حاجة لاستكمال البيانات الأساسية للمشروع",
    cat_efada: "",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "0c7ce0ca-164b-4e60-ae22-f91b37a00586",
    ProjectName: "تطوير التقارير والتنبؤات المالية",
    Department: "إدارة التقارير والميزانية",
    ProjectCode: "FI-22-005",
    ProjectOwner: "ماجد محمد الدخيل Maged M. Aldakheel",
    boardinitiative: "لا",
    ProjectManager: "تركي خالد الجبرين TURKI K. ALJEBREEN",
    ProjectDescription:
      "انشاء قاعدة بيانات لتوفير التقارير المالية للبنك واعداد النماذج المالية الخاصة بالتحليلات المالية المستقبلية\r\n",
    ProjectStartDate: "2022-11-15T00:00:00",
    ProjectFinishDate: "2023-03-15T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: null,
    ApprovedBudget: "1000000.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "Tier (2)",
    ProjectCategory: "اختر",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "حسب المخطط",
    ContractStatus: "إعداد الطرح",
    ProjectSector: "قطاع المالية",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع المالية",
    ProgramManager: "فهد تركي محمد السديري fahad alsudairy",
    ProjectOwner1: "عادل عبدالله الدحيم Adel A. Alduhaim",
    ProjectOfficerContact: " ",
    sector_efada: "جاري العمل على كراسة الشروط والمواصفات ",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "1000000.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "a886c990-14c5-46a1-ae1a-fbed6b54f36b",
    ProjectName: "تسويق المنتجات للمنشآت",
    Department: "إدارة التسويق والعلاقات العامة",
    ProjectCode: "BU-22-013",
    ProjectOwner: "معيض ناصر البيشي Meaid N Albishi",
    boardinitiative: "لا",
    ProjectManager: "مؤيد عبدالرحمن هندي Moayad A. Hende",
    ProjectDescription: " تسويق المنتجات للمنشآت",
    ProjectStartDate: "2022-12-01T00:00:00",
    ProjectFinishDate: "2024-12-01T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: "0",
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "نفقات التسويق والمواد الإعلامية ",
    EstimatedBudget: null,
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "خارجي",
    Priority: "لا ينطبق",
    ProjectCategory: "الإستضافات",
    AwardedCompany: "",
    ProjectPhase: "البدء",
    ProjectStatus: "ملغي",
    ContractStatus: "ملغي",
    ProjectSector: "قطاع الاستراتيجية والابتكار",
    Program:
      "برنامج تعزيز التمويل والخدمات غير المالية للمنشآت الصغيرة والناشئة",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاستراتيجية والابتكار",
    ProgramManager: " ",
    ProjectOwner1: "بندر سعيد الغامدي Bandar S. Alghamdi",
    ProjectOfficerContact: " ",
    sector_efada:
      "تم دمج المشروع تحت مشروع ابتكار وصناعة أدوات تسويقه لمنتجات وخدمات البنك المالية والغير ماليه - الرمز ST-22-028",
    pmo_efada: "",
    cat_efada: null,
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
  {
    ProjectUID: "4f733f59-0e37-487f-8271-fcd15bcedb86",
    ProjectName: "منتج نقاط البيع",
    Department: "إدارة المحافظ والتطوير",
    ProjectCode: "BU-19-001",
    ProjectOwner: "سلطان عبدالعزيز الحميدي Sultan A Alhamidi",
    boardinitiative: "لا",
    ProjectManager: "عزت فيصل العنقري Ezzat F AlAngari",
    ProjectDescription: "منتج نقاط البيع",
    ProjectStartDate: "2019-09-30T00:00:00",
    ProjectFinishDate: "2020-09-30T00:00:00",
    BIProjectStartDate: null,
    BIProjectFinishDate: null,
    PlannedCompletePercent: null,
    ActualCompletePercent: 0,
    BudgetItemNo: "",
    BudgetItemName: "",
    EstimatedBudget: "0.000000",
    ApprovedBudget: "0.000000",
    ContractValue: "0.000000",
    RevisedContractValue: "0.000000",
    PaidAmount: "0.00",
    RemainingAmount: "0.000000",
    ProjectType: "داخلي",
    Priority: "Tier (2)",
    ProjectCategory: "المنتجات",
    AwardedCompany: "",
    ProjectPhase: "الإغلاق",
    ProjectStatus: "تم الاطلاق(مكتمل)",
    ContractStatus: "الداخلي",
    ProjectSector: "قطاع الاعمال",
    Program: "برنامج رفع كفاءة التمويل الاجتماعي وتشجيع الادخار",
    ProjectProgress: "0",
    BudgetCategory: "الرأس مالية",
    BankProjectTypes: "إستراتيجي",
    IsAligned: "لا ينطبق",
    NotAligned: "التواريخ",
    AlignedComments: "",
    PlannedResourceHours: 0,
    ActualResourceHours: 0,
    StrategicObjectives: "تمكين الحماية الاجتماعية",
    PortfoilioName: "قطاع الاعمال",
    ProgramManager: "Ibrahim A. Alabdusallam",
    ProjectOwner1: "فهد علي الاشقر Fahad A. Alashgar",
    ProjectOfficerContact: "وليد سليمان النزهه Waleed S. Alnozha",
    sector_efada: "المنتج في مرحلة التشغيل",
    pmo_efada: "في انتظار الإفادة بمستهدفات المنتج",
    cat_efada: "المنتجات",
    YearBudget: "0.00",
    SpentYearBudget: "0.000000",
  },
];
